<template>
  <div v-if="preloader === true">
    <template>
      <v-dialog v-model="preloader" hide-overlay persistent width="300">
        <v-progress-linear indeterminate></v-progress-linear>
      </v-dialog>
    </template>
  </div>
  <div v-else>
    <v-card
      height="64px"
      width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="
        position: fixed;
        z-index: 200;
        top: 0;
        width: 98%;
        padding-top: 16px;
      "
    >
    <v-card-title class="ml-0 pl-0">
        <p class="breadcrumb-text">Question Bank</p>
        <span><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span>
      </v-card-title>
      <UserNavMenu />
    </v-card>
    <v-container fluid class="px-0 py-0 qpad">
      <v-dialog v-model="uploadingDialog" max-width="366px" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center d-flex flex-column align-center">
              <v-icon
                v-if="uploadingMsg != 'File Uploading...'"
                color="success"
                size="96"
                >mdi-check-circle-outline</v-icon
              >
              <p class="text-h5 py-4">{{ uploadingMsg }}</p>
              <v-progress-circular
                :size="50"
                color="blue"
                indeterminate
                v-if="uploadingMsg == 'File Uploading...'"
              ></v-progress-circular>
              <v-btn
                class="btn primary-btn"
                large
                width="157px"
                rounded
                @click="uploadingDialog = false"
                v-if="uploadingMsg != 'File Uploading...'"
                >Ok</v-btn
              >
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>

      <v-row v-if="createQuestionDialog" class="px-0 abc">
        <v-col cols="12" sm="12" md="12">
          <div class="background pl-8 pr-4" elevation="0">
            <div>
              <v-card-title class="px-0">
                <div
                  elevation="0"
                  class="background w-100 d-flex justify-space-between"
                >
                  <v-toolbar-title class="text-h5 px-0"
                    >{{ formbtn() }} Question</v-toolbar-title
                  >
                </div>
              </v-card-title>
            </div>
            <v-card
              id="myScroll"
              style="height: calc(100vh - 166px); overflow-x: hidden; display: flex; flex-direction: column;"
            >
              <v-form ref="form" v-model="isFormValid" style="flex: 1; overflow-y: auto; overflow-x: hidden;">
                <v-card-text>
                  <v-card class="ma-4 pa-4" elevation="0">
                    <!-- Select Question Type   -->
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          v-model="questionType"
                          :items="questionTypeList"
                          outlined
                          class="rounded-xl"
                          :rules="[(v) => !!v || 'Please select question type']"
                          required
                          attach
                          @change="onQuestionTypeChange"
                        >
                          <template v-slot:label>
                            Question Type<span class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <template v-if="questionType && questionType !== 'PASSAGE_BASED'">
                    <v-row>
                      <v-col class="py-0">
                        <v-row
                          align="center"
                          class="d-flex flex-row justify-space-between"
                        >
                          <v-col class="pt-0 pb-0">
                            <div class="text-body-1 my-2">
                              Question Description
                              <span class="required">*</span>
                            </div>
                          </v-col>
                          <v-col class="pa-0">
                            <v-btn
                              class="btn outline-btn float-right my-2"
                              v-if="questionAssetUrl == 'NA'"
                              ><v-icon>mdi-attachment</v-icon>
                              <span>Upload Audio/Video/Image</span>
                              <input
                                type="file"
                                name="image"
                                @change="onChange"
                                accept="image/*, audio/*, video/*"
                              />
                            </v-btn>
                            <span>
                              <v-chip
                                text
                                class="float-right my-2"
                                v-if="mainImage && questionAssetUrl !== 'NA'"
                                @click:close="closeChip"
                                @click="openImagePreviewDialog"
                                close
                                >View Attachment</v-chip
                              >
                            </span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <ckeditor
                          :config="editorConfig"
                          v-model="questionName"
                          class="m-ckeditor"
                          :rules="[(v) => !!v || 'Question is required']"
                          required
                          @ready="onEditorReady"
                        >
                        </ckeditor>
                        <div
                          v-if="isBlankPlaceholderMissing"
                          class="error--text text-caption mt-2"
                        >
                          {{ blankPlaceholderError }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :items="markingTypesListItems"
                          v-model="markingType"
                          outlined
                          item-text="name"
                          item-value="name"
                          item-disabled="disabled"
                          class="rounded-xl"
                          @change="handleMarkingTypeChange"
                          :rules="[(v) => !!v || 'Marking Type is required']"
                          required
                          attach
                        >
                          <template v-slot:label>
                            Marking Type<span class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0" cols="6">
                        <div class="text-body-1 my-2"></div>
                        <v-text-field
                          @keypress="preventNonNumericInput"
                          :disabled="
                            markingType?.toLowerCase() !== 'regular marking'
                          "
                          :min="0"
                          type="number"
                          outlined
                          class="rounded-xl"
                          v-model="correctAnswerScore"
                          required
                        >
                          <template v-slot:label>
                            Correct Answer Score<span class="required"> *</span>
                          </template>
                          
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <!-- Fields below only visible after marking type is selected -->
                    <template v-if="markingType">

                    <!-- Single Select Answers -->
                    <v-row v-if="questionType == 'SINGLE_CHOICE'">
                      <v-col>
                        <div class="text-body-1 mb-2">
                          Options <span class="required">*</span>
                          <span class="font-italic grey--text"
                            >(Supported image types: .jpeg/.jpg, .png, .bmp 2;
                            Max size - 5MB)
                          </span>
                        </div>
                        <v-radio-group
                          v-model="singleSelectCorrectAnswer"
                          :rules="[(v) => !!v || 'Please select one']"
                        >
                          <div
                            v-for="(option, index) in options"
                            :key="index"
                            class="d-flex align-center my-2"
                          >
                            <v-list-item
                              :class="
                                singleSelectCorrectAnswer == option.optionKey
                                  ? 'lightGreen rounded-xl'
                                  : 'grey lighten-4 rounded-xl'
                              "
                              min-height="72"
                              class="flex-grow-1"
                            >
                              <v-list-item-avatar>
                                <v-radio :value="option.optionKey"></v-radio>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-subtitle
                                  v-if="
                                    option.optionValue.startsWith('https://') ||
                                    option.optionValue.startsWith('http://') ||
                                    option.optionValue.startsWith('blob:')
                                  "
                                >
                                  <span class="d-flex align-start"
                                    ><img
                                      @loadstart="resolveQuestionOptionUrl"
                                      :src="option.optionValue"
                                      alt=""
                                      width="auto"
                                      height="150"
                                      class="img"
                                    />
                                    <v-btn icon class="ml-1"
                                      ><v-icon @click="restorePrevValue(index)"
                                        >mdi-close</v-icon
                                      ></v-btn
                                    ></span
                                  >
                                </v-list-item-subtitle>
                                <v-list-item-title v-else class="align-center">
                                  <div v-html="option.optionValue"></div>
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-row align="center" class="overflow-hidden">
                                  <v-btn
                                    class="options-btn"
                                    v-if="
                                      !option.optionValue.startsWith('https://') ||
                                      !option.optionValue.startsWith('http://') ||
                                      !option.optionValue.startsWith('blob:')
                                    "
                                    icon
                                    @click="editOption(index)"
                                  >
                                    <v-icon class="options-icon" large>mdi-format-textbox</v-icon>
                                  </v-btn>
                                  <v-btn
                                    class="px-0 options-btn"
                                    text
                                    color="blue"
                                    @click="editedOptionIndex = index"
                                    v-on:click="uploadingForOption = true"
                                  >
                                    <input
                                      class="options-attach-img"
                                      type="file"
                                      name="image"
                                      accept="image/*"
                                      @change="onChange"
                                      v-on:click="uploadingForOption = true"
                                    />
                                    <img :width="24" :src="uploadImageIcon" />
                                  </v-btn>
                                </v-row>
                              </v-list-item-action>
                            </v-list-item>
                            <div class="d-flex align-center ml-3">
                              <div v-if="markingType === 'Likert Marking'" class="d-flex flex-column likert-score-wrapper mr-2">
                                <span class="likert-score-label">Option Score <span class="required">*</span></span>
                                <div class="likert-score-control">
                                  <span class="likert-score-value">{{ option.optionScore || 0 }}</span>
                                  <div class="d-flex flex-column likert-score-arrows">
                                    <v-btn icon x-small :disabled="(option.optionScore || 0) >= 10" @click="incrementOptionScore(index)">
                                      <v-icon x-small>mdi-chevron-up</v-icon>
                                    </v-btn>
                                    <v-btn icon x-small :disabled="(option.optionScore || 0) === 0" @click="decrementOptionScore(index)">
                                      <v-icon x-small>mdi-chevron-down</v-icon>
                                    </v-btn>
                                  </div>
                                </div>
                              </div>
                              <v-btn icon @click="removeOption(index)">
                                <img :width="24" :height="24" :src="deleteOptionIcon" alt="Delete option" />
                              </v-btn>
                            </div>
                          </div>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <!-- Multi Select Answers -->
                    <v-row v-else-if="questionType == 'MULTIPLE_CHOICE'">
                      <v-col cols="12" sm="12" md="12" class="overflow-hidden">
                        <div class="text-body-1 mb-2">
                          Options <span class="required">*</span>
                          <span class="font-italic grey--text"
                            >(Guidelines for image in options: 1. File type -
                            .jpeg/.jpg, .png, .bmp 2. File size - 5MB)
                          </span>
                        </div>

                        <div
                          v-for="(option, index) in options"
                          :key="index"
                          class="d-flex align-center my-2"
                        >
                          <v-list-item
                            :class="
                              selectedAnswersForMultitpleTypeQuestions.includes(option.optionKey)
                                ? 'lightGreen rounded-xl'
                                : 'grey lighten-4 rounded-xl'
                            "
                            min-height="72"
                            class="flex-grow-1"
                          >
                            <v-list-item-avatar>
                              <v-checkbox
                                v-model="selectedAnswersForMultitpleTypeQuestions"
                                :value="option.optionKey"
                              ></v-checkbox>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-subtitle
                                v-if="
                                  option.optionValue.startsWith('https://') ||
                                  option.optionValue.startsWith('http://') ||
                                  option.optionValue.startsWith('blob:')
                                "
                              >
                                <span class="d-flex align-start"
                                  ><img
                                    @loadstart="resolveQuestionOptionUrl"
                                    :src="option.optionValue"
                                    alt=""
                                    width="auto"
                                    height="150"
                                    class="img"
                                  />
                                  <v-btn icon class="ml-1"
                                    ><v-icon @click="restorePrevValue(index)"
                                      >mdi-close</v-icon
                                    ></v-btn
                                  ></span
                                >
                              </v-list-item-subtitle>
                              <v-list-item-title v-else class="align-center">
                                <div v-html="option.optionValue"></div>
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-row align="center">
                                <v-btn
                                  v-if="
                                    !option.optionValue.startsWith('https://') ||
                                    !option.optionValue.startsWith('http://') ||
                                    !option.optionValue.startsWith('blob:')
                                  "
                                  icon
                                  @click="editOption(index)"
                                >
                                  <v-icon large class="pa-2 options-icon">mdi-format-textbox</v-icon>
                                </v-btn>
                                <v-btn
                                  class="px-0"
                                  text
                                  color="blue"
                                  @click="editedOptionIndex = index"
                                  v-on:click="uploadingForOption = true"
                                >
                                  <input
                                    class="options-attach-img"
                                    type="file"
                                    name="image"
                                    accept="image/*"
                                    @change="onChange"
                                    v-on:click="uploadingForOption = true"
                                  />
                                  <img :width="24" :src="uploadImageIcon" />
                                </v-btn>
                              </v-row>
                            </v-list-item-action>
                          </v-list-item>
                          <div class="d-flex align-center ml-3">
                            <div v-if="markingType === 'Likert Marking'" class="d-flex flex-column likert-score-wrapper mr-2">
                              <span class="likert-score-label">Option Score <span class="required">*</span></span>
                              <div class="likert-score-control">
                                <span class="likert-score-value">{{ option.optionScore || 0 }}</span>
                                <div class="d-flex flex-column likert-score-arrows">
                                  <v-btn icon x-small :disabled="(option.optionScore || 0) >= 10" @click="incrementOptionScore(index)">
                                    <v-icon x-small>mdi-chevron-up</v-icon>
                                  </v-btn>
                                  <v-btn icon x-small :disabled="(option.optionScore || 0) === 0" @click="decrementOptionScore(index)">
                                    <v-icon x-small>mdi-chevron-down</v-icon>
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                            <v-btn icon @click="removeOption(index)">
                              <img :width="24" :height="24" :src="deleteOptionIcon" alt="Delete option" />
                            </v-btn>
                          </div>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="
                        questionType == 'SINGLE_CHOICE' ||
                        questionType == 'MULTIPLE_CHOICE'
                      "
                      justify="start"
                      align="center"
                      class="px-2 blue--text"
                      @click="addOption"
                    >
                      <v-icon :disabled="options.length > 4" large
                        >mdi-plus-circle-outline</v-icon
                      >
                      <v-btn
                        :disabled="options.length > 4"
                        class="pl-0"
                        text
                        x-large
                        color="blue"
                        >Add Options</v-btn
                      >
                    </v-row>
                    <v-row v-if="questionType == 'FILL_IN_THE_BLANKS'">
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-textarea
                          :rules="[
                            (v) => !!v || 'Correct Answer field is required',
                          ]"
                          required
                          outlined
                          class="rounded-xl"
                          label="Correct Answer"
                          v-model="correctAnswer"
                        >
                        <template v-slot:label>
                            Correct Answer<span class="required"> *</span>
                        </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <!-- True False -->
                    <v-row v-if="questionType == 'TRUE_FALSE'">
                      <v-col>
                        <div class="text-body-1 mb-2">Options*</div>
                        <v-radio-group
                          v-model="trueFalseCorrectAnswer"
                          :rules="[(v) => !!v || 'Please select one']"
                        >
                          <v-list-item
                            :class="
                              trueFalseCorrectAnswer == option.optionKey
                                ? 'lightGreen rounded-xl my-2'
                                : 'grey lighten-4  rounded-xl my-2'
                            "
                            min-height="72"
                            v-for="(option, index) in [
                              { optionKey: 'A', optionValue: 'TRUE' },
                              { optionKey: 'B', optionValue: 'FALSE' },
                            ]"
                            :key="index"
                          >
                            <v-list-item-avatar>
                              <v-radio :value="option.optionKey"></v-radio>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title>{{
                                option.optionValue
                              }}</v-list-item-title>
                            </v-list-item-content>
                            <!-- <v-list-item-action>
                          <v-row align="center">
                            <v-btn icon>
                              <v-icon>mdi-dots-vertical </v-icon>
                            </v-btn>
                          </v-row>
                        </v-list-item-action> -->
                          </v-list-item>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <!-- Match the Following -->
                    <div
                      class="text-body-1 my-4"
                      v-if="questionType == 'MATCH_THE_FOLLOWING'"
                    >
                      Options <span class="required">*</span>
                      <span class="font-italic grey--text"
                        >(Guidelines for image in options: 1. File type -
                        .jpeg/.jpg, .png, .bmp 2. File size - 5MB)
                      </span>
                    </div>
                    <v-row v-if="questionType == 'MATCH_THE_FOLLOWING'">
                      <v-col cols="6" sm="12" md="6" class="overflow-hidden">
                        <div class="text-body-1 mb-2">Match the Items*</div>
                        <v-list-item
                          :class="
                            selectedLhsForMtfTypeQuestions.includes(
                              option.optionKey,
                            )
                              ? 'lightGreen rounded-xl my-2'
                              : 'grey lighten-4 rounded-xl my-2'
                          "
                          min-height="72"
                          v-for="(option, index) in options"
                          :key="index"
                        >
                          <v-list-item-avatar>
                            <v-text-field
                              v-model="selectedLhsForMtfTypeQuestions[index]"
                              :value="option.optionKey"
                              outlined
                              dense
                              hide-details
                              clearable
                              v-show="false"
                            ></v-text-field>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-subtitle
                              v-if="
                                option.optionValue.startsWith('https://') ||
                                option.optionValue.startsWith('http://') ||
                                option.optionValue.startsWith('blob:')
                              "
                            >
                              <span class="d-flex align-start"
                                ><img
                                  @loadstart="resolveQuestionOptionUrl"
                                  :src="option.optionValue"
                                  alt=""
                                  width="auto"
                                  height="150"
                                  class="img"
                                />
                                <v-btn icon class="ml-1"
                                  ><v-icon @click="restorePrevValue(index)"
                                    >mdi-close</v-icon
                                  ></v-btn
                                ></span
                              >
                            </v-list-item-subtitle>

                            <v-list-item-title v-else class="align-center">
                              <div v-html="option.optionValue"></div>
                            </v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-row align="center">
                              <v-btn
                                v-if="
                                  !option.optionValue.startsWith('https://') ||
                                  !option.optionValue.startsWith('http://') ||
                                  !option.optionValue.startsWith('blob:')
                                "
                                icon
                                @click="editOption(index)"
                              >
                                <v-icon large class="pa-2"
                                  >mdi-format-textbox
                                </v-icon>
                              </v-btn>
                              <v-btn
                                class="px-0"
                                text
                                color="blue"
                                @click="editedOptionIndex = index"
                                v-on:click="uploadingForOption = true"
                              >
                                <img :width="24" :src="uploadImageIcon" />
                              </v-btn>
                              <v-btn icon @click="removeOption(index)">
                                <img :width="24" :height="24" :src="deleteOptionIcon" alt="Delete option" />
                              </v-btn>
                            </v-row>
                          </v-list-item-action>
                        </v-list-item>
                      </v-col>
                      <v-col cols="6" sm="12" md="6" class="overflow-hidden">
                        <div class="text-body-1 mb-2">Correct Answers*</div>

                        <v-list-item
                          :class="
                            selectedRhsForMtfTypeQuestions.includes(
                              ans.optionKey,
                            )
                              ? 'lightGreen rounded-xl my-2'
                              : 'grey lighten-4 rounded-xl my-2'
                          "
                          min-height="72"
                          v-for="(ans, index) in answers"
                          :key="index"
                        >
                          <v-list-item-avatar>
                            <v-text-field
                              v-model="selectedRhsForMtfTypeQuestions[index]"
                              :value="ans.optionKey"
                              outlined
                              dense
                              hide-details
                              clearable
                              v-show="false"
                            ></v-text-field>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-subtitle
                              v-if="
                                ans.optionValue.startsWith('https://') ||
                                ans.optionValue.startsWith('http://') ||
                                ans.optionValue.startsWith('blob:')
                              "
                            >
                              <span class="d-flex align-start"
                                ><img
                                  @loadstart="resolveQuestionOptionUrl"
                                  :src="ans.optionValue"
                                  alt=""
                                  width="auto"
                                  height="150"
                                  class="img"
                                />
                                <v-btn icon class="ml-1"
                                  ><v-icon @click="restorePrevValue(index)"
                                    >mdi-close</v-icon
                                  ></v-btn
                                ></span
                              >
                            </v-list-item-subtitle>

                            <v-list-item-title v-else class="align-center">
                              <div v-html="ans.optionValue"></div>
                            </v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-row align="center">
                              <v-btn
                                v-if="
                                  !ans.optionValue.startsWith('https://') ||
                                  !ans.optionValue.startsWith('http://') ||
                                  !ans.optionValue.startsWith('blob:')
                                "
                                icon
                                @click="editAnswer(index)"
                              >
                                <v-icon large class="pa-2"
                                  >mdi-format-textbox
                                </v-icon>
                              </v-btn>
                              <v-btn
                                class="px-0"
                                text
                                color="blue"
                                @click="editedAnswerIndex = index"
                                v-on:click="uploadingForOption = true"
                              >
                                <img :width="24" :src="uploadImageIcon" />
                              </v-btn>
                              <v-btn icon @click="removeOption(index)">
                                <img :width="24" :height="24" :src="deleteOptionIcon" alt="Delete option" />
                              </v-btn>
                            </v-row>
                          </v-list-item-action>
                        </v-list-item>
                      </v-col>
                    </v-row>
                    <!-- Fill in the blanks -->
                    <v-row v-if="questionType == 'Fill in the blanks'">
                      <v-col class="py-0">
                        <div class="text-body-1 my-2">Answer*</div>
                        <v-textarea
                          outlined
                          class="rounded-xl"
                          label="Enter Answer"
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-textarea
                          required
                          outlined
                          class="rounded-xl"
                          label="Answer Explaination"
                          v-model="answerExplanation"
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-textarea
                          outlined
                          class="rounded-xl textarea"
                          label="Answer Hint"
                          required
                          v-model="hint"
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>

                    </template>
                    </template>
                    <template v-else-if="questionType === 'PASSAGE_BASED'">
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2">Passage<span class="required"> *</span></div>
                        <ckeditor
                          :config="getFreshPassageEditorConfig()"
                          v-model="questionStatement"
                          class="m-ckeditor"
                          :rules="[(v) => !!v && !!getTextWithoutHTMLTags(v).trim() || 'Passage is required']"
                          required
                        ></ckeditor>
                        <div v-if="isPassageTooLong"
                          class="error--text text-caption mt-2"
                        >
                          {{  `Passage exceeds the ${passageMaxWords}-word limit. Please reduce the word count.` }}
                        </div>
                      </v-col>
                    </v-row>
                    </template>
                  </v-card>
                  <v-card v-if="markingType" class="ma-4 pa-4" elevation="0">
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          v-model="product"
                          :items="productOptions"
                          outlined
                          class="rounded-xl"
                          required
                          :rules="[
                            (v) => !!v || 'Please select an application',
                          ]"
                          attach
                        >
                          <template v-slot:label>
                            Application<span class="required"> *</span>
                          </template></v-autocomplete
                        >
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          label="Skill*"
                          :items="skills"
                          v-model="skill"
                          outlined
                          item-text="name"
                          item-value="name"
                          class="rounded-xl"
                          :rules="[(v) => !!v || 'Please select skill']"
                          required
                          @change="checkSubjects(skill)"
                          attach
                        >
                          <template v-slot:label>
                            Skill<span class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :disabled="currentSkill?.isSetNumberNotApplicable"
                          :items="setNumbersList"
                          outlined
                          class="rounded-xl"
                          v-model="setNumber"
                          :required="!currentSkill?.isSetNumberNotApplicable"
                          :rules="!currentSkill?.isSetNumberNotApplicable ? [(v) => !!v || 'Please select set number'] : []"
                          attach
                        >
                          <template v-slot:label>
                            <span v-if="!currentSkill?.isSetNumberNotApplicable">Set Number<span class="required"> *</span></span>
                            <span v-else>Set Number</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <!--<v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-text-field
                          v-model="questionid"
                          label="Question ID*"
                          outlined
                          class="rounded-xl"
                          required
                          :rules="questionIdRules"
                          :error-messages="questionIdError"
                          @input="validateQuestionId"
                        ></v-text-field>
                      </v-col> -->
                    </v-row>

                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :disabled="currentSkill?.subjects?.length === 0"
                          label="Subject"
                          clearable
                          deletable-chips
                          multiple
                          :items="subjects"
                          outlined
                          class="rounded-xl"
                          v-model="subject"
                          item-text="name"
                          item-value="name"
                          :search-input.sync="searchSubjects"
                          attach
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :items="levels"
                          @change="getGradesMappedToLevel"
                          outlined
                          class="rounded-xl"
                          required
                          :rules="[(v) => !!v || 'Please select NEP Level']"
                          v-model="level"
                          item-text="name"
                          item-value="name"
                          attach
                        >
                          <template v-slot:label>
                            NEP Level<span class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :disabled="currentSkill?.isGradeNotApplicable"
                          :items="grade !== 'NA' ? gradesMappedToLevel : ['NA']"
                          outlined
                          class="rounded-xl"
                          :required="!currentSkill?.isGradeNotApplicable"
                          v-model="grade"
                          item-text="name"
                          item-value="name"
                          attach
                          :rules="!currentSkill?.isGradeNotApplicable ? [(v) => !!v || 'Please select grade'] : []"
                        >
                          <template v-slot:label>
                            Grade<span v-if="!currentSkill?.isGradeNotApplicable" class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-text-field
                          outlined
                          class="rounded-xl"
                          value="00"
                          label="Strand"
                          type="text"
                          v-model="strand"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          outlined
                          class="rounded-xl"
                          value="00"
                          label="Sub Strand"
                          type="text"
                          v-model="subStrand"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          outlined
                          class="rounded-xl"
                          value="00"
                          label="Topic"
                          type="text"
                          v-model="topic"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <v-autocomplete
                          v-model="selectedLOs"
                          clearable
                          deletable-chips
                          label="Select or Search LO's"
                          outlined
                          class="rounded-xl"
                          height="50px"
                          chips
                          :search-input.sync="searchLOs"
                          :items="LOData"
                          multiple
                          item-text="name"
                          item-value="io_code"
                          attach
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <v-autocomplete
                          v-model="selectedHrisRoles"
                          label="HRIS Unique Role"
                          :items="hrisUniqueRole"
                          outlined
                          class="rounded-xl"
                          attach
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          v-model="languageOfQuestion"
                          label="Language"
                          :items="languageOptions"
                          outlined
                          class="rounded-xl"
                          required
                          attach
                        ></v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          label="Case Sensitive"
                          :items="['Yes', 'No']"
                          outlined
                          class="rounded-xl"
                          required
                          v-model="isCaseSensitive"
                          attach
                        ></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          label="Bloom's Taxonomy Level"
                          :items="bloomsTaxonomyLevel"
                          outlined
                          class="rounded-xl"
                          v-model="bloomsTaxonomy"
                          required
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :items="
                            difficultyLevel !== 'NA' ? difficultyLevels : ['NA']
                          "
                          outlined
                          class="rounded-xl"
                          :rules="[
                            (v) => !!v || 'Please select Difficulty Level',
                          ]"
                          required
                          v-model="difficultyLevel"

                        >
                          <template v-slot:label>
                            Difficulty Level<span class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col class="py-0" cols="6" sm="6" md="6">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          label="Complexity Level"
                          :items="complexityLevels"
                          outlined
                          class="rounded-xl"
                          v-model="complexityLevel"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete

                          label="Proficiency Level"
                          :items="['A1', 'A2', 'B1', 'B2', 'C1', 'C2']"
                          outlined
                          class="rounded-xl"
                          v-model="proficiencyLevel"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          label="Authored By"
                          :items="authoredByOptions"
                          outlined
                          class="rounded-xl"
                          required
                          v-model="authoredBy"
                          item-text="name"
                          item-value="value"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          label="Group Name*"
                          :items="groupNames"
                          outlined
                          class="rounded-xl"
                          required
                          v-model="groupName"
                          :rules="[(v) => !!v || 'Please select Group Name']"
                        >
                          <template v-slot:label>
                            Group<span class="required"> *</span>
                          </template></v-autocomplete
                        >
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete label="Knowledge Level*" :items="knowledgeLevels" outlined class="rounded-xl"
                          v-model="knowledgeLevel" attach>
                        </v-autocomplete>
                      </v-col> -->
                    </v-row>

                    <v-row>
                      <!-- <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete label="Type of audience" :items="typeOfAudienceOptions" outlined class="rounded-xl" required
                          v-model="typeOfAudience" item-text="name" item-value="name" attach>
                        </v-autocomplete>
                      </v-col> -->
                    </v-row>
                  </v-card>
                  <v-card v-if="questionType === 'PASSAGE_BASED'" class="ma-4 pa-4" elevation="0">
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          v-model="product"
                          :items="productOptions"
                          outlined
                          class="rounded-xl"
                          required
                          :rules="[(v) => !!v || 'Please select an application']"
                          attach
                        >
                          <template v-slot:label>
                            Application<span class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :items="skills"
                          v-model="skill"
                          outlined
                          item-text="name"
                          item-value="name"
                          class="rounded-xl"
                          :rules="[(v) => !!v || 'Please select skill']"
                          required
                          @change="checkSubjects(skill)"
                          attach
                        >
                          <template v-slot:label>
                            Skill<span class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :disabled="currentSkill?.isSetNumberNotApplicable"
                          :items="setNumbersList"
                          outlined
                          class="rounded-xl"
                          v-model="setNumber"
                          :required="!currentSkill?.isSetNumberNotApplicable"
                          :rules="!currentSkill?.isSetNumberNotApplicable ? [(v) => !!v || 'Please select set number'] : []"
                          attach
                        >
                          <template v-slot:label>
                            <span v-if="!currentSkill?.isSetNumberNotApplicable">Set Number<span class="required"> *</span></span>
                            <span v-else>Set Number</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :items="levels"
                          @change="getGradesMappedToLevel"
                          outlined
                          class="rounded-xl"
                          required
                          :rules="[(v) => !!v || 'Please select NEP Level']"
                          v-model="level"
                          item-text="name"
                          item-value="name"
                          attach
                        >
                          <template v-slot:label>
                            NEP Level<span class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :disabled="currentSkill?.isGradeNotApplicable"
                          :items="grade !== 'NA' ? gradesMappedToLevel : ['NA']"
                          outlined
                          class="rounded-xl"
                          :required="!currentSkill?.isGradeNotApplicable"
                          v-model="grade"
                          item-text="name"
                          item-value="name"
                          attach
                          :rules="!currentSkill?.isGradeNotApplicable ? [(v) => !!v || 'Please select grade'] : []"
                        >
                          <template v-slot:label>
                            Grade<span v-if="!currentSkill?.isGradeNotApplicable" class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :disabled="currentSkill?.subjects?.length === 0"
                          label="Subject"
                          clearable
                          deletable-chips
                          multiple
                          :items="subjects"
                          outlined
                          class="rounded-xl"
                          v-model="subject"
                          item-text="name"
                          item-value="name"
                          :search-input.sync="searchSubjects"
                          attach
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          v-model="selectedHrisRoles"
                          label="HRIS Unique Role"
                          :items="hrisUniqueRole"
                          outlined
                          class="rounded-xl"
                          attach
                        ></v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          v-model="languageOfQuestion"
                          label="Language"
                          :items="languageOptions"
                          outlined
                          class="rounded-xl"
                          attach
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          label="Authored By"
                          :items="authoredByOptions"
                          outlined
                          class="rounded-xl"
                          v-model="authoredBy"
                          item-text="name"
                          item-value="value"
                          attach
                        ></v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :items="groupNames"
                          outlined
                          class="rounded-xl"
                          required
                          v-model="groupName"
                          :rules="[(v) => !!v || 'Please select Group Name']"
                          attach
                        >
                          <template v-slot:label>
                            Group<span class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          v-model="passageCustomer"
                          :items="customerOptions"
                          label="Customer"
                          outlined
                          class="rounded-xl"
                          attach
                        ></v-autocomplete>
                      </v-col>
                      <v-col class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-autocomplete
                          :items="difficultyLevel !== 'NA' ? difficultyLevels : ['NA']"
                          outlined
                          class="rounded-xl"
                          :rules="[(v) => !!v || 'Please select Difficulty Level']"
                          required
                          v-model="difficultyLevel"
                          attach
                        >
                          <template v-slot:label>
                            Difficulty Level<span class="required"> *</span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row class="mb-2 mt-0">
                      <v-col class="py-0">
                        <p class=" grey--text text-body-2">
                          Note - The above passage details will be applied to all associated sub-questions.
                        </p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6" class="py-0">
                        <div class="text-body-1 my-2"></div>
                        <v-text-field
                          v-model.number="numberOfQuestions"
                          type="number"
                          min="1"
                          max="5"
                          outlined
                          class="rounded-xl"
                          :rules="[(v) => (!!v && v >= 1 && v <= 5) || 'Number of Questions must be between 1 and 5']"
                          required
                        >
                          <template v-slot:label>
                            Number of Questions<span class="required"> *</span>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card v-if="questionType === 'PASSAGE_BASED'" class="ma-4 pa-4" elevation="0">
                    <div class="d-flex align-center justify-space-between mb-4">
                      <div class="text-h6">Questions</div>
                      <div class="d-flex align-center">
                        <v-btn
                          class="btn outline-btn mr-3"
                          :disabled="!passageSubQuestions.length || passageSubQuestionPanels.length === passageSubQuestions.length"
                          @click="togglePassageSubQuestionPanels(true)"
                        >
                          Expand All
                        </v-btn>
                        <v-btn
                          class="btn outline-btn"
                          :disabled="!passageSubQuestionPanels.length"
                          @click="togglePassageSubQuestionPanels(false)"
                        >
                          Collapse All
                        </v-btn>
                      </div>
                    </div>

                    <v-expansion-panels v-model="passageSubQuestionPanels" flat multiple class="mt-2">
                      <v-expansion-panel v-for="(subQuestion, index) in passageSubQuestions" :key="index" class="mb-4 expansion-panel-card">
                        <v-expansion-panel-header class="expansion-panel-card-header">Question {{ index + 1 }}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row class="pt-8">
                            <v-col class="py-0">
                              <v-autocomplete
                                v-model="subQuestion.questionType"
                                :items="subQuestionTypeList"
                                outlined
                                class="rounded-xl"
                                :rules="[(v) => !!v || 'Please select question type']"
                                @change="onSubQuestionTypeChange(subQuestion)"
                                attach
                              >
                                <template v-slot:label>
                                  Question Type<span class="required"> *</span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col class="py-0">
                              <div class="text-body-1 my-2">Question Statement</div>
                              <ckeditor
                                :config="getFreshPassageEditorConfig()"
                                v-model="subQuestion.questionDescription"
                              ></ckeditor>
                              <div
                                v-if="isBlankMissing(subQuestion.questionType, subQuestion.questionDescription)"
                                class="error--text text-caption mt-2"
                              >
                                {{ blankPlaceholderError }}
                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="mt-8">
                            <v-col cols="6" class="py-0">
                              <v-autocomplete
                                v-model="subQuestion.markingType"
                                :items="getSubQuestionMarkingTypes(subQuestion)"
                                outlined
                                item-text="name"
                                item-value="name"
                                item-disabled="disabled"
                                class="rounded-xl"
                                :rules="[(v) => !!v || 'Marking Type is required']"
                                attach
                              >
                                <template v-slot:label>
                                  Marking Type<span class="required"> *</span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="6" class="py-0">
                              <v-text-field
                                v-model="subQuestion.correctAnswerScore"
                                type="number"
                                :min="0"
                                outlined
                                class="rounded-xl"
                                :rules="[(v) => (v !== null && v !== '') || 'Correct Answer Score is required']"
                              >
                                <template v-slot:label>
                                  Correct Answer Score<span class="required"> *</span>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <!-- Fields below only visible after marking type is selected, mirroring the main form -->
                          <template v-if="subQuestion.markingType">
                            <PassageSubQuestionAnswer
                              v-model="subQuestion.answerPayload"
                              :questionType="subQuestion.questionType"
                              :markingType="subQuestion.markingType"
                              :loData="LOData"
                            />
                          </template>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>
                </v-card-text>
              </v-form>
              <v-divider></v-divider>
              <v-card-actions class="px-4 py-3 d-flex justify-end">
                <v-btn
                  class="btn outline-btn font-weight-medium mx-3 elevation-0"
                  rounded
                  @click="createQuestionDialog = false"
                  >Cancel</v-btn
                >
                <template v-if="$store.state.role.questionBank.create">
                  <v-progress-circular
                    v-if="isCreatingQuestion"
                    indeterminate
                    color="blue"
                  ></v-progress-circular>
                  <v-btn
                    v-else
                    rounded
                    class="mx-3 btn primary-btn"
                    :disabled="(!formbtnBool && !isCreateFormReady) || (formbtnBool && !isQuestionFormDirty) || isBlankPlaceholderMissing || isPassageTooLong"
                    @click="!formbtnBool ? createQuestion() : openUpdateCommentDialog()"
                  >
                    <v-icon></v-icon>{{ formbtn() }}
                  </v-btn>
                </template>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
      </v-row>

      <div class="pr-4 pl-8" v-else>
        <v-row class="mt-6 justify-space-between">
          <v-col cols="3">
            <div class="text-h6">Question Bank</div>
          </v-col>
          <v-col cols="9" class="mt-0 mb-6">
            <v-row justify="end" class="flex-nowrap">
              <v-text-field
                solo
                label="Search here..."
                prepend-inner-icon="mdi-magnify"
                hide-details
                v-model="search"
                class="search-bar border-button rounded-pill mx-3"
                dense
                clearable
              ></v-text-field>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
                    :class="filterCount > 0 ? 'outline-disabled-btn' : ''"
                    rounded
                    depressed
                    v-bind="attrs"
                    v-on="on"
                    :disabled="filterCount > 0"
                  >
                    <v-img
                      v-bind="attrs"
                      v-on="on"
                      :style="
                        filterCount > 0
                          ? 'filter: grayscale(100%) opacity(50%);'
                          : ''
                      "
                      :src="require(`@/assets/svg/sort.svg`)"
                    />
                    <span>Sort</span>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="option in sortOptions"
                    :key="option.value"
                    @click="selectSortOption(option.value)"
                    :class="{
                      'selected-sort-option': selectedSort === option.value,
                    }"
                  >
                    <v-list-item-title>
                      {{ option.label }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                @click="filterDialog = true"
                depressed
                rounded
                outlined
                class="btn outline-btn mx-3 pl-4 pr-6"
                ><v-icon class="pr-2">mdi-tune</v-icon>
                <span v-if="filterCount > 0">Filter ({{ filterCount }})</span>
                <span v-else>Filter</span></v-btn
              >

              <v-btn
                depressed
                rounded
                outlined
                class="btn mx-3 pl-4 pr-6"
                @click="deleteDialog = true"
                :class="
                  !$store.state.role.questionBank.delete &&
                  selectedTableItems.length == 0
                    ? 'outline-disabled-btn'
                    : 'outline-btn'
                "
                :disabled="
                  !$store.state.role.questionBank.delete ||
                  selectedTableItems.length == 0
                "
                ><v-icon class="pr-2">mdi-trash-can-outline</v-icon
                >Delete</v-btn
              >
              <v-btn
                @click="downloadQuestions"
                :loading="loadingQuestionsToDownload"
                depressed
                outlined
                rounded
                class="btn outline-btn mx-3"
                ><v-icon>mdi-import mdi-rotate-90</v-icon></v-btn
              >

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    
                    class="btn tertiary-btn mx-3 pl-4 pr-6"
                    @click="clearValue"
                    rounded
                    depressed
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon class="pr-2">mdi-plus</v-icon> Create Question
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="createQuestionDialog = true">
                    <v-list-item-title>
                      <v-icon>mdi-book-open-variant </v-icon> CREATE NEW
                      QUESTION
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-title>
                      <v-icon>mdi-file-document-multiple </v-icon>
                      <input type="file" @change="handleFileUpload" />

                      CREATE NEW QUESTIONS IN BULK
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-title @click="downloadFile" class="cursor">
                      <v-icon>mdi-book-open-variant </v-icon>
                      DOWNLOAD SAMPLE FILE
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <!-- Notification Dialog -->
              <v-dialog
                v-model="notificationDialog"
                class="cdz"
                max-width="380px"
              >
                <Notification @close-dialog="notificationDialog = false" />
              </v-dialog>

              <v-dialog
                v-model="deleteDialog"
                class="cdz"
                max-width="366px"
                persistent
              >
                <v-card fluid>
                  <v-container fluid class="pa-0">
                    <v-card-text class="text-center">
                      <v-avatar color="background" size="90"
                        ><v-icon size="65"
                          >mdi-trash-can-outline</v-icon
                        ></v-avatar
                      >
                      <p class="text-h5 pt-4 pb-0">Delete Question</p>
                      <p
                        class="text-disabled grey--text text-subtitle-1 mb-4"
                        color="rgba(0, 0, 0, 0.6)"
                        disabled
                      >
                        This action will permanently delete the item . This
                        cannot be undone
                      </p>

                      <div class="d-flex justify-space-between" fluid>
                        <v-btn
                          depressed
                          class="btn outline-btn font-weight-medium"
                          width="157px"
                          rounded
                          @click="
                            () => {
                              deleteDialog = false;
                              formbtnBool = false;
                            }
                          "
                          >CANCEL</v-btn
                        >
                        <v-btn
                          class="btn primary-btn"
                          depressed
                          outlined
                          width="157px"
                          rounded
                          :disabled="selectedTableItems.length == 0"
                          :loading="dLoading"
                          @click="deleteData(selectedTableItems)"
                          >DELETE</v-btn
                        >
                      </div>
                    </v-card-text>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-row>
          </v-col>
        </v-row>
        <v-data-table :loading="isLoading" v-model="selectedTableItems" :headers="headers" height="calc(100vh - 230px)"
          fixed-header :items="newFilteredQuestions" show-select :single-select="singleSelect" item-key="id"
          :items-per-page="dataTableOptions.itemsPerPage" :options.sync="dataTableOptions" :server-items-length="newQuestionCount" hide-default-footer ref="myTable" :class=" isScrollable ? 'frozen-columns-table' : ''">
          <template v-slot:loading>
            <bubble-loader />
          </template>
          <template v-slot:no-data>
            <div class="custom-no-data">
              <p>No Data Available</p>
            </div>
          </template>
          <template v-slot:header.actions>
            <v-row class="text-center custom-header">
              <v-col class="header-cell">
                <span class="custom-header-text">Action</span>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.questionId`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div class="single-line-ellipsis" v-bind="attrs" v-on="on">
                  {{ item.questionId }}
                </div>
              </template>
              <span>{{ item.questionId }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.questionStatement`]="{ item }">
            <v-tooltip bottom max-width="40vw">
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="single-line-ellipsis"
                  v-html="formatQuestionStatementForDisplay(item.questionStatement)"
                  v-bind="attrs"
                  v-on="on"
                ></div>
              </template>
              <span v-html="formatQuestionStatementForDisplay(item.questionStatement)"></span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.questionType`]="{ item }">
            {{ formatQuestionType(item.questionType) }}
          </template>
          <template v-slot:[`item.difficultyLevel`]="{ item }">
            {{ formatQuestionType(item.difficultyLevel) }}
          </template>
          <template v-slot:[`item.MyLo`]="{}">
            <span
              ><v-chip>{{ dummyLO[0].name }}</v-chip></span
            >
            <span v-if="dummyLO.length > 1"
              ><v-chip>+{{ dummyLO.length - 1 }}</v-chip></span
            >
          </template>
          <template v-slot:[`item.createdOn`]="{ item }">
            {{ getDate(item.createdOn) }}
          </template>
          <!-- <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <img width="36px" height="36px" @click="updateData(item)" class="cursor" src="../assets/edit.svg" />
              <img width="36px" height="36px" @click="previewQuestion(item)" class="cursor ml-2" src="../assets/preview_1.svg" />
            </div>
          </template> -->

          <template v-slot:item.actions="{ item, index }">
            <div class="d-flex justify-center">
              <v-menu left bottom offset-x offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="content-black-badge"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="updateData(item)">
                    <v-list-item-title>Edit Question</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="previewQuestion(item)">
                    <v-list-item-title>View Question</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="viewExamMode(item)">
                    <v-list-item-title>View Exam Mode</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="viewHistory(item)">
                    <v-list-item-title>View History</v-list-item-title>
                  </v-list-item>
                  
                </v-list>
              </v-menu>
            </div>
          </template>
          <template v-slot:footer="{ props }">
            <table-footer
              :pagination="props.pagination"
              :options="props.options"
              @update-options="onFooterUpdate"
            />
          </template>
        </v-data-table>

        <!-- Create Question Dialog Form -->

        <!-- Filter Dialog -->

        <v-dialog v-model="filterDialog" class="cdz" max-width="570px">
          <v-card width="570px" height="100vh" class="filterDialogClass">
            <v-row class="mt-4 mx-1">
              <v-col>
                <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
                  Filter
                </div>
              </v-col>
              <v-col class="d-flex justify-end">
                <div @click="clearFilter" class="clear-filter-btn">
                  CLEAR FILTER
                </div>
              </v-col>
            </v-row>

            <v-tabs vertical>
              <div class="ml-3 mt-4 mr-4 filterLine">
                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Question Type</span>
                  <span
                    v-if="selectedQuestionTypeFilter.length > 0"
                    class="ml-1"
                    >({{ selectedQuestionTypeFilter.length }})</span
                  ></v-tab
                >

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Level</span>
                  <span v-if="selectedLevelFilter.length > 0" class="ml-1"
                    >({{ selectedLevelFilter.length }})</span
                  ></v-tab
                >

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Grade</span>
                  <span v-if="selectedGradeFilter.length > 0" class="ml-1"
                    >({{ selectedGradeFilter.length }})</span
                  ></v-tab
                >
                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Difficulty Level</span>
                  <span
                    v-if="selecteddifficultyLevelFilter.length > 0"
                    class="ml-1"
                    >({{ selecteddifficultyLevelFilter.length }})</span
                  ></v-tab
                >

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Complexity Level</span>
                  <span
                    v-if="selectedcomplexityLevelFilter.length > 0"
                    class="ml-1"
                    >({{ selectedcomplexityLevelFilter.length }})</span
                  ></v-tab
                >

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Knowledge Level</span>
                  <span
                    v-if="selectedknowlewdgeLevelFilter.length > 0"
                    class="ml-1"
                    >({{ selectedknowlewdgeLevelFilter.length }})</span
                  ></v-tab
                >

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Blooms Taxonomy Level</span>
                  <span
                    v-if="selectedbloomsTaxonomyLevelFilter.length > 0"
                    class="ml-1"
                    >({{ selectedbloomsTaxonomyLevelFilter.length }})</span
                  ></v-tab
                >

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Skills</span>
                  <span v-if="selectedskillsFilter.length > 0" class="ml-1"
                    >({{ selectedskillsFilter.length }})</span
                  ></v-tab
                >

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Subjects</span>
                  <span v-if="selectedsubjectsFilter.length > 0" class="ml-1"
                    >({{ selectedsubjectsFilter.length }})</span
                  ></v-tab
                >

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Reported Questions</span>
                  <span v-if="selectedReportedQuestionsFilter" class="ml-1"
                    >(1)</span
                  ></v-tab
                >

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Attachments</span>
                  <span
                    v-if="selectedQuestionAssetUrlFilter.length > 0"
                    class="ml-1"
                    >({{ selectedQuestionAssetUrlFilter.length }})</span
                  >
                </v-tab>

                <v-tab
                  class="black--text justify-start"
                  active-class="activeTab"
                >
                  <span>Has Equation</span>
                  <span v-if="hasEquationFilter.length > 0" class="ml-1"
                    >({{ hasEquationFilter.length }})</span
                  >
                </v-tab>
              </div>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group
                      v-model="selectedQuestionTypeFilter"
                      active-class="active-chip"
                      column
                      :multiple="true"
                    >
                      <v-chip
                        v-for="(questionType, index) in filterQuestionTypeList"
                        :key="index"
                        :value="questionType"
                        elevated
                      >
                        {{ questionType }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group
                      v-model="selectedLevelFilter"
                      active-class="active-chip"
                      column
                      :multiple="true"
                    >
                      <v-chip
                        v-for="(level, index) in filterLevels"
                        :key="index"
                        :value="level"
                        elevated
                      >
                        {{ level }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card
                    v-if="selectedLevelFilter.length > 0"
                    class="school-filter"
                  >
                    <v-card-text>
                      <v-chip-group
                        v-model="selectedGradeFilter"
                        active-class="active-chip"
                        column
                        :multiple="true"
                      >
                        <v-chip
                          v-for="(grade, index) in filterGrades"
                          :key="index"
                          :value="grade"
                          elevated
                        >
                          {{ grade }}
                        </v-chip>
                      </v-chip-group>
                    </v-card-text>
                  </v-card>
                  <v-card
                    elevation="0"
                    v-if="selectedLevelFilter.length == 0"
                    class="school-filter"
                  >
                    <v-card-text class="d-flex justify-center">
                      Please Select Level First
                    </v-card-text>
                  </v-card>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group
                      v-model="selecteddifficultyLevelFilter"
                      active-class="active-chip"
                      column
                      :multiple="true"
                    >
                      <v-chip
                        v-for="(
                          difficultyLevel, index
                        ) in filterDifficultyLevels"
                        :key="index"
                        :value="difficultyLevel"
                        elevated
                      >
                        {{ difficultyLevel }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group
                      v-model="selectedcomplexityLevelFilter"
                      active-class="active-chip"
                      column
                      :multiple="true"
                    >
                      <v-chip
                        v-for="(
                          complexityLevel, index
                        ) in filterComplexityLevels"
                        :key="index"
                        :value="complexityLevel"
                        elevated
                      >
                        {{ complexityLevel }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group
                      v-model="selectedknowlewdgeLevelFilter"
                      active-class="active-chip"
                      column
                      :multiple="true"
                    >
                      <v-chip
                        v-for="(
                          knowlewdgeLevel, index
                        ) in filterKnowledgeLevels"
                        :key="index"
                        :value="knowlewdgeLevel"
                        elevated
                      >
                        {{ knowlewdgeLevel }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group
                      v-model="selectedbloomsTaxonomyLevelFilter"
                      active-class="active-chip"
                      column
                      :multiple="true"
                    >
                      <v-chip
                        v-for="(
                          bloomsTaxonomyLevel, index
                        ) in filterBloomsTaxonomyLevel"
                        :key="index"
                        :value="bloomsTaxonomyLevel"
                        elevated
                      >
                        {{ bloomsTaxonomyLevel }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group
                      v-model="selectedskillsFilter"
                      active-class="active-chip"
                      column
                      :multiple="true"
                    >
                      <v-chip
                        v-for="(skill, index) in filterSkills"
                        :key="index"
                        :value="skill"
                        elevated
                      >
                        {{ skill }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <!-- <v-card width="380px" class="elevation-0 transparent">
                    <v-text-field
                      solo
                      label="Search here..."
                      hide-details
                      prepend-inner-icon="mdi-magnify"
                      v-model="subjectSearch"
                      class="search-bar2 border-button rounded-pill mx-2"
                      dense
                      clearable
                    ></v-text-field>
                  </v-card>
                  <v-card-text>
                    <v-chip-group v-model="selectedsubjectsFilter" active-class="active-chip" column :multiple="true">
                      <v-chip v-for="(subject, index) in getFilterableSubjects" :key="index" :value="subject" elevated>
                        {{ subject }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text> -->
                  <FilterSearch
                    :items="filterSubjects"
                    v-model="selectedsubjectsFilter"
                    search-label="Search Subjects..."
                  />
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group
                      v-model="selectedReportedQuestionsFilter"
                      active-class="active-chip"
                      column
                      :multiple="false"
                    >
                      <v-chip
                        v-for="(question, index) in reportedQuestions"
                        :key="index"
                        :value="question.value"
                        elevated
                      >
                        {{ question.label }}
                      </v-chip>
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            elevated
                            active-class="active-chip"
                          >
                            Custom Dates
                          </v-chip>
                        </template>
                        <v-card>
                          <v-card-title>Select Dates</v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col>
                                <v-menu
                                  ref="menu"
                                  v-model="menuStart"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      class="custom-date-picker"
                                      v-bind="attrs"
                                      v-on="on"
                                      label="Start Date"
                                      prepend-icon="mdi-calendar"
                                      v-model="customStartDate"
                                      readonly
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="customStartDate"
                                    @input="menuStart = false"
                                    class="custom-date-picker"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col>
                                <v-menu
                                  ref="menu"
                                  v-model="menuEnd"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      class="custom-date-picker"
                                      v-bind="attrs"
                                      v-on="on"
                                      label="End Date"
                                      prepend-icon="mdi-calendar"
                                      v-model="customEndDate"
                                      readonly
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="customEndDate"
                                    @input="menuEnd = false"
                                    class="custom-date-picker"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              class="btn primary-btn"
                              @click="addCustomDates"
                              >Ok</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-chip-group
                      v-model="selectedQuestionAssetUrlFilter"
                      active-class="active-chip"
                      column
                      :multiple="true"
                    >
                      <v-chip
                        v-for="(type, index) in mediaTypes"
                        :key="index"
                        :value="type.value"
                        elevated
                      >
                        <v-icon left>{{ type.icon }}</v-icon>
                        {{ type.label }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat height="580px" id="myScroll">
                  <v-card-text>
                    <v-chip-group
                      v-model="hasEquationFilter"
                      active-class="active-chip"
                      :multiple="true"
                      column
                    >
                      <v-chip
                        v-for="(type, index) in equationTypes"
                        :key="index"
                        :value="type.value"
                        elevated
                      >
                        <v-icon left>{{ type.icon }}</v-icon>
                        {{ type.label }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                  <v-card-text
                    class="d-flex justify-center py-0"
                    v-if="
                      selectedLevelFilter.length === 0 &&
                      selectedsubjectsFilter.length === 0
                    "
                  >
                    Please Select Level or Subject First for refined search
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>

            <div class="filterDialogButton">
              <v-card-actions class="px-6 pb-3">
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  depressed
                  class="btn outline-btn font-weight-medium pa-4"
                  @click="filterDialog = false"
                  >Cancel</v-btn
                >
                <v-btn
                  rounded
                  class="btn primary-btn pa-4"
                  @click="
                    (filterDialog = false),
                      filterQuestions(
                        selectedQuestionTypeFilter,
                        selectedLevelFilter,
                        selectedGradeFilter,
                        selecteddifficultyLevelFilter,
                        selectedcomplexityLevelFilter,
                        selectedknowlewdgeLevelFilter,
                        selectedbloomsTaxonomyLevelFilter,
                        selectedskillsFilter,
                        selectedsubjectsFilter,
                        selectedReportedQuestionsFilter,
                      ),
                      getFilterCount()
                  "
                  >Apply</v-btn
                >
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="filterDialog" max-width="400px">
        <v-card width="400px" height="100%">
          <v-card-text class="pa-6">
            <v-row>
              <v-col>
                <div class="pl-1 text-body1 font-weight-bold">FILTER</div>
              </v-col>
              <v-spacer></v-spacer>
              <v-col>
                <div
                  class="text-body1 font-weight-bold black--text cursor"
                  @click="clearFilter"
                >
                  CLEAR FILTER
                </div>
              </v-col>
            </v-row>
            <div>
              <v-card
                height="450px"
                elevation="0"
                id="myScroll"
                class="pt-5 ,pb-5"
              >
                <v-row class="pl-1">
                  <v-col>
                    <div class="text-body1 font-weight-normal black--text">
                      Question Type
                    </div>
                  </v-col>
                </v-row>
                <v-chip-group
                  v-model="selectedQuestionTypeFilter"
                  active-class="btn-color white--text"
                  column
                  :multiple="true"
                >
                  <v-chip
                    v-for="(questionType, index) in questionTypeList"
                    :key="index"
                    :value="questionType"
                    elevated
                  >
                    {{ questionType }}
                  </v-chip>
                </v-chip-group>

                  <v-row class="pl-1">
                    <v-col>
                      <div
                        class="text-body1 font-weight-normal black--text pt-3"
                      >
                        Level
                      </div>
                    </v-col>
                  </v-row>
                  <v-chip-group
                    v-model="selectedLevelFilter"
                    active-class="btn-color white--text"
                    column
                    :multiple="true"
                  >
                    <v-chip
                      v-for="(level, index) in levels"
                      :key="index"
                      :value="level.name"
                      elevated
                    >
                      {{ level.name }}
                    </v-chip>
                  </v-chip-group>

                  <v-row class="pl-1">
                    <v-col>
                      <div
                        class="text-body1 font-weight-normal black--text pt-3"
                      >
                        Difficulty Level
                      </div>
                    </v-col>
                  </v-row>
                  <v-chip-group
                    v-model="selecteddifficultyLevelFilter"
                    active-class="btn-color white--text"
                    column
                    :multiple="true"
                  >
                    <v-chip
                      v-for="(difficultyLevel, index) in difficultyLevels"
                      :key="index"
                      :value="difficultyLevel"
                      elevated
                    >
                      {{ difficultyLevel }}
                    </v-chip>
                  </v-chip-group>

                  <v-row class="pl-1">
                    <v-col>
                      <div
                        class="text-body1 font-weight-normal black--text pt-3"
                      >
                        Complexity Level
                      </div>
                    </v-col>
                  </v-row>
                  <v-chip-group
                    v-model="selectedcomplexityLevelFilter"
                    active-class="btn-color white--text"
                    column
                    :multiple="true"
                  >
                    <v-chip
                      v-for="(complexityLevel, index) in complexityLevels"
                      :key="index"
                      :value="complexityLevel"
                      elevated
                    >
                      {{ complexityLevel }}
                    </v-chip>
                  </v-chip-group>

                  <v-row class="pl-1">
                    <v-col>
                      <div
                        class="text-body1 font-weight-normal black--text pt-3"
                      >
                        Knowlewdge Level
                      </div>
                    </v-col>
                  </v-row>
                  <v-chip-group
                    v-model="selectedknowlewdgeLevelFilter"
                    active-class="btn-color white--text"
                    column
                    :multiple="true"
                  >
                    <v-chip
                      v-for="(knowlewdgeLevel, index) in knowledgeLevels"
                      :key="index"
                      :value="knowlewdgeLevel"
                      elevated
                    >
                      {{ knowlewdgeLevel }}
                    </v-chip>
                  </v-chip-group>

                  <v-row class="pl-1">
                    <v-col>
                      <div
                        class="text-body1 font-weight-normal black--text pt-3"
                      >
                        Blooms Taxonomy Level
                      </div>
                    </v-col>
                  </v-row>
                  <v-chip-group
                    v-model="selectedbloomsTaxonomyLevelFilter"
                    active-class="btn-color white--text"
                    column
                    :multiple="true"
                  >
                    <v-chip
                      v-for="(
                        bloomsTaxonomyLevel, index
                      ) in bloomsTaxonomyLevel"
                      :key="index"
                      :value="bloomsTaxonomyLevel"
                      elevated
                    >
                      {{ bloomsTaxonomyLevel }}
                    </v-chip>
                  </v-chip-group>

                  <v-row class="pl-1">
                    <v-col>
                      <div
                        class="text-body1 font-weight-normal black--text pt-3"
                      >
                        Skills
                      </div>
                    </v-col>
                  </v-row>
                  <v-chip-group
                    v-model="selectedskillsFilter"
                    active-class="btn-color white--text"
                    column
                    :multiple="true"
                  >
                    <v-chip
                      v-for="(skill, index) in skills"
                      :key="index"
                      :value="skill.name"
                      elevated
                    >
                      {{ skill.name }}
                    </v-chip>
                  </v-chip-group>

                <v-row class="pl-1">
                  <v-col>
                    <div class="text-body1 font-weight-normal black--text pt-3">
                      Subjects
                    </div>
                  </v-col>
                </v-row>
                <v-chip-group
                  v-model="selectedsubjectsFilter"
                  active-class="btn-color white--text"
                  column
                  :multiple="true"
                >
                  <v-chip
                    v-for="(subject, index) in subjects"
                    :key="index"
                    :value="subject.name"
                    elevated
                  >
                    {{ subject.name }}
                  </v-chip>
                </v-chip-group>
              </v-card>
              <div>
                <v-card-actions class="px-6 pb-6">
                  <v-spacer></v-spacer>
                  <v-btn
                    rounded
                    outlined
                    class="pa-4"
                    @click="filterDialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    rounded
                    class="accent pa-4"
                    @click="
                      filterQuestions(
                        selectedQuestionTypeFilter,
                        selectedLevelFilter,
                        selecteddifficultyLevelFilter,
                        selectedcomplexityLevelFilter,
                        selectedknowlewdgeLevelFilter,
                        selectedbloomsTaxonomyLevelFilter,
                        selectedskillsFilter,
                        selectedsubjectsFilter
                      )
                    "
                    >Apply</v-btn
                  >
                </v-card-actions>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog> -->
        <!-- Success Dialog -->
        <v-dialog
          v-model="successDialog"
          class="cdz"
          max-width="366px"
          persistent
        >
          <v-card>
            <v-container fluid class="pa-8">
              <v-card-text class="text-center d-flex flex-column align-center">
                <v-icon color="#228B22" size="96"
                  >mdi-check-circle-outline</v-icon
                >
                <p class="text-h5 font-weight-bold py-4">
                  {{ successMessage }}
                </p>
                <v-btn
                  class="btn primary-btn"
                  large
                  width="157px"
                  rounded
                  @click="successDialog = false"
                  >Ok</v-btn
                >
              </v-card-text>
            </v-container>
          </v-card>
        </v-dialog>
      </div>
      <!-- Error Dialog -->
      <!-- Update Comment Dialog -->
      <v-dialog v-model="updateCommentDialog" max-width="665px" persistent>
        <v-card class="pa-4">
          <v-card-title class="text-h6 pb-2">Comment</v-card-title>
          <v-card-text class="pb-2">
            <ckeditor
              :config="editorConfigForComment"
              v-model="updateComment"
              class="m-ckeditor"
            ></ckeditor>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer></v-spacer>
            <v-btn rounded outlined class="btn outline-btn" @click="updateCommentDialog = false; updateComment = ''">Cancel</v-btn>
            <v-btn rounded class="btn primary-btn ml-3" :disabled="!updateComment.replace(/<[^>]*>/g, '').trim()" @click="submitUpdate()">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="errorDialog" class="cdz" max-width="366px" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center d-flex flex-column align-center">
              <img src="../assets/warning_1.svg" width="96" height="96" alt="warning" />
              <p class="text-h6 py-3 font-weight-regular">{{ errorMessage }}</p>
              <v-btn
                class="btn primary-btn"
                large
                width="157px"
                rounded
                @click="errorDialog = false"
                >Re-Upload</v-btn
              >
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="deleteSuccessDialog"
        class="cdz"
        max-width="366px"
        persistent
      >
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center d-flex flex-column align-center">
              <v-icon color="#228B22" size="96"
                >mdi-check-circle-outline</v-icon
              >
              <p class="text-h5 font-weight-bold py-4">Question Deleted</p>
              <v-btn
                class="btn primary-btn"
                large
                width="157px"
                rounded
                @click="deleteSuccessDialog = false"
                >Ok</v-btn
              >
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Edit Option Dialog -->
      <v-dialog max-width="887px" v-model="optionTextFieldDialog" center>
        <v-card>
          <v-card-title class="gray-02 mb-8">Edit Option</v-card-title>
          <v-card-text>
            <!-- <v-text-field
            outlined
            class="rounded-xl"
            v-model="editedOption.value"
            label="Enter Option*"
          ></v-text-field> -->
            <ckeditor
              :config="editorConfigForOption"
              v-model="editedCkeditorValue"
              class="m-ckeditor"
              @ready="onEditorReady"
            ></ckeditor>
            <p v-if="!isValid" class="error-message red--text">
              Please enter a valid value (maximum 200 characters).
            </p>
          </v-card-text>
          <v-card-actions class="px-6 pb-6">
            <v-spacer></v-spacer>
            <v-btn
              depressed
              rounded
              class="btn outline-btn font-weight-medium pa-4"
              @click="optionTextFieldDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              depressed
              rounded
              @click="saveEditedValue"
              class="btn primary-btn pa-4"
              :disabled="!isValid"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Edit Answer Dialog -->
      <v-dialog max-width="887px" v-model="answerTextFieldDialog" center>
        <v-card>
          <v-card-title class="gray-02 mb-8">Edit Option</v-card-title>
          <v-card-text>
            <!-- <v-text-field
            outlined
            class="rounded-xl"
            v-model="editedOption.value"
            label="Enter Option*"
          ></v-text-field> -->
            <ckeditor
              :config="editorConfigForOption"
              v-model="editedCkeditorValue"
              class="m-ckeditor"
              @ready="onEditorReady"
            ></ckeditor>
            <p v-if="!isValid" class="error-message red--text">
              Please enter a valid value (maximum 200 characters).
            </p>
          </v-card-text>
          <v-card-actions class="px-6 pb-6">
            <v-spacer></v-spacer>
            <v-btn
              depressed
              rounded
              class="btn outline-btn font-weight-medium pa-4"
              @click="answerTextFieldDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              depressed
              rounded
              @click="saveEditedAnswer"
              class="btn primary-btn pa-4"
              :disabled="!isValid"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Edit Option Score Dialog -->
      <v-dialog
        max-width="438px"
        class="options-score-dialog"
        v-model="optionScoreDialog"
      >
        <v-card class="d-flex flex-column pa-3 gap-4">
          <div class="font-weight-bold h6">Score</div>
          <v-text-field
            v-model="optionScoreInput"
            type="number"
            outlined
            min="0"
            class="rounded-xl"
            placeholder="Enter Option Score here"
            label="Option Score*"
            required
            :max="markingType === 'Likert Marking' ? 10 : undefined"
            :rules="
              markingType === 'Likert Marking'
                ? [(v) => !!v || 'Option Score is required', (v) => v <= 10 || 'Option Score cannot exceed 10']
                : []
            "
          >
          </v-text-field>
          <div class="d-flex justify-end w-100 gap-4">
            <v-btn
              class="btn outline-btn elevation-0"
              @click="closeOptionScoreDialog"
            >
              Cancel
            </v-btn>
            <v-btn class="btn primary-btn" @click="saveOptionScore">
              Save
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <!-- Uploading Bulk Questions Dialog-->
      <v-dialog
        max-width="600px"
        max-height="80vh"
        v-model="uploadingQuestionsDialog"
        center
      >
        <v-card class="pa-4">
          <v-row>
            <v-col cols="6" md="6">
              <v-card-title class="pa-0 ma-0">
                Uploading... {{ bulkQuestionUploadResponse.length }} /
                {{ bulkQuestionJsonData.length }}
              </v-card-title>
            </v-col>
            <v-col cols="6" md="6">
              <v-btn
                class="float-right"
                icon
                @click="closeUploadingQuestionsDialog"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-col>
          </v-row>
          <v-data-table
            :headers="headersresponce"
            :items="bulkQuestionUploadResponse"
            :items-per-page="-1"
          >
            <template v-slot:[`item.status`]="{ item }">
              <div class="d-flex flex-row ml-2">
                {{ item.status }}

                <v-icon
                  v-if="item.status.includes('Uploaded Successfully!')"
                  color="green"
                  >mdi-check-all</v-icon
                >
                <v-icon v-else color="red">mdi-alert-circle-outline</v-icon>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="questionHistoryDialog"
        fullscreen
        hide-overlay
        class="settings-dialog-content"
      >
        <v-card >
          <!-- Reported Questions Component -->
          <div class="px-6 pt-6">
            <div class="question-history-layout">
              <div
                class="question-history-section question-history-section-primary"
              >
                <div class="question-history-card pa-4">
                  <div class="question-history-card-header">
                    <h3 class="question-history-title mb-3">
                      {{ activeQuestionHistory.questionId || "NA" }}
                    </h3>
                  </div>

                  <div class="question-history-card-body">
                  <template v-if="activeQuestionHistory.questionType !== 'PASSAGE_BASED'">
                    <div
                      class="question-history-field-block mt-2"
                      :class="getHistoryFieldBlockClass('questionType')"
                    >
                      <p class="question-history-field-label mb-2">Question Type</p>
                      <div class="question-history-highlight-value">
                        {{ formatQuestionType(activeQuestionHistory.questionType) || "NA" }}
                      </div>
                    </div>

                    <div
                      class="question-history-field-block mt-2"
                      :class="getHistoryFieldBlockClass('questionStatement')"
                    >
                      <p class="question-history-highlight-label mb-2">Question</p>
                      <div
                        class="question-history-highlight-value"
                        v-html="formatQuestionStatementForDisplay(activeQuestionHistory.questionStatement) || 'NA'"
                      ></div>
                    </div>

                    <div v-if="historyImageLoading || historyResolvedAssetUrl" class="question-history-field-block mt-2">
                      <div v-if="historyImageLoading" class="d-flex align-center">
                        <v-progress-circular indeterminate color="#3F41D1" size="32" width="3" />
                      </div>
                      <template v-if="historyResolvedAssetUrl && !historyImageLoading">
                        <img
                          v-if="assetMediaKind(questionHistory.questionAssetType) === 'image'"
                          :src="historyResolvedAssetUrl"
                          class="exam-mode-image"
                        />
                        <component
                          v-else-if="assetMediaKind(questionHistory.questionAssetType) === 'audio' || assetMediaKind(questionHistory.questionAssetType) === 'video'"
                          :is="assetMediaKind(questionHistory.questionAssetType)"
                          :src="historyResolvedAssetUrl"
                          controls
                          controlsList="nodownload noplaybackrate"
                          class="exam-mode-media"
                        />
                      </template>
                    </div>

                    <div class="question-history-summary-grid mt-2">
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('markingType')"
                      >
                        <p class="question-history-field-label mb-1">Marking Type</p>
                        <p class="question-history-field-value mb-0">
                          {{ activeQuestionHistory.markingType || "NA" }}
                        </p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="{ 'question-history-field-block--changed': isHistoryFieldChanged('marksAllotted') || isHistoryFieldChanged('correctAnswerScore') }"
                      >
                        <p class="question-history-field-label mb-1">
                          Correct Answer Score
                        </p>
                        <p class="question-history-field-value mb-0">
                          {{ activeQuestionHistory.marksAllotted ?? activeQuestionHistory.correctAnswerScore ?? "NA" }}
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="activeQuestionHistory.questionType !== 'MATCH_THE_FOLLOWING' && activeQuestionHistory.questionType !== 'FILL_IN_THE_BLANKS'"
                      class="question-history-field-block mt-2"
                      :class="getHistoryFieldBlockClass('questionOptions')"
                    >
                      <p class="question-history-section-title mb-4">Options</p>
                      <div
                        v-if="Array.isArray(activeQuestionHistory.questionOptions) && activeQuestionHistory.questionOptions.length"
                        class="question-history-options-grid"
                      >
                        <div
                          v-for="(option, index) in activeQuestionHistory.questionOptions"
                          :key="option.optionKey || index"
                          class="question-history-option-item"
                        >
                          <span class="question-history-option-index">{{ index + 1 }}.</span>
                          <div
                            class="question-history-option-value"
                            :class="{
                              'question-history-option-value--correct': isHistoryCorrectOption(option),
                            }"
                            v-html="formatOptionValue(option.optionValue)"
                          ></div>
                        </div>
                      </div>
                      <p v-else class="question-history-field-value mb-0">NA</p>
                    </div>

                    <div
                      v-if="activeQuestionHistory.questionType === 'MATCH_THE_FOLLOWING' && historyMatchingPairs.length"
                      class="question-history-field-block mt-2"
                      :class="{ 'question-history-field-block--changed': isHistoryFieldChanged('correctAnswer') || isHistoryFieldChanged('mtfOptions') }"
                    >
                      <div class="question-history-match-header">
                        <p class="question-history-field-label mb-2">Items</p>
                        <p class="question-history-field-label mb-2">Matching Pair</p>
                      </div>
                      <div
                        v-for="(pair, index) in historyMatchingPairs"
                        :key="index"
                        class="question-history-match-row"
                      >
                        <p class="question-history-field-value mb-0">{{ index + 1 }}. {{ pair.item }}</p>
                        <p class="question-history-field-value mb-0">{{ pair.match }}</p>
                      </div>
                    </div>

                    <div
                      v-if="activeQuestionHistory.questionType === 'FILL_IN_THE_BLANKS'"
                      class="question-history-field-block mt-2"
                      :class="getHistoryFieldBlockClass('correctAnswer')"
                    >
                      <p class="question-history-highlight-label mb-2">Answer</p>
                      <div class="question-history-highlight-value">
                        {{ activeQuestionHistory.correctAnswer || "NA" }}
                      </div>
                    </div>

                    <div
                      class="question-history-field-block mt-2"
                      :class="getHistoryFieldBlockClass('answerExplanation')"
                    >
                      <p class="question-history-highlight-label mb-2">Answer Explanation</p>
                      <div
                        class="question-history-highlight-value"
                        v-html="activeQuestionHistory.answerExplanation || 'NA'"
                      ></div>
                    </div>

                    <div class="question-history-meta-grid mt-2">
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('hint')"
                      >
                        <p class="question-history-field-label mb-1">Hint</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.hint || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('application')"
                      >
                        <p class="question-history-field-label mb-1">Application</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.application || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('skill')"
                      >
                        <p class="question-history-field-label mb-1">Skill</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.skill || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('setNumber')"
                      >
                        <p class="question-history-field-label mb-1">Set Number</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.setNumber || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('subject')"
                      >
                        <p class="question-history-field-label mb-1">Subject</p>
                        <p class="question-history-field-value mb-0">{{ Array.isArray(activeQuestionHistory.subject) ? activeQuestionHistory.subject.join(', ') : activeQuestionHistory.subject || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('level')"
                      >
                        <p class="question-history-field-label mb-1">NEP Level</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.level || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('grade')"
                      >
                        <p class="question-history-field-label mb-1">Grade</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.grade || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('strand')"
                      >
                        <p class="question-history-field-label mb-1">Strand</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.strand || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('subStrand')"
                      >
                        <p class="question-history-field-label mb-1">Sub-Strand</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.subStrand || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('topic')"
                      >
                        <p class="question-history-field-label mb-1">Topic</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.topic || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('selectedLOs')"
                      >
                        <p class="question-history-field-label mb-1">LO</p>
                        <p class="question-history-field-value mb-0">{{ Array.isArray(activeQuestionHistory.selectedLOs) ? (activeQuestionHistory.selectedLOs.length ? activeQuestionHistory.selectedLOs.join(', ') : "NA") : activeQuestionHistory.selectedLOs || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('hrisUniqueRole')"
                      >
                        <p class="question-history-field-label mb-1">HRIS Unique Role</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.hrisUniqueRole || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('languageOfQuestion')"
                      >
                        <p class="question-history-field-label mb-1">Language</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.languageOfQuestion || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('isCaseSensitive')"
                      >
                        <p class="question-history-field-label mb-1">Case Sensitive</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.isCaseSensitive || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('bloomsTaxonomy')"
                      >
                        <p class="question-history-field-label mb-1">Bloom's Taxonomy Level</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.bloomsTaxonomy || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('difficultyLevel')"
                      >
                        <p class="question-history-field-label mb-1">Dfficulty Level</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.difficultyLevel || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('complexityLevel')"
                      >
                        <p class="question-history-field-label mb-1">complexity Level</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.complexityLevel || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('proficiencyLevel')"
                      >
                        <p class="question-history-field-label mb-1">Proficiency Level</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.proficiencyLevel || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('authoredBy')"
                      >
                        <p class="question-history-field-label mb-1">Authored By</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.authoredBy || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('groupName')"
                      >
                        <p class="question-history-field-label mb-1">Group</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.groupName || "NA" }}</p>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="question-history-field-block mt-2"
                      :class="getHistoryFieldBlockClass('questionType')"
                    >
                      <p class="question-history-field-label mb-2">Question Type</p>
                      <div class="question-history-highlight-value">
                        {{ formatQuestionType(activeQuestionHistory.questionType) || "NA" }}
                      </div>
                    </div>

                    <div
                      class="question-history-field-block mt-2"
                      :class="getHistoryFieldBlockClass('questionStatement')"
                    >
                      <p class="question-history-highlight-label mb-2">Passage</p>
                      <div
                        class="question-history-highlight-value"
                        v-html="formatQuestionStatementForDisplay(activeQuestionHistory.questionStatement) || 'NA'"
                      ></div>
                    </div>

                    <div class="question-history-meta-grid mt-2">
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('application')"
                      >
                        <p class="question-history-field-label mb-1">Application</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.application || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('skill')"
                      >
                        <p class="question-history-field-label mb-1">Skill</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.skill || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('setNumber')"
                      >
                        <p class="question-history-field-label mb-1">Set Number</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.setNumber || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('level')"
                      >
                        <p class="question-history-field-label mb-1">NEP Level</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.level || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('grade')"
                      >
                        <p class="question-history-field-label mb-1">Grade</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.grade || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('subject')"
                      >
                        <p class="question-history-field-label mb-1">Subject</p>
                        <p class="question-history-field-value mb-0">{{ Array.isArray(activeQuestionHistory.subject) ? activeQuestionHistory.subject.join(', ') : activeQuestionHistory.subject || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('hrisUniqueRole')"
                      >
                        <p class="question-history-field-label mb-1">HRIS Unique Role</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.hrisUniqueRole || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('languageOfQuestion')"
                      >
                        <p class="question-history-field-label mb-1">Language</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.languageOfQuestion || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('authoredBy')"
                      >
                        <p class="question-history-field-label mb-1">Authored By</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.authoredBy || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('groupName')"
                      >
                        <p class="question-history-field-label mb-1">Group</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.groupName || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('customer')"
                      >
                        <p class="question-history-field-label mb-1">Customer</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.customer || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('difficultyLevel')"
                      >
                        <p class="question-history-field-label mb-1">Difficulty Level</p>
                        <p class="question-history-field-value mb-0">{{ activeQuestionHistory.difficultyLevel || "NA" }}</p>
                      </div>
                      <div
                        class="question-history-field-block"
                        :class="getHistoryFieldBlockClass('subQuestions')"
                      >
                        <p class="question-history-field-label mb-1">Number of Questions</p>
                        <p class="question-history-field-value mb-0">{{ (activeQuestionHistory.subQuestions || []).length || "NA" }}</p>
                      </div>
                    </div>

                    <div class="question-history-field-block mt-2">
                      <div class="d-flex align-center justify-space-between mb-4">
                        <p class="question-history-section-title mb-0">Questions</p>
                        <div class="d-flex align-center">
                          <v-btn
                            class="btn outline-btn mr-3"
                            :disabled="!(activeQuestionHistory.subQuestions || []).length || historySubQuestionPanels.length === (activeQuestionHistory.subQuestions || []).length"
                            @click="toggleHistorySubQuestionPanels(true)"
                          >
                            Expand All
                          </v-btn>
                          <v-btn
                            class="btn outline-btn"
                            :disabled="!historySubQuestionPanels.length"
                            @click="toggleHistorySubQuestionPanels(false)"
                          >
                            Collapse All
                          </v-btn>
                        </div>
                      </div>
                      <v-expansion-panels v-model="historySubQuestionPanels" multiple flat>
                        <v-expansion-panel
                          v-for="(subQuestion, index) in activeQuestionHistory.subQuestions || []"
                          :key="index"
                          class="question-history-expansion-panel"
                        >
                          <v-expansion-panel-header class="question-history-expansion-header">
                            Question {{ index + 1 }}
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div
                              class="question-history-field-block mt-2 pt-4"
                              :class="getSubQuestionFieldBlockClass(index, 'questionType')"
                            >
                              <p class="question-history-field-label mb-2">Question Type</p>
                              <div class="question-history-highlight-value">
                                {{ formatQuestionType(subQuestion.questionType) || "NA" }}
                              </div>
                            </div>

                            <div
                              class="question-history-field-block mt-2"
                              :class="getSubQuestionFieldBlockClass(index, 'questionStatement')"
                            >
                              <p class="question-history-highlight-label mb-2">Question</p>
                              <div
                                class="question-history-highlight-value"
                                v-html="formatQuestionStatementForDisplay(subQuestion.questionStatement) || 'NA'"
                              ></div>
                            </div>

                            <div class="question-history-summary-grid mt-2">
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'markingType')"
                              >
                                <p class="question-history-field-label mb-1">Marking Type</p>
                                <p class="question-history-field-value mb-0">{{ subQuestion.markingType || "NA" }}</p>
                              </div>
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'correctAnswerScore')"
                              >
                                <p class="question-history-field-label mb-1">Correct Answer Score</p>
                                <p class="question-history-field-value mb-0">{{ subQuestion.correctAnswerScore ?? "NA" }}</p>
                              </div>
                            </div>

                            <div
                              v-if="subQuestion.questionType !== 'MATCH_THE_FOLLOWING' && subQuestion.questionType !== 'FILL_IN_THE_BLANKS' && getSubQuestionResolvedOptions(subQuestion).length"
                              class="question-history-field-block mt-2"
                              :class="getSubQuestionFieldBlockClass(index, 'questionOptions')"
                            >
                              <p class="question-history-section-title mb-4">Options</p>
                              <div class="question-history-options-grid">
                                <div
                                  v-for="(option, optionIndex) in getSubQuestionResolvedOptions(subQuestion)"
                                  :key="option.optionKey || optionIndex"
                                  class="question-history-option-item"
                                >
                                  <span class="question-history-option-index">{{ optionIndex + 1 }}.</span>
                                  <div
                                    class="question-history-option-value"
                                    :class="{ 'question-history-option-value--correct': isSubQuestionCorrectOption(subQuestion, option) }"
                                    v-html="formatOptionValue(option.optionValue)"
                                  ></div>
                                </div>
                              </div>
                            </div>

                            <div class="question-history-summary-grid mt-2" v-if="subQuestion.questionType === 'FILL_IN_THE_BLANKS'">
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'correctAnswer')"
                              >
                                <p class="question-history-highlight-label mb-2">Answer</p>
                                <div class="question-history-highlight-value">{{ subQuestion.correctAnswer || "NA" }}</div>
                              </div>
                            </div>

                            <div
                              v-if="subQuestion.questionType === 'MATCH_THE_FOLLOWING' && getSubQuestionMatchingPairs(subQuestion).length"
                              class="question-history-field-block mt-2"
                              :class="getSubQuestionFieldBlockClass(index, 'correctAnswer')"
                            >
                              <div class="question-history-match-header">
                                <p class="question-history-field-label mb-2">Items</p>
                                <p class="question-history-field-label mb-2">Matching Pair</p>
                              </div>
                              <div
                                v-for="(pair, pairIndex) in getSubQuestionMatchingPairs(subQuestion)"
                                :key="pairIndex"
                                class="question-history-match-row"
                              >
                                <p class="question-history-field-value mb-0">{{ pairIndex + 1 }}. {{ pair.item }}</p>
                                <p class="question-history-field-value mb-0">{{ pair.match }}</p>
                              </div>
                            </div>

                            <div
                              class="question-history-field-block mt-2"
                              :class="getSubQuestionFieldBlockClass(index, 'answerExplanation')"
                            >
                              <p class="question-history-highlight-label mb-2">Answer Explanation</p>
                              <div
                                class="question-history-highlight-value"
                                v-html="subQuestion.answerExplanation || 'NA'"
                              ></div>
                            </div>

                            <div class="question-history-meta-grid mt-2">
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'hint')"
                              >
                                <p class="question-history-field-label mb-1">Hint</p>
                                <p class="question-history-field-value mb-0">{{ getDisplayValue(subQuestion.hint) }}</p>
                              </div>
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'strand')"
                              >
                                <p class="question-history-field-label mb-1">Strand</p>
                                <p class="question-history-field-value mb-0">{{ getDisplayValue(subQuestion.strand) }}</p>
                              </div>
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'subStrand')"
                              >
                                <p class="question-history-field-label mb-1">Sub-Strand</p>
                                <p class="question-history-field-value mb-0">{{ getDisplayValue(subQuestion.subStrand) }}</p>
                              </div>
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'topic')"
                              >
                                <p class="question-history-field-label mb-1">Topic</p>
                                <p class="question-history-field-value mb-0">{{ getDisplayValue(subQuestion.topic) }}</p>
                              </div>
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'selectedLOs')"
                              >
                                <p class="question-history-field-label mb-1">LO</p>
                                <p class="question-history-field-value mb-0">{{ getDisplayValue(subQuestion.selectedLOs) }}</p>
                              </div>
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'isCaseSensitive')"
                              >
                                <p class="question-history-field-label mb-1">Case Sensitive</p>
                                <p class="question-history-field-value mb-0">{{ getDisplayValue(subQuestion.isCaseSensitive) }}</p>
                              </div>
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'bloomsTaxonomy')"
                              >
                                <p class="question-history-field-label mb-1">Bloom's Taxonomy Level</p>
                                <p class="question-history-field-value mb-0">{{ getDisplayValue(subQuestion.bloomsTaxonomy) }}</p>
                              </div>
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'difficultyLevel')"
                              >
                                <p class="question-history-field-label mb-1">Difficulty Level</p>
                                <p class="question-history-field-value mb-0">{{ getDisplayValue(subQuestion.difficultyLevel) }}</p>
                              </div>
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'complexityLevel')"
                              >
                                <p class="question-history-field-label mb-1">Complexity Level</p>
                                <p class="question-history-field-value mb-0">{{ getDisplayValue(subQuestion.complexityLevel) }}</p>
                              </div>
                              <div
                                class="question-history-field-block"
                                :class="getSubQuestionFieldBlockClass(index, 'proficiencyLevel')"
                              >
                                <p class="question-history-field-label mb-1">Proficiency Level</p>
                                <p class="question-history-field-value mb-0">{{ getDisplayValue(subQuestion.proficiencyLevel) }}</p>
                              </div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </template>
                  </div>
                </div>
              </div>

              <div class="question-history-section question-history-section-secondary pa-4">
                <div class="question-history-side-header">
                  <h3 class="question-history-side-title mb-1">View History</h3>
                  <p class="question-history-side-subtitle mb-0">View the history of all updates made to this question, including version changes, editors, timestamps, and number of modifications</p>
                </div>

                <div class="question-history-side-content mt-6">
                  <div
                    v-if="questionHistoryLoading"
                    class="question-history-loading-state"
                  >
                    <v-progress-circular
                      indeterminate
                      :size="24"
                      :width="3"
                      color="primary"
                    ></v-progress-circular>
                    <span>Loading version history...</span>
                  </div>

                  <div
                    v-else-if="questionHistoryTimeline.length"
                    class="question-history-timeline"
                  >
                    <div
                      v-for="group in questionHistoryTimeline"
                      :key="group.dateLabel"
                      class="question-history-timeline-group"
                    >
                      <div class="question-history-timeline-date-row">
                        <div class="question-history-timeline-date-meta">
                          <span class="question-history-timeline-dot"></span>
                          <p class="question-history-timeline-date mb-0">
                            {{ group.dateLabel }}
                          </p>
                        </div>
                        <v-btn
                          icon
                          x-small
                          class="question-history-timeline-toggle"
                          @click="toggleHistoryTimelineGroup(group.dateLabel)"
                        >
                          <v-icon small>
                            {{
                              isHistoryTimelineGroupCollapsed(group.dateLabel)
                                ? "mdi-chevron-down"
                                : "mdi-chevron-up"
                            }}
                          </v-icon>
                        </v-btn>
                      </div>

                      <div
                        v-if="!isHistoryTimelineGroupCollapsed(group.dateLabel)"
                        class="question-history-timeline-items"
                      >
                        <div
                          v-for="item in group.items"
                          :key="item.version || item.updatedOn"
                          class="question-history-timeline-card"
                          :class="{
                            'question-history-timeline-card-active': isSelectedHistoryVersion(item),
                            'question-history-timeline-card-current': isCurrentHistoryVersion(item),
                          }"
                          @click="selectHistoryVersion(item)"
                        >
                          <div class="question-history-timeline-card-top">
                            <div>
                              <p class="question-history-timeline-version mb-1">
                                {{ item.version || "NA" }}
                              </p>
                              <div class="question-history-timeline-inline-meta">
                                <v-icon small class="question-history-timeline-icon">
                                  mdi-pencil-outline
                                </v-icon>
                                <span>{{ getHistoryChangeLabel(item) }}</span>
                              </div>
                            </div>

                            <div
                              v-if="isCurrentHistoryVersion(item)"
                              class="question-history-current-badge"
                            >
                              Current
                            </div>
                          </div>

                          <div class="question-history-timeline-card-bottom mt-2">
                            <div class="question-history-timeline-inline-meta">
                              <v-icon small class="question-history-timeline-icon">
                                mdi-account-outline
                              </v-icon>
                              <span>{{ item.updatedBy?.name || "NA" }}</span>
                            </div>

                            <div class="question-history-timeline-inline-meta">
                              <v-icon small class="question-history-timeline-icon">
                                mdi-clock-outline
                              </v-icon>
                              <span>{{ formatHistoryTime(item.updatedOn) }}</span>
                            </div>
                          </div>
                          <div v-if="item.comment" class="question-history-timeline-card-bottom mt-2">
                            <div class="question-history-timeline-inline-meta">
                              <v-icon small class="question-history-timeline-icon">
                                mdi-comment-text-outline
                              </v-icon>
                              <v-tooltip bottom max-width="320">
                                <template #activator="{ on, attrs }">
                                  <span
                                    class="question-history-comment-clamp"
                                    v-bind="attrs"
                                    v-on="on"
                                    v-html="item.comment"
                                  ></span>
                                </template>
                                <span v-html="item.comment"></span>
                              </v-tooltip>
                            </div>
                          </div>

                          
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-else class="question-history-empty-state">
                    No version history found.
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-center justify-end">
              <v-btn
                @click="questionHistoryDialog = false; stopAllAudio()"
                dense
                rounded
                class="btn outline-btn elevation-0"
              >
                <span>CLOSE</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <div v-if="imagePreview">
        <template>
          <v-dialog v-model="imagePreview" max-width="500px">
            <v-card>
              <div class="d-flex justify-center align-center flex-column pa-4">
                <img
                  v-if="assetMediaKind(questionAssetType) === 'image'"
                  :src="questionAssetUrlForPreview"
                  @loadstart="resolveQuestionAssetUrl"
                  alt="question asset"
                  class="img pa-0 w-auto h-auto"
                />
                <component
                  v-else-if="assetMediaKind(questionAssetType) === 'audio' || assetMediaKind(questionAssetType) === 'video'"
                  :is="assetMediaKind(questionAssetType)"
                  :src="questionAssetUrlForPreview"
                  controls
                  controlsList="nodownload noplaybackrate"
                  :class="assetMediaKind(questionAssetType) === 'audio' ? 'exam-mode-media' : 'asset-preview-video'"
                  @loadstart="resolveQuestionAssetUrl"
                />
              </div>
              <div class="d-flex justify-end pb-2">
                <v-btn
                  class="btn outline-btn font-weight-medium mx-3 text-right"
                  rounded
                  text
                  @click="
                    imagePreview = false;
                    questionAssetUrlForPreview = IMAGE_ALT_SRC;
                    stopAllAudio();
                  "
                  >Cancel</v-btn
                >
              </div>
            </v-card>
          </v-dialog>
        </template>
      </div>
      <!-- Exam Mode Dialog -->
      <v-dialog v-model="examModeDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <div class="exam-mode-wrapper" v-if="examModeQuestion">
          <!-- Left Sidebar -->
          <div class="exam-mode-sidebar">
            <div class="exam-mode-sidebar-header graphik-regular">Campaign</div>
            <v-card class="exam-mode-stats-card" outlined>
              <p class="exam-mode-placeholder-text graphik-regular">
                Answered, Skipped and Bookmarked Questions count will appear here
              </p>
            </v-card>
            <div class="exam-mode-list-card mt-3">
              <p class="exam-mode-placeholder-text graphik-regular">List of questions will appear here</p>
            </div>
          </div>

          <!-- Right Content -->
          <div class="exam-mode-content">
            <!-- Close -->
            <v-btn icon class="exam-mode-close-btn" @click="examModeDialog = false; stopAllAudio()">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <!-- Timer Bar -->
            <div class="exam-mode-topbar">
              <div class="d-flex align-center">
                <div class="exam-mode-timer-unit">
                  <span class="exam-mode-timer-label graphik-regular">HH</span>
                  <div class="exam-mode-timer-box graphik-regular">00</div>
                </div>
                <span class="exam-mode-timer-colon graphik-regular">:</span>
                <div class="exam-mode-timer-unit">
                  <span class="exam-mode-timer-label graphik-regular">MM</span>
                  <div class="exam-mode-timer-box graphik-regular">19</div>
                </div>
                <span class="exam-mode-timer-colon graphik-regular">:</span>
                <div class="exam-mode-timer-unit">
                  <span class="exam-mode-timer-label graphik-regular">SS</span>
                  <div class="exam-mode-timer-box graphik-regular">59</div>
                </div>
                <div class="exam-mode-timer-unit ml-3">
                  <span class="exam-mode-timer-label graphik-regular" style="visibility:hidden">HH</span>
                  <span class="exam-mode-time-left-text">Time Left</span>
                </div>
              </div>
              <v-btn class="exam-mode-submit-btn font-weight-bold" depressed rounded>Submit</v-btn>
            </div>

            <!-- Progress -->
            <v-progress-linear value="0" height="16" color="#3F41D1" background-color="#E0E0E0" class="exam-mode-progress" />

            <!-- Question meta -->
            <div class="d-flex justify-space-between align-center exam-mode-question-meta">
              <span class="exam-mode-question-counter">Question 01 of 01</span>
              <v-chip small class="exam-mode-lang-chip graphik-regular">
                {{ examModeQuestion.skill}}
              </v-chip>
            </div>

            <!-- Question Card -->
            <v-card v-if="examModeQuestion.questionType === 'PASSAGE_BASED'" class="exam-mode-question-card" outlined>
              <div class="exam-mode-question-content" ref="examModeContent">
                <p class="font-weight-bold mb-2">
                  Paragraph (Question 1/{{ (examModeQuestion.subQuestions || []).length }})
                </p>
                <div v-html="formatQuestionStatementForDisplay(examModeQuestion.questionStatement)" class="exam-mode-question-text"></div>

                <div v-if="examModeActiveSubQuestion" class="exam-mode-subquestion-box mt-4">
                  <div class="exam-mode-question-text font-weight-bold">
                    Q1.1. <span v-html="formatQuestionStatementForDisplay(examModeActiveSubQuestion.questionStatement)"></span>
                  </div>
                  <div class="exam-mode-question-card-footer">
                    <span class="exam-mode-expand-link cursor" @click="examModeExpandDialog = true">
                      <v-icon small color="#3F41D1">mdi-arrow-expand</v-icon>
                      <span class="ml-1">EXPAND QUESTION</span>
                    </span>
                    <v-icon color="red">mdi-flag-outline</v-icon>
                  </div>
                </div>
              </div>
            </v-card>
            <v-card v-else class="exam-mode-question-card" outlined>
              <div class="exam-mode-question-content" ref="examModeContent">
                <div v-html="formatQuestionStatementForDisplay(examModeQuestion.questionStatement)" class="exam-mode-question-text font-weight-bold"></div>
                <div v-if="examModeImageLoading" class="exam-mode-image-loader mt-3">
                  <v-progress-circular indeterminate color="#3F41D1" size="32" width="3" />
                </div>
                <template v-if="examModeResolvedAssetUrl && !examModeImageLoading">
                  <img
                    v-if="assetMediaKind(examModeQuestion.questionAssetType) === 'image'"
                    :src="examModeResolvedAssetUrl"
                    class="exam-mode-image mt-3"
                    @load="onExamModeImageLoad"
                    @error="examModeImageLoading = false"
                  />
                  <component
                    v-else-if="assetMediaKind(examModeQuestion.questionAssetType) === 'audio' || assetMediaKind(examModeQuestion.questionAssetType) === 'video'"
                    :is="assetMediaKind(examModeQuestion.questionAssetType)"
                    :src="examModeResolvedAssetUrl"
                    controls
                    controlsList="nodownload noplaybackrate"
                    class="exam-mode-media mt-3"
                    @loadeddata="onExamModeImageLoad"
                    @error="examModeImageLoading = false"
                  />
                </template>
              </div>
              <div class="exam-mode-question-card-footer">
                <span
                  v-if="examModeIsScrollable"
                  class="exam-mode-expand-link cursor"
                  @click="examModeExpandDialog = true"
                >
                  <v-icon small color="#3F41D1">mdi-arrow-expand</v-icon>
                  <span class="ml-1">EXPAND QUESTION</span>
                </span>
                <span v-else></span>
                <v-icon color="red">mdi-flag-outline</v-icon>
              </div>
            </v-card>

            <!-- Options: SINGLE_CHOICE -->
            <template v-if="examModeActiveQuestionType === 'SINGLE_CHOICE'">
              <div class="exam-mode-options-wrapper">
                <v-radio-group v-model="examModeSelectedOption" hide-details class="ma-0 pa-0">
                  <div :class="['exam-mode-options-grid', { 'exam-mode-options-grid--image': examModeResolvedOptions[0]?.optionValue?.startsWith('https://') || examModeResolvedOptions[0]?.optionValue?.startsWith('http://') || examModeResolvedOptions[0]?.optionValue?.startsWith('blob:') }]">
                    <v-card
                      v-for="(option, idx) in examModeResolvedOptions"
                      :key="idx"
                      class="exam-mode-option-card"
                    >
                      <v-radio :value="option.optionKey" color="#3F41D1" hide-details class="ma-0 pa-0" @click.prevent>
                        <template #label>
                          <v-tooltip bottom :disabled="isImageOption(option.optionValue)" max-width="320">
                            <template #activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on" v-html="formatOptionValue(option.optionValue)" class="exam-mode-option-label graphik-regular"></span>
                            </template>
                            <span>{{ option.optionValue }}</span>
                          </v-tooltip>
                        </template>
                      </v-radio>
                    </v-card>
                  </div>
                </v-radio-group>
              </div>
            </template>

            <!-- Options: MULTIPLE_CHOICE -->
            <template v-else-if="examModeActiveQuestionType === 'MULTIPLE_CHOICE'">
              <div class="exam-mode-options-wrapper">
                <div :class="['exam-mode-options-grid', { 'exam-mode-options-grid--image': examModeResolvedOptions[0]?.optionValue?.startsWith('https://') || examModeResolvedOptions[0]?.optionValue?.startsWith('http://') || examModeResolvedOptions[0]?.optionValue?.startsWith('blob:') }]">
                  <v-card
                    v-for="(option, idx) in examModeResolvedOptions"
                    :key="idx"
                    class="exam-mode-option-card"
                  >
                    <v-checkbox
                      v-model="examModeSelectedOptions"
                      :value="option.optionKey"
                      color="#3F41D1"
                      hide-details
                      class="ma-0 pa-0"
                      @click.prevent
                    >
                      <template #label>
                        <v-tooltip bottom :disabled="isImageOption(option.optionValue)" max-width="320">
                          <template #activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" v-html="formatOptionValue(option.optionValue)" class="exam-mode-option-label graphik-regular"></span>
                          </template>
                          <span>{{ option.optionValue }}</span>
                        </v-tooltip>
                      </template>
                    </v-checkbox>
                  </v-card>
                </div>
              </div>
            </template>

            <!-- Options: TRUE_FALSE -->
            <template v-else-if="examModeActiveQuestionType === 'TRUE_FALSE'">
              <div class="exam-mode-options-wrapper">
                <v-radio-group v-model="examModeSelectedOption" hide-details class="ma-0 pa-0">
                  <div class="exam-mode-options-grid">
                    <v-card class="exam-mode-option-card">
                      <v-radio value="true" color="#3F41D1" hide-details label="True" class="ma-0 pa-0" @click.prevent />
                    </v-card>
                    <v-card class="exam-mode-option-card">
                      <v-radio value="false" color="#3F41D1" hide-details label="False" class="ma-0 pa-0" @click.prevent />
                    </v-card>
                  </div>
                </v-radio-group>
              </div>
            </template>

            <!-- Options: FILL_IN_THE_BLANK -->
            <template v-else-if="examModeActiveQuestionType === 'FILL_IN_THE_BLANK' || examModeActiveQuestionType === 'FILL_IN_THE_BLANKS'">
              <v-card class="exam-mode-fib-card" outlined>
                <v-text-field
                  v-model="examModeFillAnswer"
                  placeholder="Type your answer here..."
                  outlined
                  dense
                  hide-details
                  readonly
                />
              </v-card>
            </template>

            <!-- Options: MATCH_THE_FOLLOWING -->
            <template v-else-if="examModeActiveQuestionType === 'MATCH_THE_FOLLOWING'">
              <div class="exam-mode-mtf-wrapper" v-if="examModeMtfPairs.length">
                <div class="exam-mode-mtf-col">
                  <div
                    v-for="(pair, idx) in examModeMtfPairs"
                    :key="'left-' + idx"
                    class="exam-mode-mtf-item"
                  >
                    {{ pair.key }}
                  </div>
                </div>
                <div class="exam-mode-mtf-col">
                  <div
                    v-for="(pair, idx) in examModeMtfPairs"
                    :key="'right-' + idx"
                    class="exam-mode-mtf-item"
                  >
                    {{ pair.value }}
                  </div>
                </div>
              </div>
            </template>
            <v-divider class="pb-4"></v-divider>
            <!-- Bottom Nav -->
            <div class="exam-mode-nav">
              <div>
                <v-btn outlined rounded disabled class="exam-mode-nav-btn mr-2">Previous</v-btn>
                <v-btn  rounded disabled class="exam-mode-nav-btn">Next</v-btn>
              </div>
              <div>
                <v-btn text class="exam-mode-action-btn font-weight-bold mr-2">
                  <v-icon >mdi-bookmark-outline</v-icon>Bookmark
                </v-btn>
                <v-btn text class="exam-mode-action-btn font-weight-bold" @click="examModeSelectedOption = null; examModeFillAnswer = ''">
                  <v-icon >mdi-eraser</v-icon>Clear
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-dialog>

      <!-- Expand Question Dialog -->
      <v-dialog v-model="examModeExpandDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card class="exam-mode-expand-dialog" v-if="examModeQuestion">
          <div class="exam-mode-expand-header">
            <span class="exam-mode-expand-title">Question</span>
            <v-btn icon @click="examModeExpandDialog = false; stopAllAudio()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="exam-mode-expand-body" v-if="examModeQuestion.questionType !== 'PASSAGE_BASED'">
            <!-- Question card — fixed height, image scrolls inside if needed -->
            <v-card class="exam-mode-question-card" outlined>
              <div class="exam-mode-question-content">
                <div v-html="formatQuestionStatementForDisplay(examModeQuestion.questionStatement)" class="exam-mode-question-text"></div>
                <template v-if="examModeResolvedAssetUrl">
                  <img
                    v-if="assetMediaKind(examModeQuestion.questionAssetType) === 'image'"
                    :src="examModeResolvedAssetUrl"
                    class="exam-mode-image mt-3"
                  />
                  <component
                    v-else-if="assetMediaKind(examModeQuestion.questionAssetType) === 'audio' || assetMediaKind(examModeQuestion.questionAssetType) === 'video'"
                    :is="assetMediaKind(examModeQuestion.questionAssetType)"
                    :src="examModeResolvedAssetUrl"
                    controls
                    controlsList="nodownload noplaybackrate"
                    class="exam-mode-media mt-3"
                  />
                </template>
              </div>
              <div class="exam-mode-question-card-footer">
                <span></span>
                <v-icon color="red">mdi-flag-outline</v-icon>
              </div>
            </v-card>

            <!-- Options pinned at bottom -->
            <template v-if="examModeQuestion.questionType === 'SINGLE_CHOICE'">
              <div class="exam-mode-options-wrapper">
                <v-radio-group v-model="examModeSelectedOption" hide-details class="ma-0 pa-0">
                  <div :class="['exam-mode-options-grid', { 'exam-mode-options-grid--image': examModeResolvedOptions[0]?.optionValue?.startsWith('https://') || examModeResolvedOptions[0]?.optionValue?.startsWith('http://') || examModeResolvedOptions[0]?.optionValue?.startsWith('blob:') }]">
                    <v-card v-for="(option, idx) in examModeResolvedOptions" :key="idx" class="exam-mode-option-card">
                      <v-radio :value="option.optionKey" color="#3F41D1" hide-details class="ma-0 pa-0" @click.prevent>
                        <template #label>
                          <v-tooltip bottom :disabled="isImageOption(option.optionValue)" max-width="320">
                            <template #activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on" v-html="formatOptionValue(option.optionValue)" class="exam-mode-option-label graphik-regular"></span>
                            </template>
                            <span>{{ option.optionValue }}</span>
                          </v-tooltip>
                        </template>
                      </v-radio>
                    </v-card>
                  </div>
                </v-radio-group>
              </div>
            </template>

            <template v-else-if="examModeQuestion.questionType === 'MULTIPLE_CHOICE'">
              <div class="exam-mode-options-wrapper">
                <div :class="['exam-mode-options-grid', { 'exam-mode-options-grid--image': examModeResolvedOptions[0]?.optionValue?.startsWith('https://') || examModeResolvedOptions[0]?.optionValue?.startsWith('http://') || examModeResolvedOptions[0]?.optionValue?.startsWith('blob:') }]">
                  <v-card v-for="(option, idx) in examModeResolvedOptions" :key="idx" class="exam-mode-option-card">
                    <v-checkbox v-model="examModeSelectedOptions" :value="option.optionKey" color="#3F41D1" hide-details class="ma-0 pa-0" @click.prevent>
                      <template #label>
                        <v-tooltip bottom :disabled="isImageOption(option.optionValue)" max-width="320">
                          <template #activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" v-html="formatOptionValue(option.optionValue)" class="exam-mode-option-label graphik-regular"></span>
                          </template>
                          <span>{{ option.optionValue }}</span>
                        </v-tooltip>
                      </template>
                    </v-checkbox>
                  </v-card>
                </div>
              </div>
            </template>

            <template v-else-if="examModeQuestion.questionType === 'TRUE_FALSE'">
              <div class="exam-mode-options-wrapper">
                <v-radio-group v-model="examModeSelectedOption" hide-details class="ma-0 pa-0">
                  <div class="exam-mode-options-grid">
                    <v-card class="exam-mode-option-card">
                      <v-radio value="true" color="#3F41D1" hide-details label="True" class="ma-0 pa-0" @click.prevent />
                    </v-card>
                    <v-card class="exam-mode-option-card">
                      <v-radio value="false" color="#3F41D1" hide-details label="False" class="ma-0 pa-0" @click.prevent />
                    </v-card>
                  </div>
                </v-radio-group>
              </div>
            </template>

            <template v-else-if="examModeQuestion.questionType === 'FILL_IN_THE_BLANK' || examModeQuestion.questionType === 'FILL_IN_THE_BLANKS'">
              <v-card class="exam-mode-fib-card" outlined>
                <v-text-field v-model="examModeFillAnswer" placeholder="Type your answer here..." outlined dense hide-details readonly />
              </v-card>
            </template>
          </div>

          <!-- Passage layout: passage on the left, sub-question + options on the right -->
          <div class="exam-mode-expand-body exam-mode-expand-body--passage" v-else>
            <div class="exam-mode-expand-passage-pane">
              <div v-html="formatQuestionStatementForDisplay(examModeQuestion.questionStatement)" class="exam-mode-question-text"></div>
            </div>
            <v-divider vertical></v-divider>
            <div class="exam-mode-expand-question-pane">
              <v-card v-if="examModeActiveSubQuestion" class="exam-mode-question-card" outlined>
                <div class="exam-mode-question-content">
                  <div class="exam-mode-question-text font-weight-bold">
                    Q1.1. <span v-html="formatQuestionStatementForDisplay(examModeActiveSubQuestion.questionStatement)"></span>
                  </div>
                </div>
                <div class="exam-mode-question-card-footer">
                  <span></span>
                  <v-icon color="red">mdi-flag-outline</v-icon>
                </div>
              </v-card>

              <div class="mt-auto">
                <template v-if="examModeActiveQuestionType === 'SINGLE_CHOICE'">
                  <div class="exam-mode-options-wrapper">
                    <v-radio-group v-model="examModeSelectedOption" hide-details class="ma-0 pa-0">
                      <div :class="['exam-mode-options-grid', { 'exam-mode-options-grid--image': examModeResolvedOptions[0]?.optionValue?.startsWith('https://') || examModeResolvedOptions[0]?.optionValue?.startsWith('http://') || examModeResolvedOptions[0]?.optionValue?.startsWith('blob:') }]">
                        <v-card v-for="(option, idx) in examModeResolvedOptions" :key="idx" class="exam-mode-option-card">
                          <v-radio :value="option.optionKey" color="#3F41D1" hide-details class="ma-0 pa-0" @click.prevent>
                            <template #label>
                              <v-tooltip bottom :disabled="isImageOption(option.optionValue)" max-width="320">
                                <template #activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on" v-html="formatOptionValue(option.optionValue)" class="exam-mode-option-label graphik-regular"></span>
                                </template>
                                <span>{{ option.optionValue }}</span>
                              </v-tooltip>
                            </template>
                          </v-radio>
                        </v-card>
                      </div>
                    </v-radio-group>
                  </div>
                </template>

                <template v-else-if="examModeActiveQuestionType === 'MULTIPLE_CHOICE'">
                  <div class="exam-mode-options-wrapper">
                    <div :class="['exam-mode-options-grid', { 'exam-mode-options-grid--image': examModeResolvedOptions[0]?.optionValue?.startsWith('https://') || examModeResolvedOptions[0]?.optionValue?.startsWith('http://') || examModeResolvedOptions[0]?.optionValue?.startsWith('blob:') }]">
                      <v-card v-for="(option, idx) in examModeResolvedOptions" :key="idx" class="exam-mode-option-card">
                        <v-checkbox v-model="examModeSelectedOptions" :value="option.optionKey" color="#3F41D1" hide-details class="ma-0 pa-0" @click.prevent>
                          <template #label>
                            <v-tooltip bottom :disabled="isImageOption(option.optionValue)" max-width="320">
                              <template #activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" v-html="formatOptionValue(option.optionValue)" class="exam-mode-option-label graphik-regular"></span>
                              </template>
                              <span>{{ option.optionValue }}</span>
                            </v-tooltip>
                          </template>
                        </v-checkbox>
                      </v-card>
                    </div>
                  </div>
                </template>

                <template v-else-if="examModeActiveQuestionType === 'TRUE_FALSE'">
                  <div class="exam-mode-options-wrapper">
                    <v-radio-group v-model="examModeSelectedOption" hide-details class="ma-0 pa-0">
                      <div class="exam-mode-options-grid">
                        <v-card class="exam-mode-option-card">
                          <v-radio value="true" color="#3F41D1" hide-details label="True" class="ma-0 pa-0" @click.prevent />
                        </v-card>
                        <v-card class="exam-mode-option-card">
                          <v-radio value="false" color="#3F41D1" hide-details label="False" class="ma-0 pa-0" @click.prevent />
                        </v-card>
                      </div>
                    </v-radio-group>
                  </div>
                </template>

                <template v-else-if="examModeActiveQuestionType === 'FILL_IN_THE_BLANK' || examModeActiveQuestionType === 'FILL_IN_THE_BLANKS'">
                  <v-card class="exam-mode-fib-card" outlined>
                    <v-text-field v-model="examModeFillAnswer" placeholder="Type your answer here..." outlined dense hide-details readonly />
                  </v-card>
                </template>

                <template v-else-if="examModeActiveQuestionType === 'MATCH_THE_FOLLOWING'">
                  <div class="exam-mode-mtf-wrapper" v-if="examModeMtfPairs.length">
                    <div class="exam-mode-mtf-col">
                      <div v-for="(pair, idx) in examModeMtfPairs" :key="'left-' + idx" class="exam-mode-mtf-item">
                        {{ pair.key }}
                      </div>
                    </div>
                    <div class="exam-mode-mtf-col">
                      <div v-for="(pair, idx) in examModeMtfPairs" :key="'right-' + idx" class="exam-mode-mtf-item">
                        {{ pair.value }}
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <v-divider></v-divider>
              <div class="exam-mode-expand-footer">
                <v-btn rounded outlined class="btn outline-btn mr-3" @click="examModeExpandDialog = false">Cancel</v-btn>
                <v-btn rounded class="btn primary-btn" @click="examModeExpandDialog = false">Done</v-btn>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import AuthService from "../services/AuthService";
import axios from "axios";
import QuestionsController from "../controllers/QuestionsController";
import LoBankController from "@/controllers/LoBankController";
import AudienceRoleController from "@/controllers/AudienceRoleController";
import SubjectController from "@/controllers/SubjectController";
import SkillsController from "@/controllers/SkillsController";
import LevelController from "@/controllers/LevelController";
import AudienceRolesController from "@/controllers/AudienceRolesController";
import Papa from "papaparse";
import { storage } from "../firebase";
import { getDownloadURL, ref, uploadBytes } from "@firebase/storage";
import Notification from "./Notification";
import { debounce } from "lodash";
import GradeController from "@/controllers/GradeController";
import {
  format,
  startOfToday,
  startOfYesterday,
  startOfWeek,
  startOfMonth,
  startOfLastWeek,
  startOfLastMonth,
  endOfToday,
  endOfYesterday,
  endOfWeek,
  endOfMonth,
  endOfLastWeek,
  endOfLastMonth,
} from "date-fns";
import BubbleLoader from "@/components/BubbleLoader.vue";
import UserNavMenu from "@/components/UserNavMenu.vue";
import FilterSearch from "@/components/FilterSearch.vue";
import PassageSubQuestionAnswer from "@/components/PassageSubQuestionAnswer.vue";
import isTableScrollableMixin from "@/mixins/isTableScrollableMixin";

const IMAGE_ALT_SRC = "../assets/caution.png";

const PASSAGE_BASED_QUESTION_TYPE = "PASSAGE_BASED";
const PARENT_QUESTION_TYPES = new Set([PASSAGE_BASED_QUESTION_TYPE]);

const BLANK_PLACEHOLDER_PATTERN = /\{\s*blank\s*\}/i;
const BLANK_PLACEHOLDER_PATTERN_GLOBAL = new RegExp(
  BLANK_PLACEHOLDER_PATTERN.source,
  "gi",
);
const BLANK_PLACEHOLDER_ERROR =
  "For FILL_IN_THE_BLANKS, the question statement must include the {blank} placeholder.";

const MAX_ASSET_SIZE_BYTES = 100 * 1024 * 1024;
const SIZE_LIMITED_ASSET_TYPES = new Set(["audio", "video"]);
const ASSET_TYPE_LABELS = { audio: "Audio", video: "Video" };

const defaultOptions = [
  {
    optionKey: "A",
    optionValue: "Option 1",
    optionScore: 0,
  },
  {
    optionKey: "B",
    optionValue: "Option 2",
    optionScore: 0,
  },
  {
    optionKey: "C",
    optionValue: "Option 3",
    optionScore: 0,
  },
  {
    optionKey: "D",
    optionValue: "Option 4",
    optionScore: 0,
  },
];
const defaultAnswers = [
  {
    optionKey: "A",
    optionValue: "Answer 1",
  },
  {
    optionKey: "B",
    optionValue: "Answer 2",
  },
  {
    optionKey: "C",
    optionValue: "Answer 3",
  },
  {
    optionKey: "D",
    optionValue: "Answer 4",
  },
];

export default {
  name: "QuestionBankView",
  mixins: [isTableScrollableMixin],
  components: {
    Notification,
    BubbleLoader,
    UserNavMenu,
    FilterSearch,
    PassageSubQuestionAnswer,
  },
  data() {
    return {
      loadingQuestionsToDownload: false,
      tempOptions: new Map(),
      newFilteredQuestions: [],
      newQuestionCount: 0,
      notificationDialog: false,
      appliedFilter: false,
      uploadingQuestionsDialog: false,
      mainImage: true,
      editorConfig: {
        extraPlugins: "ckeditor_wiris",
      },
      editorConfigForOption: {
        extraPlugins: "ckeditor_wiris",
      },
      editorConfigForComment: {
        toolbar: [
          ['Bold', 'Italic', 'Underline', 'Strike'],
          ['FontColor', 'Highlight'],
          ['NumberedList', 'BulletedList'],
          ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
          ['SpecialChar'],
          ['Subscript', 'Superscript'],
          ['Link'],
          ['Image'],
        ],
      },
      editorConfigForPassage: {
        toolbar: [
          ['Bold', 'Italic', 'Underline', 'Strike'],
          ['FontColor'],
          ['Blockquote'],
          ['NumberedList', 'BulletedList'],
          ['SpecialChar'],
          ['Subscript', 'Superscript'],
          ['Link'],
          ['Image'],
        ],
      },
      bulkQuestionJsonData: [],
      filterData: false,
      windowHeight: window.innerHeight,
      dataTableOptions: {
        itemsPerPage:10,
        page:1
      },
      totalItems: 0,
      pageSize: 10,
      page: 1,
      count: 0,
      preSignedUrl: "",
      sortCol: "sanitizedQuestionStatement",
      sortOrder: "asc",
      selectedFile: null,
      questionAssetUrl: "NA",
      questionAssetType: null,
      uploadingForOption: false,
      groupName: null,
      tableData: [],
      isLoading: true,
      algoliaIndex: null,
      selectedLOs: [],
      selectedTags: null,
      LOData: [],
      checkData: {
        skills: [],
        levels: [],
        grades: [],
        subjects: [],
      },

      skills: [],
      search: this.$route.query.search || "",
      dLoading: false,
      editId: null,
      formbtnBool: false,
      suppressSharedFieldReset: false,
      subjectData: [],
      selectedAnswersForMultitpleTypeQuestions: [],
      searchLOs: "",
      searchSubjects: "",
      singleSelect: false,
      createQuestionDialog: false,
      deleteDialog: false,
      optionTextFieldDialog: false,
      editedOptionIndex: 0,
      editedAnswerIndex: 0,
      editedCkeditorValue: "",
      successDialog: false,
      deleteSuccessDialog: false,
      successMessage: "New Question Created",
      errorDialog: false,
      filterDialog: false,
      filterCount: 0,
      selectedTableItems: [],
      bulkQuestionUploadResponse: [],
      uploadingDialog: false,
      uploadingMsg: "File Uploading...",
      questionType: "",
      questionName: "",
      answerExplanation: "",
      filterVal: "",
      filterVal: "",
      removedQuestion: [],
      questionDescription: "NA",
      errorMessage: "",
      skill: 0,
      level: 0,
      searchBool: false,
      tag: "",
      correctAnswerScore: 0,
      bloomsTaxonomy: "",
      knowledgeLevel: "",
      complexityLevel: "",
      difficultyLevel: "",
      correctAnswer: "NA",
      hint: "",
      subjectShowBool: false,
      subject: null,
      proficiencyLevel: "",
      isCreatingQuestion: false,
      dummyLO: [{ name: "lO1_1" }, { name: "lO1_2" }, { name: "lO1_3" }],
      rules: {
        required: (value) => !!value || "Field is required",
      },
      options: [...defaultOptions],
      answers: [...defaultAnswers],
      headers: [
        {
          text: "ID",
          value: "questionId",
          cellClass: "w-auto",
          sortable: false,
        },
        {
          text: "Question",
          value: "questionStatement",
          cellClass: "Qw-40",
          sortable: false,
        },
        {
          text: "Type",
          value: "questionType",
          cellClass: "w-15",
          sortable: false,
        },
        { text: "Skills", value: "skill", cellClass: "w-15", sortable: false },
        {
          text: "Difficulty",
          value: "difficultyLevel",
          cellClass: "w-15",
          sortable: false,
        },
        {
          text: "Actions",
          value: "actions",
          cellClass: "w-10",
          sortable: false,
        },
      ],
      imagePreview: false,
      headersresponce: [
        { text: "Question Index in CSV", value: "questionIndex" },
        { text: "Status", value: "status" },
      ],
      questionTypeList: [
        "SINGLE_CHOICE",
        "MULTIPLE_CHOICE",
        "FILL_IN_THE_BLANKS",
        "TRUE_FALSE",
        "MATCH_THE_FOLLOWING",
        "PASSAGE_BASED",
      ],
      selectedQuestionTypeFilter: [],
      product: null,
      productOptions: ["MESTA", "SRS", "Hubble STAR", "LMS"],
      questionid: "",
      los: [],
      hrisUniqueRole: [],
      groupNames: [],
      isCaseSensitive: "No",
      marksAllotted: null,
      languageOfQuestion: "",
      languageOptions: ["English", "Hindi", "Marathi"],
      levels: [],
      levelsGrades: [],
      grades: [],
      gradesMappedToLevel: [],
      gradesTemp: [],
      singleSelectCorrectAnswer: null,
      trueFalseCorrectAnswer: null,
      selectedLevelFilter: [],
      difficultyLevels: ["EASY", "MEDIUM", "HARD"],
      selectedGradeFilter: [],
      selecteddifficultyLevelFilter: [],
      complexityLevels: ["P1", "P2", "P3", "P4", "P5"],
      selectedcomplexityLevelFilter: [],
      knowledgeLevels: ["MUST_KNOW", "SHOULD_KNOW", "NICE_TO_KNOW"],
      selectedknowlewdgeLevelFilter: [],
      bloomsTaxonomyLevel: [
        "REMEMBER",
        "UNDERSTAND",
        "APPLY",
        "ANALYSE",
        "ANALYZE",
        "EVALUATE",
        "CREATE",
      ],
      selectedbloomsTaxonomyLevelFilter: [],
      selectedskillsFilter: [],
      subjects: [],
      selectedsubjectsFilter: [],
      selectedlearningObjectives: [],
      tagsList: [],
      selectedtags: [],
      mtfAnswers: [
        {
          key: 1,
          value: "Answer 1",
          type: "TEXT",
        },
        {
          key: 2,
          value: "Answer 2",
          type: "TEXT",
        },
        {
          key: 3,
          value: "Answer 3",
          type: "TEXT",
        },
        {
          key: 4,
          value: "Answer 4",
          type: "TEXT",
        },
      ],
      preloader: false,
      debouncedSearch: null,
      grade: null,
      strand: null,
      subStrand: null,
      topic: null,
      setNumber: "",
      markingType: null,
      setNumbersList: ["1", "2", "3"],
      markingTypesList: ["Regular Marking", "Likert Marking"],
      questionAssetUrlForPreview: IMAGE_ALT_SRC,
      IMAGE_ALT_SRC,
      reportedQuestions: [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "This Week", value: "this_week" },
        { label: "Last Week", value: "last_week" },
        { label: "This Month", value: "this_month" },
        { label: "Last Month", value: "last_month" },
      ],
      selectedReportedQuestionsFilter: null,
      menu: false,
      menuStart: false,
      menuEnd: false,
      customStartDate: null,
      customEndDate: null,
      isCustomDate: false,
      isCustom: false,
      sendSelectedReportedQuestionsFilter: [],
      selectedSort: "questionAsc", // Default selected sort option
      sortOptions: [
        { value: "questionAsc", label: "Question - Ascending (A-Z)" },
        { value: "questionDesc", label: "Question - Descending (Z-A)" },
        { value: "dateNewest", label: "Date - Newest" },
        { value: "dateOldest", label: "Date - Oldest" },
      ],
      // typeOfAudience: null,
      // typeOfAudienceOptions: [{ name: "Student" }, { name: "Teacher" }, { name: "Both" }],
      authoredBy: null,
      authoredByOptions: [
      { name: "HubbleHox", value: "HubbleHox" },
        { name: "Vendor Acquired", value: "Vendor Acquired" },
        {
          name: "Acquired from Publications",
          value: "Acquired from Publications",
        },
        { name: "Acquired From Book", value: "Acquired From Book" },
        { name: "Practice guide", value: "Practice guide" },
        { name: "Vertex", value: "Vertex" },
        { name: "Ampersand", value: "Ampersand" },
      ],
      // --- Passage Based Question fields ---
      questionStatement: "",
      passageCustomer: null,
      customerOptions: ["vgos","svkm"], // placeholder — no existing source in the app, adjust as needed
      numberOfQuestions: 1,
      passageSubQuestions: [],
      passageSubQuestionPanels: [],
      // Add a map to track questionId-language combinations
      questionIdLanguageCombos: new Map(),
      questionIdError: "",
      // questionIdRules: [
      //   v => !!v || 'Question ID is required',
      //   v => this.validateQuestionId(v) || 'Question ID must include the product prefix'
      // ],
      selectedLhsForMtfTypeQuestions: [],
      selectedRhsForMtfTypeQuestions: [],
      answerTextFieldDialog: false,
      selectedQuestionAssetUrlFilter: [],
      hasEquationFilter: [],
      mediaTypes: [],
      equationTypes: [],
      subjectSearch: "",
      uploadImageIcon: require("@/assets/uploadImage.svg"),
      deleteOptionIcon: require("@/assets/delete-noir.svg"),
      optionScoreDialog: false,
      updateCommentDialog: false,
      updateComment: "",
      selectedOptionIndex: 0,
      optionScoreInput: 0,
      filters: {},
      filterQuestionTypeList: [],
      filterKnowledgeLevels: [],
      filterBloomsTaxonomyLevel: [],
      filterLevels: [],
      filterGrades: [],
      filterSkills: [],
      filterSubjects: [],
      filterDifficultyLevels: [],
      filterComplexityLevels: [],
      levelGradeMap: [],
      questionHistoryDialog: false,
      questionHistory: {},
      questionHistoryLoading: false,
      historyResolvedAssetUrl: null,
      historyImageLoading: false,
      selectedQuestionHistoryVersionId: null,
      originalQuestionFormData: null,
      collapsedHistoryTimelineGroups: {},
      historySubQuestionPanels: [],
      examModeDialog: false,
      examModeQuestion: null,
      examModeSelectedOption: null,
      examModeSelectedOptions: [],
      examModeFillAnswer: '',
      examModeResolvedAssetUrl: null,
      examModeResolvedOptions: [],
      examModeImageLoading: false,
      examModeIsScrollable: false,
      examModeExpandDialog: false,
      passageMaxWords : 500,
    };
  },
  watch: {
    questionType(newVal, oldVal) {
      if (this.suppressSharedFieldReset) return;
      // Crossing the Passage <-> regular-type boundary (either direction): the shared
      // metadata fields (Skill, Grade, Subject, etc.) are reused between the passage-level
      // card and the regular single-question card. Reset them so values filled on one side
      // don't carry over to the other.
      const wasPassage = oldVal === 'PASSAGE_BASED';
      const isPassage = newVal === 'PASSAGE_BASED';
      if (wasPassage !== isPassage) {
        this.product = null;
        this.skill = 0;
        this.setNumber = "";
        this.level = 0;
        this.grade = null;
        this.subject = null;
        this.selectedHrisRoles = [];
        this.languageOfQuestion = "";
        this.difficultyLevel = "";
        this.authoredBy = null;
        this.groupName = null;
      }
    },
    createQuestionDialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.form?.resetValidation();
          this.isFormValid = false;
        });
      }
    },
    numberOfQuestions(newVal) {
      if (this.questionType !== 'PASSAGE_BASED') return;
      const n = Math.min(5, Math.max(0, parseInt(newVal, 10) || 0));
      if (n === this.passageSubQuestions.length) return;
      if (n > this.passageSubQuestions.length) {
        const toAdd = n - this.passageSubQuestions.length;
        for (let i = 0; i < toAdd; i++) {
          this.passageSubQuestions.push(this.createEmptyPassageSubQuestion());
        }
      } else {
        this.passageSubQuestions.splice(n);
        this.passageSubQuestionPanels = this.passageSubQuestionPanels.filter((i) => i < n);
      }
    },
    selectedLevelFilter(newLevel) {
      this.filterGrades = [
        ...new Set(
          newLevel.flatMap((level) => this.levelGradeMap[level] || []),
        ),
      ];
    },
    dataTableOptions: {
      handler() {
        this.pageSize = this.dataTableOptions.itemsPerPage;
        this.page = this.dataTableOptions.page;

        this.getNewQuestionsData();
      },
      deep: true,
    },

    search(newValue) {
      console.log("search Val :", newValue);
      if (newValue === null) this.search = "";
      this.dataTableOptions.page = 1;
      this.debouncedSearch();
    },

    tag(newValue) {
      console.log(newValue.indexOf(","));
      if (newValue.indexOf(",") != -1) {
        var temp = newValue.split(",")[0];
        if (temp != "") {
          this.tagsList.push(temp);
        }
        this.tag = "";
        console.log("value inside", this.tag);
      }
      console.log("index value", newValue.indexOf(","));
      console.log("outside", this.tag);
    },
    //   selectedLevelFilter: {
    //  handler(newValue, oldValue) {
    //   console.log("selectedLevelFilter", newValue);

    //   // Handle additions
    //   newValue.forEach(levelName => {
    //     if (!oldValue.includes(levelName)) {
    //       const newLevel = this.levelsGrades.find(level => level.name === levelName);
    //       if (newLevel && newLevel.grades) {
    //         this.gradesTemp = [...new Set([...this.gradesTemp, ...newLevel.grades])];
    //       }
    //     }
    //   });
    //   // Handle removals
    //   oldValue.forEach(levelName => {
    //     if (!newValue.includes(levelName)) {
    //       const removedLevel = this.levelsGrades.find(level => level.name === levelName);
    //       if (removedLevel && removedLevel.grades) {
    //         this.gradesTemp = this.gradesTemp.filter(grade =>
    //           newValue.some(selectedLevelName => {
    //             const level = this.levelsGrades.find(l => l.name === selectedLevelName);
    //             return level && level.grades.includes(grade);
    //           })
    //         );
    //       }
    //     }
    //   });
    //   this.gradesTemp.sort();
    //   // Reseting subject and grade filter when new level is selected
    //   this.selectedGradeFilter = [];
    //   this.selectedsubjectsFilter = [];
    //   this.subjectSearch = ""
    //  }
    // },

    selectedGradeFilter(newVal) {
      // Reseting subject filter when new grade is selected
      this.selectedsubjectsFilter = [];
      this.subjectSearch = "";
    },
  },
  mounted() {
    console.log('this.$store.state.role',this.$store.state)
    this.getMasterFilters();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    if (this.$store.state.role.createdOn == undefined) {
      this.logout();
      if (this.$store.state.role.createdOn == undefined) {
        this.logout();
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    markingTypesListItems() {
      return [
        { name: 'Regular Marking', disabled: false },
        { name: 'Likert Marking', disabled: this.questionType === 'FILL_IN_THE_BLANKS' },
      ];
    },
    blankPlaceholderError() {
      return BLANK_PLACEHOLDER_ERROR;
    },
    isPassageTooLong() {
      if (this.questionType !== PASSAGE_BASED_QUESTION_TYPE) return false;
      return this.countWords(this.questionStatement || "") > this.passageMaxWords;
    },
    isBlankPlaceholderMissing() {
      if (this.questionType === "PASSAGE_BASED") {
        return this.passageSubQuestions.some((sub) =>
          this.isBlankMissing(sub.questionType, sub.questionDescription),
        );
      }
      // Only flag once something has been typed: editItem fills the editor 2s
      // after opening, and "Question is required" already covers the empty case.
      return (
        !!this.questionName &&
        this.isBlankMissing(this.questionType, this.questionName)
      );
    },
    subQuestionTypeList() {
      return this.questionTypeList.filter((t) => t !== 'PASSAGE_BASED');
    },
    isCreateFormReady() {
      const answerValid = (() => {
        if (this.questionType === 'SINGLE_CHOICE') return !!this.singleSelectCorrectAnswer;
        if (this.questionType === 'TRUE_FALSE') return !!this.trueFalseCorrectAnswer;
        if (this.questionType === 'FILL_IN_THE_BLANKS') return !!this.correctAnswer;
        if (this.questionType === 'MULTIPLE_CHOICE') return this.selectedAnswersForMultitpleTypeQuestions?.length > 0;
        return true;
      })();

      if (this.questionType === 'PASSAGE_BASED') {
        const passageTextValid = !!this.getTextWithoutHTMLTags(this.questionStatement || '').trim() && !this.isPassageTooLong;
        const countValid = Number.isInteger(this.numberOfQuestions) && this.numberOfQuestions > 0
          && this.passageSubQuestions.length === this.numberOfQuestions;
        const subQuestionsValid = this.passageSubQuestions.length > 0 && this.passageSubQuestions.every((q) =>
          !!q.questionType && !!q.markingType &&
          q.correctAnswerScore !== null && q.correctAnswerScore !== '' && !isNaN(q.correctAnswerScore) &&
          !!q.answerPayload?.isValid
        );
        return !!(
          passageTextValid &&
          countValid &&
          subQuestionsValid &&
          this.product &&
          this.skill &&
          this.level &&
          (this.currentSkill?.isGradeNotApplicable || this.grade) &&
          (this.currentSkill?.isSetNumberNotApplicable || this.setNumber) &&
          this.difficultyLevel &&
          this.groupName
        );
      }

      return !!(
        this.questionType &&
        this.questionName &&
        this.markingType &&
        this.product &&
        this.skill &&
        this.level &&
        (this.currentSkill?.isGradeNotApplicable || this.grade) &&
        (this.currentSkill?.isSetNumberNotApplicable || this.setNumber) &&
        this.difficultyLevel &&
        this.groupName &&
        answerValid
      );
    },
    isEditQuestionContentPresent() {
      return this.questionType === 'PASSAGE_BASED' ? !!this.questionStatement : !!this.questionName;
    },
    isQuestionFormDirty() {
      if (!this.formbtnBool || !this.originalQuestionFormData) return true;
      if (!this.isEditQuestionContentPresent) return false;
      const current = this.buildQuestionUpdatePayload();
      const changed = this.getChangedQuestionFields(current, this.originalQuestionFormData);
      return Object.keys(changed).length > 0;
    },
    isValid() {
      return (
        this.getTextWithoutHTMLTags(this.editedCkeditorValue).length <= 200
      );
    },
    getHeight() {
      return this.windowHeight;
    },
    getFilterableSubjects() {
      let originalSubjects = this.filterSubjects;
      let filteredSubjects = [...originalSubjects];

      if (this.selectedGradeFilter.length > 0) {
        let filterableSubjects = [];
        this.grades.forEach((grade) => {
          if (this.selectedGradeFilter.includes(grade.name)) {
            filterableSubjects = [...filterableSubjects, ...grade.subjects];
          }
        });
        filteredSubjects = originalSubjects.filter((subject) =>
          filterableSubjects.includes(subject),
        );
      }

      if (this.selectedLevelFilter.length > 0) {
        let grades = [];
        this.levels.forEach((level) => {
          if (this.selectedLevelFilter.includes(level.name)) {
            grades = [...grades, ...level.grades];
          }
        });

        let filterableSubjects = [];
        this.grades.forEach((grade) => {
          if (grades.includes(grade.name)) {
            filterableSubjects = [...filterableSubjects, ...grade.subjects];
          }
        });

        filteredSubjects = originalSubjects.filter((subject) =>
          filterableSubjects.includes(subject),
        );
      }

      if (this.subjectSearch) {
        const searchText = this.subjectSearch.trim().toLowerCase();
        filteredSubjects = searchText
          ? filteredSubjects.filter((subject) =>
              subject.name.toLowerCase().includes(searchText),
            )
          : filteredSubjects;
      }

      return filteredSubjects;
    },
    currentSkill() {
      return this.skills.find(({ name }) => name === this.skill);
    },
    questionHistoryVersions() {
      const rawVersions = this.questionHistory?.versions;
      console.log('rawVersions',rawVersions)
      const versions = Array.isArray(rawVersions)
        ? rawVersions
        : rawVersions && typeof rawVersions === "object"
          ? Object.entries(rawVersions).map(([versionId, value]) => ({
              version: value?.version || versionId,
              ...value,
            }))
          : [];

      return [...versions]
        .filter((item) => item && (item.version || item.updatedOn))
        .sort((first, second) => {
          const firstTime = this.getHistoryTimestampValue(first.updatedOn);
          const secondTime = this.getHistoryTimestampValue(second.updatedOn);
          return secondTime - firstTime;
        })
        .map((item, index) => ({
          ...item,
          timelineIndex: index,
        }));
    },
    questionHistoryTimeline() {
      return this.questionHistoryVersions.reduce((groups, item) => {
        const dateLabel = this.formatHistoryDate(item.updatedOn);
        const existingGroup = groups.find((group) => group.dateLabel === dateLabel);

        if (existingGroup) {
          existingGroup.items.push(item);
          return groups;
        }

        groups.push({
          dateLabel,
          items: [item],
        });

        return groups;
      }, []);
    },
    selectedQuestionHistoryVersion() {
      if (!this.selectedQuestionHistoryVersionId) {
        return this.questionHistoryVersions[0] || null;
      }

      return (
        this.questionHistoryVersions.find(
          ({ version }) => version === this.selectedQuestionHistoryVersionId,
        ) || this.questionHistoryVersions[0] || null
      );
    },
    historyMatchingPairs() {
      const correctAnswer = this.activeQuestionHistory?.correctAnswer;
      if (!correctAnswer || typeof correctAnswer !== "string") return [];
      const decodeHtmlEntities = (str) => {
        const el = document.createElement('textarea');
        el.innerHTML = str;
        return el.value;
      };
      return correctAnswer.split(",").map((pair) => {
        const colonIndex = pair.indexOf(":");
        if (colonIndex === -1) return null;
        return {
          item: decodeHtmlEntities(pair.slice(0, colonIndex).trim()),
          match: decodeHtmlEntities(pair.slice(colonIndex + 1).trim()),
        };
      }).filter(Boolean);
    },
    examModeActiveSubQuestion() {
      if (this.examModeQuestion?.questionType !== 'PASSAGE_BASED') return null;
      return (this.examModeQuestion.subQuestions || [])[0] || null;
    },
    examModeActiveQuestionType() {
      return this.examModeActiveSubQuestion
        ? this.examModeActiveSubQuestion.questionType
        : this.examModeQuestion?.questionType;
    },
    examModeMtfPairs() {
      const source = this.examModeActiveSubQuestion || this.examModeQuestion;
      if (!source) return [];
      if (Array.isArray(source.mtfOptions) && source.mtfOptions.length) {
        return source.mtfOptions.map(o => ({ key: o.key, value: o.value }));
      }
      const correctAnswer = source.correctAnswer;
      if (!correctAnswer || typeof correctAnswer !== 'string') return [];
      const pairs = correctAnswer.split(', ').map(pair => {
        const colonIdx = pair.indexOf(':');
        if (colonIdx === -1) return null;
        return { key: pair.slice(0, colonIdx).trim(), value: pair.slice(colonIdx + 1).trim() };
      }).filter(Boolean);
      const values = pairs.map(p => p.value).sort(() => Math.random() - 0.5);
      return pairs.map((p, i) => ({ key: p.key, value: values[i] }));
    },
    activeQuestionHistory() {
      const selectedSnapshot = this.selectedQuestionHistoryVersion?.snapshot;

      if (!selectedSnapshot || typeof selectedSnapshot !== "object") {
        return this.questionHistory;
      }

      return {
        ...this.questionHistory,
        ...selectedSnapshot,
      };
    },
    activeQuestionHistoryChangedFields() {
      return Array.isArray(this.selectedQuestionHistoryVersion?.changedFields)
        ? this.selectedQuestionHistoryVersion.changedFields
        : [];
    },
    previousActiveQuestionHistory() {
      const selected = this.selectedQuestionHistoryVersion;
      if (!selected) return null;

      const versions = this.questionHistoryVersions;
      const selectedIndex = versions.findIndex(({ version }) => version === selected.version);
      const previousVersion = selectedIndex > -1 ? versions[selectedIndex + 1] : null;
      const previousSnapshot = previousVersion?.snapshot;

      if (!previousSnapshot || typeof previousSnapshot !== "object") return null;

      return {
        ...this.questionHistory,
        ...previousSnapshot,
      };
    },
  },
  methods: {
    async viewExamMode(question) {
      this.examModeQuestion = question;
      this.examModeSelectedOption = null;
      this.examModeFillAnswer = '';
      this.examModeResolvedAssetUrl = null;
      this.examModeImageLoading = false;
      this.examModeIsScrollable = false;
      this.examModeExpandDialog = false;
      const isPassage = question.questionType === 'PASSAGE_BASED';
      this.examModeResolvedOptions = JSON.parse(JSON.stringify(
        (isPassage ? question.subQuestions?.[0]?.questionOptions : question.questionOptions) || [],
      ));
      this.examModeDialog = true;

      // Sub-questions (and the passage itself) carry no asset field — only regular
      // questions have questionAssetUrl/image options to resolve.
      if (!isPassage) {
        const assetUrl = question.questionAssetUrl;
        if (assetUrl && assetUrl !== 'NA') {
          this.examModeResolvedAssetUrl = await this.resolveDriveUrl(assetUrl);
        }

        for (let i = 0; i < this.examModeResolvedOptions.length; i++) {
          const val = this.examModeResolvedOptions[i].optionValue;
          if (val && /^https?:\/\//i.test(val)) {
            this.examModeResolvedOptions[i] = {
              ...this.examModeResolvedOptions[i],
              optionValue: await this.resolveDriveUrl(val),
            };
          }
        }
      }
    },
    assetMediaKind(assetType) {
      if (!assetType) return 'image';
      switch (assetType) {
        case 'audio': return 'audio';
        case 'video': return 'video';
        default: return 'image';
      }
    },
    onExamModeImageLoad() {
      this.examModeImageLoading = false;
      this.$nextTick(() => {
        const el = this.$refs.examModeContent;
        if (el) {
          this.examModeIsScrollable = el.scrollHeight > el.clientHeight;
        }
      });
    },
    async viewHistory(question) {
      this.questionHistoryDialog = true;
      this.questionHistoryLoading = true;
      this.selectedQuestionHistoryVersionId = null;
      this.collapsedHistoryTimelineGroups = {};
      this.historySubQuestionPanels = [];
      this.historyResolvedAssetUrl = null;
      this.historyImageLoading = false;
      this.questionHistory = {
        ...question,
        versions: Array.isArray(question?.versions) ? question.versions : [],
      };

      try {
        console.log('question',question)
        const response = await QuestionsController.getQuestionByQuestionId(
          question.id,
        );

        if (response?.status === 200) {
          const historyQuestion =
            response.data?.data?.question ||
            response.data?.question ||
            response.data?.data ||
            response.data;

          this.questionHistory = historyQuestion || this.questionHistory;

          const rawVersions = this.questionHistory?.versions;
          const fetchedVersions = Array.isArray(rawVersions)
            ? rawVersions
            : rawVersions && typeof rawVersions === "object"
              ? Object.entries(rawVersions).map(([versionId, value]) => ({
                  version: value?.version || versionId,
                  ...value,
                }))
              : [];

          if (fetchedVersions.length) {
            this.selectedQuestionHistoryVersionId =
              fetchedVersions
                .filter((item) => item && (item.version || item.updatedOn))
                .sort(
                  (first, second) =>
                    this.getHistoryTimestampValue(second.updatedOn) -
                    this.getHistoryTimestampValue(first.updatedOn),
                )[0]?.version || null;
          }
        }
      } catch (error) {
        console.error("Error fetching question history:", error);
      } finally {
        this.initializeHistoryTimelineGroups();
        this.historySubQuestionPanels = this.getChangedSubQuestionIndices();
        this.questionHistoryLoading = false;
      }

      if (this.questionHistory?.questionAssetUrl && this.questionHistory.questionAssetUrl !== 'NA') {
        this.historyImageLoading = true;
        this.historyResolvedAssetUrl = await this.resolveDriveUrl(this.questionHistory.questionAssetUrl);
        this.historyImageLoading = false;
      }
    },
    async getAudienceRoleGroups() {
      const response = await AudienceRolesController.getAudienceRoleGroups();
      if (response.status == 200) {
        this.groupNames = response.data.audienceRoleGroup.map(
          ({ name }) => name,
        );
      }
    },
    formatQuestionType(str) {
      if (!str) return "";
      return str
        .replace(/_/g, " ") // remove underscores
        .toLowerCase() // convert to lowercase
        .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize each word
    },
    formatQuestionStatementForDisplay(statement) {
      if (!statement) return statement;
      return statement.replace(BLANK_PLACEHOLDER_PATTERN_GLOBAL, "__________");
    },
    isBlankMissing(questionType, statement) {
      return (
        questionType === "FILL_IN_THE_BLANKS" &&
        !BLANK_PLACEHOLDER_PATTERN.test(this.sanitizedQuestion(statement))
      );
    },
    blockIfBlankPlaceholderMissing() {
      if (!this.isBlankPlaceholderMissing) return false;
      this.errorMessage = BLANK_PLACEHOLDER_ERROR;
      this.errorDialog = true;
      return true;
    },
    getHistoryTimestampValue(value) {
      if (!value) return 0;
      if (typeof value === "string" || value instanceof Date) {
        const time = new Date(value).getTime();
        return Number.isNaN(time) ? 0 : time;
      }
      if (typeof value === "object" && typeof value._seconds === "number") {
        const seconds = value._seconds * 1000;
        const nanos = typeof value._nanoseconds === "number"
          ? Math.floor(value._nanoseconds / 1000000)
          : 0;
        return seconds + nanos;
      }
      const time = new Date(value).getTime();
      return Number.isNaN(time) ? 0 : time;
    },
    formatHistoryDate(dateString) {
      const timestamp = this.getHistoryTimestampValue(dateString);
      if (!timestamp) return "NA";
      return format(new Date(timestamp), "dd/MM/yyyy");
    },
    formatHistoryTime(dateString) {
      const timestamp = this.getHistoryTimestampValue(dateString);
      if (!timestamp) return "NA";
      return format(new Date(timestamp), "hh:mma").toLowerCase();
    },
    getHistoryChangeLabel(historyItem) {
      const changeCount = Array.isArray(historyItem?.changedFields)
        ? historyItem.changedFields.length
        : 0;
      return `${changeCount} Change${changeCount === 1 ? "" : "s"}`;
    },
    isCurrentHistoryVersion(historyItem) {
      return historyItem?.timelineIndex === 0;
    },
    isSelectedHistoryVersion(historyItem) {
      if (!historyItem) return false;
      if (!this.selectedQuestionHistoryVersionId) {
        return historyItem.timelineIndex === 0;
      }
      return historyItem.version === this.selectedQuestionHistoryVersionId;
    },
    selectHistoryVersion(historyItem) {
      this.selectedQuestionHistoryVersionId = historyItem?.version || null;
      this.historySubQuestionPanels = this.getChangedSubQuestionIndices();
    },
    isHistoryFieldChanged(fieldName) {
      return this.activeQuestionHistoryChangedFields.includes(fieldName);
    },
    getHistoryFieldBlockClass(fieldName) {
      return {
        'question-history-field-block--changed': this.isHistoryFieldChanged(fieldName),
      };
    },
    isHistoryTimelineGroupCollapsed(dateLabel) {
      return Boolean(this.collapsedHistoryTimelineGroups[dateLabel]);
    },
    toggleHistoryTimelineGroup(dateLabel) {
      this.collapsedHistoryTimelineGroups = {
        ...this.collapsedHistoryTimelineGroups,
        [dateLabel]: !this.isHistoryTimelineGroupCollapsed(dateLabel),
      };
    },
    initializeHistoryTimelineGroups() {
      this.collapsedHistoryTimelineGroups = this.questionHistoryTimeline.reduce(
        (groups, group) => {
          groups[group.dateLabel] = false;
          return groups;
        },
        {},
      );
    },
    getHistoryCorrectAnswerKeys() {
      const correctAnswer = this.activeQuestionHistory?.correctAnswer;

      if (Array.isArray(correctAnswer)) {
        return correctAnswer
          .map((value) => String(value).trim())
          .filter(Boolean);
      }

      if (typeof correctAnswer === "string") {
        return correctAnswer
          .split(",")
          .map((value) => value.trim())
          .filter(Boolean);
      }

      if (correctAnswer === null || correctAnswer === undefined || correctAnswer === "NA") {
        return [];
      }

      return [String(correctAnswer).trim()].filter(Boolean);
    },
    isHistoryCorrectOption(option) {
      const optionKey = option?.optionKey ? String(option.optionKey).trim() : "";
      if (!optionKey) return false;

      return this.getHistoryCorrectAnswerKeys().includes(optionKey);
    },
    toggleHistorySubQuestionPanels(expand) {
      this.historySubQuestionPanels = expand
        ? [...Array((this.activeQuestionHistory.subQuestions || []).length).keys()]
        : [];
    },
    getSubQuestionChangedFields(index) {
      if (!this.activeQuestionHistoryChangedFields.includes('subQuestions')) return [];

      const previous = this.previousActiveQuestionHistory;
      if (!previous) return [];

      const currentSub = (this.activeQuestionHistory.subQuestions || [])[index];
      const previousSub = (previous.subQuestions || [])[index];
      if (!currentSub) return [];
      // Sub-question wasn't there before — nothing to diff against, so nothing to
      // call out field-by-field (the panel gets auto-opened regardless, see
      // getChangedSubQuestionIndices).
      if (!previousSub) return [];

      const isMTF = currentSub.questionType === 'MATCH_THE_FOLLOWING';
      const keys = new Set([...Object.keys(currentSub), ...Object.keys(previousSub)]);
      const changed = [];

      keys.forEach((key) => {
        // Same MTF-noise exclusion as the top-level diff (Math.random() shuffle in
        // prepareOptions() makes mtfOptions/questionOptions unreliable to compare).
        if (key === 'mtfOptions') return;
        if (isMTF && key === 'questionOptions') return;

        if (JSON.stringify(currentSub[key]) !== JSON.stringify(previousSub[key])) {
          changed.push(key);
        }
      });

      return changed;
    },
    getSubQuestionFieldBlockClass(index, fieldName) {
      return {
        'question-history-field-block--changed': this.getSubQuestionChangedFields(index).includes(fieldName),
      };
    },
    getChangedSubQuestionIndices() {
      if (!this.activeQuestionHistoryChangedFields.includes('subQuestions')) return [];

      const currentSubQuestions = this.activeQuestionHistory.subQuestions || [];
      const previousSubQuestions = this.previousActiveQuestionHistory?.subQuestions || [];

      return currentSubQuestions
        .map((_, index) => index)
        .filter((index) => index >= previousSubQuestions.length || this.getSubQuestionChangedFields(index).length > 0);
    },
    getSubQuestionCorrectAnswerKeys(subQuestion) {
      const correctAnswer = subQuestion?.correctAnswer;

      if (Array.isArray(correctAnswer)) {
        return correctAnswer.map((value) => String(value).trim()).filter(Boolean);
      }

      if (typeof correctAnswer === "string") {
        return correctAnswer.split(",").map((value) => value.trim()).filter(Boolean);
      }

      if (correctAnswer === null || correctAnswer === undefined) {
        return [];
      }

      return [String(correctAnswer).trim()].filter(Boolean);
    },
    isSubQuestionCorrectOption(subQuestion, option) {
      const optionKey = option?.optionKey ? String(option.optionKey).trim() : "";
      return optionKey ? this.getSubQuestionCorrectAnswerKeys(subQuestion).includes(optionKey) : false;
    },
    getSubQuestionResolvedOptions(subQuestion) {
      return Array.isArray(subQuestion?.questionOptions) ? subQuestion.questionOptions : [];
    },
    getSubQuestionMatchingPairs(subQuestion) {
      const correctAnswer = subQuestion?.correctAnswer;
      if (!correctAnswer || typeof correctAnswer !== "string") return [];
      return correctAnswer.split(",").map((pair) => {
        const colonIndex = pair.indexOf(":");
        if (colonIndex === -1) return null;
        return {
          item: pair.slice(0, colonIndex).trim(),
          match: pair.slice(colonIndex + 1).trim(),
        };
      }).filter(Boolean);
    },
    getDisplayValue(value) {
      if (Array.isArray(value)) {
        return value.length ? value.join(", ") : "NA";
      }

      return value || "NA";
    },
    async getMasterFilters() {
      console.log("questions");
      const docId = "questions";
      try {
        const response = await QuestionsController.getMasterFilters(docId);
        this.filterQuestionTypeList = response.data.questionType;
        this.filterKnowledgeLevels = response.data.knowledgeLevel;
        this.filterBloomsTaxonomyLevel = response.data.bloomsTaxonomyLevel;
        this.levelGradeMap = response.data.levelGradeMap;
        this.filterLevels = Object.keys(this.levelGradeMap);
        // this.filterGrades = response.data.grade
        this.filterComplexityLevels = response.data.complexityLevel;
        this.filterSubjects = response.data.subjects;
        this.filterSkills = response.data.skills;
        this.filterDifficultyLevels = response.data.difficultyLevel;
        this.equationTypes = response.data.equationTypes;
        this.mediaTypes = response.data.mediaTypes;
      } catch (error) {
        return error.response;
      }
    },
    addCustomDates() {
      this.isCustomDate = true;

      if (this.customStartDate && this.customEndDate) {
        this.sendSelectedReportedQuestionsFilter = {
          start: format(new Date(this.customStartDate), "yyyy-MM-dd 00:00:00"),
          end: format(new Date(this.customEndDate), "yyyy-MM-dd 23:59:59"),
        };
        this.menu = false;
      }
    },
    onEditorReady(editor) {
      editor.on("afterCommandExec", function (event) {
        var commandName = event.data.name;
        if (
          [
            "ckeditor_wiris_openFormulaEditor",
            "ckeditor_wiris_openFormulaEditorChemistry",
          ].includes(commandName)
        ) {
          setTimeout(() => {
            const wiris_license_overlays =
              document.querySelectorAll(".wrs_tickContainer");
            wiris_license_overlays.forEach((element) => {
              element.remove();
            });
          }, 2000);
        }
      });
    },
    resolveImageUrl(url) {
      if (!url || url === 'NA') return url;
      const driveMatch = url.match(/drive\.google\.com\/file\/d\/([^/?]+)/);
      if (driveMatch) {
        return `https://drive.google.com/uc?export=view&id=${driveMatch[1]}`;
      }
      return url;
    },
    isImageOption(value) {
      if (!value) return false;
      return /^(https?:\/\/|blob:)/i.test(value.trim());
    },
    formatOptionValue(value) {
      if (!value) return 'NA';
      if (this.isImageOption(value)) {
        return `<img src="${this.resolveImageUrl(value.trim())}" style="max-width:200px; max-height:150px; object-fit:contain;" />`;
      }
      return value;
    },
    restorePrevValue(index) {
      this.options[index].optionValue = this.tempOptions.get(index);
    },
    stopAllAudio() {
      document.querySelectorAll('audio, video').forEach(media => {
        media.pause();
        media.currentTime = 0;
      });
    },
    closeChip() {
      this.mainImage = false;
      this.questionAssetUrl = "NA";
    },
    openImagePreviewDialog() {
      this.imagePreview = true;
    },
    async downloadFile() {
      let fileName = "Hubble STAR - Question Bank Sample File.csv";
      try {
        const response = await axios.get(
          `https://firebasestorage.googleapis.com/v0/b/vgos-sss-stag.appspot.com/o/question_bank%2F${fileName}?alt=media`,
          {
            responseType: "blob", // Important
          },
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    },
    getDateRange() {
      switch (this.selectedReportedQuestionsFilter) {
        case "today":
          this.sendSelectedReportedQuestionsFilter = {
            start: format(startOfToday(), "yyyy-MM-dd 00:00:00"),
            end: format(endOfToday(), "yyyy-MM-dd 23:59:59"),
          };
          break;
        case "yesterday":
          this.sendSelectedReportedQuestionsFilter = {
            start: format(startOfYesterday(), "yyyy-MM-dd 00:00:00"),
            end: format(endOfYesterday(), "yyyy-MM-dd 23:59:59"),
          };
          break;
        case "this_week":
          this.sendSelectedReportedQuestionsFilter = {
            start: format(
              startOfWeek(new Date(), { weekStartsOn: 1 }),
              "yyyy-MM-dd 00:00:00",
            ),
            end: format(
              endOfWeek(new Date(), { weekStartsOn: 1 }),
              "yyyy-MM-dd 23:59:59",
            ),
          };
          break;
        case "last_week":
          const lastWeekDate = new Date(
            new Date().setDate(new Date().getDate() - 7),
          );
          this.sendSelectedReportedQuestionsFilter = {
            start: format(
              startOfWeek(lastWeekDate, { weekStartsOn: 1 }),
              "yyyy-MM-dd 00:00:00",
            ),
            end: format(
              endOfWeek(lastWeekDate, { weekStartsOn: 1 }),
              "yyyy-MM-dd 23:59:59",
            ),
          };
          break;
        case "this_month":
          this.sendSelectedReportedQuestionsFilter = {
            start: format(startOfMonth(new Date()), "yyyy-MM-dd 00:00:00"),
            end: format(endOfMonth(new Date()), "yyyy-MM-dd 23:59:59"),
          };
          break;
        case "last_month":
          const lastMonthDate = new Date(
            new Date().setMonth(new Date().getMonth() - 1),
          );
          this.sendSelectedReportedQuestionsFilter = {
            start: format(startOfMonth(lastMonthDate), "yyyy-MM-dd 00:00:00"),
            end: format(endOfMonth(lastMonthDate), "yyyy-MM-dd 23:59:59"),
          };
          break;
        default:
          this.sendSelectedReportedQuestionsFilter = [];
          break;
      }
    },
    async onFooterUpdate(newOptions) {
      Object.assign(this.dataTableOptions, newOptions);
      await this.$nextTick();
      this.getNewQuestionsData();
    },
    async getNewQuestionsData() {
      if (!this.isCustomDate) {
        this.getDateRange();
      }
      try {
        this.isLoading = true;
        this.newQuestionCount = 0;
        this.newFilteredQuestions = [];
        if (this.filterCount > 0) {
          this.selectedSort = "questionAsc";
          this.sortCol = "sanitizedQuestionStatement";
          this.sortOrder = "asc";
        }
        const params = {
          pgNum: this.page,
          sortCol: this.sortCol,
          sortOrder: this.sortOrder,
          itemsPerPage: this.pageSize,
          searchQuery: this.search,
          questionType: Array.isArray(this.selectedQuestionTypeFilter)
            ? this.selectedQuestionTypeFilter.join(",")
            : this.selectedQuestionTypeFilter,
          level: this.selectedLevelFilter.join(","),
          grades: this.selectedGradeFilter.join(","),
          difficultyLevel: this.selecteddifficultyLevelFilter.join(","),
          complexityLevel: this.selectedcomplexityLevelFilter.join(","),
          knowledgeLevel: this.selectedknowlewdgeLevelFilter.join(","),
          taxonomyLevel: this.selectedbloomsTaxonomyLevelFilter.join(","),
          skill: this.selectedskillsFilter.join(","),
          subject: this.selectedsubjectsFilter.join(","),
          reportedQuestion: JSON.stringify(
            this.sendSelectedReportedQuestionsFilter || [],
          ),
          questionAssetType: this.selectedQuestionAssetUrlFilter.join(","),
          hasEquation: this.hasEquationFilter.join(","),
        };

        const query = "?" + new URLSearchParams(params).toString();

        const res = await QuestionsController.getFilteredQuestions(query);

        if (res.flag) {
          this.newFilteredQuestions = res.data.questions;
          this.newQuestionCount = res.data.totalQuestions;
          this.isLoading = false;
          this.preloader = false;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
      this.updateUrlParams();
    },
    convertOptionsToArray(options) {
      let result = {};
      options?.forEach((option, index) => {
        const optionIndex = index + 1;
        result[`optionValue${optionIndex}`] = option.optionValue;
        result[`optionKey${optionIndex}`] = option.optionKey;
      });
      return result;
    },
    async exportQuestions(csvData, fileName) {
      const csv = Papa.unparse(csvData, {
        quotes: true, // or array of booleans
        quoteChar: '"',
        escapeChar: '"',
      });

      const bom = "\uFEFF";
      const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      this.loadingQuestionsToDownload = false;
    },
    formatDate(dateString) {
      return format(new Date(dateString), "dd/MM/yyyy");
    },
    async downloadQuestions() {
      const sanitizedSearch = this.search.replace(/'/g, "&#39;");
      this.loadingQuestionsToDownload = true;
      const params = {
        pgNum: this.page,
        sortCol: this.sortCol,
        sortOrder: this.sortOrder,
        itemsPerPage: this.pageSize,
        searchQuery: sanitizedSearch,
        questionType: Array.isArray(this.selectedQuestionTypeFilter)
          ? this.selectedQuestionTypeFilter.join(",")
          : this.selectedQuestionTypeFilter,
        level: this.selectedLevelFilter.join(","),
        grades: this.selectedGradeFilter.join(","),
        difficultyLevel: this.selecteddifficultyLevelFilter.join(","),
        complexityLevel: this.selectedcomplexityLevelFilter.join(","),
        knowledgeLevel: this.selectedknowlewdgeLevelFilter.join(","),
        taxonomyLevel: this.selectedbloomsTaxonomyLevelFilter.join(","),
        skill: this.selectedskillsFilter.join(","),
        subject: this.selectedsubjectsFilter.join(","),
        reportedQuestion: JSON.stringify(
          this.sendSelectedReportedQuestionsFilter || [],
        ),
        questionAssetType: this.selectedQuestionAssetUrlFilter.join(","),
        hasEquation: this.hasEquationFilter.join(","),
      };

      const query = "?" + new URLSearchParams(params).toString();
      try {
        const res = await QuestionsController.streamDownloadQuestions(query);

        if (res && res.data) {
          // Create blob from response
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // Create download link
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "questions.csv";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        console.error("Error downloading questions:", error);
      } finally {
        this.loadingQuestionsToDownload = false;
      }
    },
    decodeHtmlEntities(text) {
      const entities = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'",
        "&nbsp;": " ",
      };
      return text.replace(
        /&(amp|lt|gt|quot|#39|nbsp|#(\d+));/g,
        function (match, entity, dec) {
          if (entity === "quot") return '"';
          if (entity === "#39") return "'";
          return entities[entity] || String.fromCharCode(dec);
        },
      );
    },
    skippedQuestion(id, reason, value, message = null) {
      console.log("reason");
      if (reason == "") {
      } else if (message) {
        this.removedQuestion.push(
          "Q" + id + ". Failed" + "->reason-> " + reason + "-> " + message,
        );
      } else {
        this.removedQuestion.push(
          "Q" +
            id +
            ". Failed" +
            "->reason-> " +
            reason +
            "-> " +
            value +
            " ->  Invalid format or missing value. Please provide a valid input. If not applicable, use 'NA' instead.",
        );
      }
    },
    parentIdsOfSkippedRows(headers, rows, skippedRowIndexes) {
      const parentIdIndex = headers.indexOf("parentId");
      const parentIds = new Set();
      if (parentIdIndex === -1) return parentIds;

      for (const rowIndex of skippedRowIndexes) {
        const parentId = String(rows[rowIndex]?.[parentIdIndex] ?? "").trim();
        if (parentId && parentId.toUpperCase() !== "NA") {
          parentIds.add(parentId);
        }
      }
      return parentIds;
    },
    consolidateSubQuestions(questions, skippedParentIds = new Set()) {
      const questionIdOf = (question) => {
        const rawId = question.questionId ?? question.questionID;
        return rawId ? String(rawId).trim() : null;
      };
      const parentIdOf = (question) => {
        const rawParentId = String(
          question.parentId ?? question.parentID ?? "",
        ).trim();
        return rawParentId && rawParentId.toUpperCase() !== "NA"
          ? rawParentId
          : null;
      };

      //drop entire passage questions cohort if any one of them fails validation
      if (skippedParentIds.size) {
        questions = questions.filter((question) => {
          const questionId = questionIdOf(question);
            const groupId = parentIdOf(question) ?? questionId;
          if (!groupId || !skippedParentIds.has(groupId)) return true;
          this.skippedQuestion(
            questionId ?? "?",
            "questionId",
            `Another row of passage based question '${groupId}' is invalid, so the whole passage based question was not uploaded`,
          );
          return false;
        });
      }

      const questionsById = new Map();
      for (const question of questions) {
        const questionId = questionIdOf(question);
        if (questionId) questionsById.set(questionId, question);
      }

      // Merge each child into the sub-questions of the parent it points at.
      const mergedChildren = new Set();
      for (const question of questions) {
        const parentId = parentIdOf(question);
        if (!parentId) continue;

        const parent = questionsById.get(parentId);
        if (!parent || !PARENT_QUESTION_TYPES.has(parent.questionType)) {
          this.skippedQuestion(
            questionIdOf(question) ?? "?",
            "parentId",
            `No parent question found for parentId '${parentId}'`,
          );
          mergedChildren.add(question); // orphan - drop, don't upload standalone
          continue;
        }
        parent.subQuestions = parent.subQuestions || [];
        parent.subQuestions.push(this.toSubQuestion(question));
        mergedChildren.add(question);
      }

      const consolidatedQuestions = [];
      for (const question of questions) {
        if (mergedChildren.has(question)) continue; // merged into its parent

        const subQuestions = question.subQuestions;
        if (subQuestions && subQuestions.length) {
          const subQuestionMarksTotal = subQuestions.reduce(
            (total, subQuestion) =>
              total + (Number(subQuestion.marksAllotted) || 0),
            0,
          );
          // If the parent row states its own marks, they must equal the sub-question sum.
          const declaredMarks = String(question.marksAllotted ?? "").trim();
          const hasDeclaredMarks =
            declaredMarks !== "" && declaredMarks.toUpperCase() !== "NA";
          if (
            hasDeclaredMarks &&
            Number(declaredMarks) !== subQuestionMarksTotal
          ) {
            this.skippedQuestion(
              questionIdOf(question) ?? "?",
              "marksAllotted",
              `Parent marks (${question.marksAllotted}) must equal the sum of its sub-question marks (${subQuestionMarksTotal})`,
            );
            continue; // marks mismatch - drop it
          }
          question.marksAllotted = String(subQuestionMarksTotal);
        } else if (PARENT_QUESTION_TYPES.has(question.questionType)) {
          this.skippedQuestion(
            questionIdOf(question) ?? "?",
            question.questionType,
            "Parent question has no sub-questions",
          );
          continue; // no children merged in - drop it
        }

        delete question.parentId;
        delete question.parentID;
        consolidatedQuestions.push(question);
      }
      return consolidatedQuestions;
    },
    toSubQuestion(child) {
      const subQuestion = { ...child };
      delete subQuestion.parentId;
      delete subQuestion.parentID;
      return subQuestion;
    },
    downloadTextFile(text, filename) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text),
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    multiSubjectCheck(subjects) {
      return subjects
        .split(",")
        .every((sub) => this.checkData.subjects.includes(sub.trim()));
    },
    checkMatters(headerName, word, skill, headers, cells) {
      function validateString(input, validValues) {
        console.log("validValues", validValues);
        // Handle invalid inputs
        if (!input || !Array.isArray(validValues) || validValues.length === 0) {
          return {
            isValid: false,
            value: null,
          };
        }

        // Normalize the valid values array
        const normalizedValidValues = validValues.map((value) => {
          try {
            return value
              ?.trim()
              .toUpperCase()
              .replace(/[\s-]+/g, "_")
              .replace(/[\s_]+/g, "");
          } catch (error) {
            console.error("Error normalizing value:", value, error);
            return value; // Return original value if normalization fails
          }
        });

        // Normalize the input: convert to uppercase and replace spaces/hyphens with underscores
        const normalizedInput = input
          .trim()
          .toUpperCase()
          .replace(/[\s-]+/g, "_")
          .replace(/[\s_]+/g, "");

        // Create alternate version without underscores for concatenated strings
        const withoutUnderscores = normalizedInput.replace(/_/g, "");

        // Find matching value
        let matchedValue = normalizedValidValues.find(
          (value) => value === normalizedInput,
        );

        if (matchedValue) {
          let index = normalizedValidValues.indexOf(matchedValue);
          matchedValue = validValues[index];
        }
        return {
          isValid: Boolean(matchedValue),
          value: matchedValue || null,
        };
      }

      // Remove asterisk from header name before checking
      const cleanHeaderName = headerName.replace("*", "").toLowerCase();
      const isRequired = headerName.includes("*");

      // Check for required fields - reject empty or 'NA' values
      if (isRequired && (!word || word.trim().toUpperCase() === "NA")) {
        return false;
      }
      const productIndex = headers
        .map((h) => h.replace("*", ""))
        .indexOf("product");
      const currentProduct = cells[productIndex];

      switch (cleanHeaderName) {
        case "questiontype":
          let { isValid: isValidQT, value: valueQT } = validateString(
            word,
            this.questionTypeList,
          );
          if (isValidQT) {
            cells[headers.indexOf("questionType")] = valueQT;
          }
          return isValidQT;

        case "markingtype":
          let { isValid: isValidMT, value: valueMT } = validateString(
            word,
            this.markingTypesList,
          );
          if (isValidMT) {
            cells[headers.indexOf("markingType")] = valueMT;
          }
          return isValidMT;
        case "product":
          return ["MESTA", "SRS", "Hubble STAR", "LMS"].includes(word.trim());

        // case 'questionid':
        //   if (!word) return false;

        //   // Get language from current row - handle asterisk in header
        //   const languageIndex = headers.map(h => h.replace('*', '')).indexOf("languageOfQuestion");
        //   const language = cells[languageIndex]?.trim() || '';

        //   const comboKey = `${word.trim()}-${language}`;
        //   if (this.questionIdLanguageCombos.has(comboKey)) {
        //     return false;
        //   }

        //   const prefix = currentProduct.replace(' ', '').toUpperCase();
        //   const pattern = new RegExp(`^${prefix}_(\\d+|[a-zA-Z]\\d+)$`);
        //   const isValidFormat = pattern.test(word.toUpperCase().trim());

        //   if (isValidFormat) {
        //     this.questionIdLanguageCombos.set(comboKey, true);
        //   }

        //   return isValidFormat;

        case "skill":
          let { isValid: isValidSK, value: valueSK } = validateString(
            word,
            this.checkData.skills,
          );
          if (isValidSK) {
            cells[headers.indexOf("skill")] = valueSK;
          }
          return isValidSK;

        case "level":
          if (cells[headers.indexOf("skill")] === "Core Skills") {
            let { isValid: isValidLVL, value: valueLVL } = validateString(
              word,
              this.checkData.levels,
            );
            if (isValidLVL) {
              cells[headers.indexOf("level")] = valueLVL;
            }
            return isValidLVL;
          }
          return true;

        case "difficultylevel":
          const skillIndexDL = headers
            .map((h) => h.replace("*", ""))
            .indexOf("skill");
          const skillDL = cells[skillIndexDL]?.trim().toLowerCase();

          if (
            skillDL === "psychometry" &&
            (!word || word.trim().toUpperCase() === "NA")
          ) {
            return true;
          }
          let { isValid: isValidDL, value: valueDL } = validateString(
            word,
            this.difficultyLevels,
          );
          if (isValidDL) {
            cells[headers.indexOf("difficultyLevel")] = valueDL;
          }
          return isValidDL;

        case "subject":
          if (!isRequired && (word === "NA" || word === "na")) {
            return true;
          }
          return /,/.test(word.trim())
            ? this.multiSubjectCheck(word.trim())
            : this.checkData.subjects.includes(word.trim());

        case "hrisuniquerole":
          // Check if the role exists in audienceRoles collection or if it's 'Any'
          const trimmedWord = word.trim();
          if (!isRequired && (trimmedWord === "NA" || trimmedWord === "na")) {
            return true;
          }
          return (
            trimmedWord === "Any" || this.hrisUniqueRole.includes(trimmedWord)
          );

        case "questionasseturl":
          if (word === "NA") return true;
          const questionAssetUrlPattern = new RegExp(
            "^(https?:\\/\\/)?([\\w\\-]+\\.)+[\\w\\-]+(\\/[^\\s]*)?$",
          );
          return questionAssetUrlPattern.test(word.trim());

        case "groupname":
          let { isValid: isValidGN, value: valueGN } = validateString(
            word,
            this.groupNames,
          );
          if (isValidGN) cells[headers.indexOf("groupName")] = valueGN;
          return isValidGN;

        // case 'los':
        //   if (!word) return false;
        //   // Split the LO codes by comma and validate each
        //   const loCodes = word.split(',').map(code => code.trim());
        //   return loCodes.every(code => this.LOData.includes(code));
        case "correctanswer":
          const questionTypeIndexCorrectAnswer =
            headers.indexOf("questionType");
          const questionTypeCorrectAnswer =
            cells[questionTypeIndexCorrectAnswer];

          if (questionTypeCorrectAnswer === "MATCH_THE_FOLLOWING") {
            if (!word) return false;

            // Split by comma to get each pair
            const pairs = word.split(",").map((pair) => pair.trim());

            // Validate each pair has exactly one colon
            return pairs.every((pair) => {
              const parts = pair.split(":");
              // Each pair should have exactly 2 parts (value1:value2)
              // and neither part should be empty
              return (
                parts.length === 2 &&
                parts[0].trim().length > 0 &&
                parts[1].trim().length > 0
              );
            });
          }
          return true; // For other question types

        case "bloomstaxonomy":
          const skillIndexBT = headers
            .map((h) => h.replace("*", ""))
            .indexOf("skill");
          const skillBT = cells[skillIndexBT]?.trim().toLowerCase();
          const questionTypeIndexBT = headers.indexOf("questionType");
          if (PARENT_QUESTION_TYPES.has(cells[questionTypeIndexBT])) {
            return true; // container questions carry no Bloom's level
          }

          if (
            skillBT === "psychometry" &&
            (!word || word.trim().toUpperCase() === "NA")
          ) {
            return true;
          }
          let { isValid: isValidBT, value: valueBT } = validateString(
            word,
            this.bloomsTaxonomyLevel,
          );
          if (isValidBT) {
            cells[headers.indexOf("bloomsTaxonomy")] = valueBT;
          }
          return isValidBT;

        case "grade":
          if (!isRequired && (word === "NA" || word === "na")) {
            return true;
          }
          let { isValid: isValidGD, value: valueGD } = validateString(
            word,
            this.checkData.grades,
          );
          if (isValidGD) cells[headers.indexOf("grade")] = valueGD;
          return isValidGD;
        case "questionstatement":
          const questionTypeIndex = headers.indexOf("questionType");
          if (cells[questionTypeIndex] !== PASSAGE_BASED_QUESTION_TYPE) return true;
          return (
            this.countWords(word ?? "") <= this.passageMaxWords ||
            `Passage exceeds the ${this.passageMaxWords}-word limit. Please reduce the word count and re-upload.`
          );

        default:
          return true;
      }
    },
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },
    saveEditedValue() {
      this.options[this.editedOptionIndex].optionValue =
        this.editedCkeditorValue;
      this.optionTextFieldDialog = false;
    },
    saveEditedAnswer() {
      this.answers[this.editedAnswerIndex].optionValue =
        this.editedCkeditorValue;
      this.answerTextFieldDialog = false;
    },
    getAlphabet(num) {
      // ASCII value for 'A' is 65
      // The alphabet letter corresponding to num can be calculated by adding num to 65 and then getting the character using fromCharCode()
      return String.fromCharCode(65 + num);
    },
    onQuestionTypeChange(newType) {
      if ((newType === 'SINGLE_CHOICE' || newType === 'MULTIPLE_CHOICE') && !this.options?.length) {
        this.options = JSON.parse(JSON.stringify(defaultOptions));
      }
      if (newType === 'FILL_IN_THE_BLANKS' && this.markingType === 'Likert Marking') {
        this.markingType = 'Regular Marking';
      }
      if (newType === 'PASSAGE_BASED') {
        // Passage questions don't use the single top-level markingType/correctAnswerScore
        // (each sub-question has its own) — clearing these keeps the shared-metadata card
        // (gated on v-if="markingType") hidden without touching its existing v-if.
        this.markingType = null;
        this.correctAnswerScore = 0;
        // numberOfQuestions defaults to 1 already, so the watcher on it won't fire if it
        // hasn't changed — ensure passageSubQuestions still gets populated on first entry.
        while (this.passageSubQuestions.length < this.numberOfQuestions) {
          this.passageSubQuestions.push(this.createEmptyPassageSubQuestion());
        }
        // Open the first sub-question panel by default. Only when nothing is already
        // open — toggling the type dropdown away and back shouldn't fight a user who's
        // deliberately collapsed everything.
        if (!this.passageSubQuestionPanels.length && this.passageSubQuestions.length) {
          this.passageSubQuestionPanels = [0];
        }
      }
      // Note: intentionally NOT clearing questionStatement/passageSubQuestions/numberOfQuestions
      // here, so toggling the dropdown away and back preserves in-progress passage data.
    },

    getSubQuestionMarkingTypes(subQuestion) {
      return [
        { name: 'Regular Marking', disabled: false },
        { name: 'Likert Marking', disabled: ['FILL_IN_THE_BLANKS'].includes(subQuestion?.questionType)},
      ];
    },

    onSubQuestionTypeChange(subQuestion) {
      if (
        ['FILL_IN_THE_BLANKS'].includes(subQuestion?.questionType) &&
        ['Likert Marking'].includes(subQuestion.markingType)
      ) {
        subQuestion.markingType = 'Regular Marking';
      }
    },
    createdQuestionIdOf(record) {
      const rawId = record?.questionId ?? record?.questionID ?? record?.id;
      return rawId ? String(rawId).trim() : "";
    },

    createEmptyPassageSubQuestion() {
      return {
        questionType: "SINGLE_CHOICE",
        questionDescription: "",
        markingType: null,
        correctAnswerScore: 0,
        answerPayload: null,
      };
    },

    // ckeditor4-vue mutates the config object it's given in place: prepareConfig() does
    // `config.on = config.on || {}` then sets `config.on.instanceReady` directly on it. Sharing
    // one config object (or even a SHALLOW clone of it — shallow copies still point to the same
    // nested `on` object once one editor creates it) across multiple <ckeditor> instances causes
    // their editor instances to cross-wire, so typing in one field can end up writing into another's
    // (the passage's own field included, if it shares the object with any sub-question). Every
    // ckeditor usage needs a fully independent config tree — deep-clone via JSON round-trip, safe
    // here since editorConfigForPassage only ever contains a plain array of toolbar strings.
    getFreshPassageEditorConfig() {
      return JSON.parse(JSON.stringify(this.editorConfigForPassage));
    },

    togglePassageSubQuestionPanels(expand) {
      this.passageSubQuestionPanels = expand
        ? [...Array(this.passageSubQuestions.length).keys()]
        : [];
    },

    clearValue() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.questionType = "";
      this.answers = JSON.parse(JSON.stringify(defaultAnswers));
      this.questionName = "";
      this.questionDescription = "NA";
      this.selectedLOs = [];
      this.skill = 0;
      this.subject = null;
      this.correctAnswerScore = 0;
      this.bloomsTaxonomy = "";
      this.knowledgeLevel = "";
      this.complexityLevel = "";
      this.difficultyLevel = "";
      this.proficiencyLevel = "";
      this.level = 0;
      (this.hint = ""), (this.answerExplanation = ""), (this.selectedTags = []);
      this.formbtnBool = false;
      this.groupName = null;
      this.languageOfQuestion = "";
      this.product = null;
      this.questionid = "";
      this.singleSelectCorrectAnswer = null;
      this.selectedAnswersForMultitpleTypeQuestions = [];
      this.selectedLhsForMultitpleTypeQuestions = [];
      this.selectedRhsForMultitpleTypeQuestions = [];
      this.topic = null;
      this.grade = null;
      this.strand = null;
      this.subStrand = null;
      this.setNumber = "";
      this.markingType = null;
      // this.typeOfAudience = null,
      this.authoredBy = null;
      this.selectedHrisRoles = [];
      this.questionAssetUrl = "NA";
      this.questionAssetType = null;
      this.uploadingForOption = false;
      this.correctAnswer = "NA";
      this.isCaseSensitive = "No";
      this.marksAllotted = null;
      this.los = [];
      this.tag = "";
      this.isFormValid = false;
      this.questionStatement = "";
      this.passageCustomer = null;
      this.numberOfQuestions = 1;
      this.passageSubQuestions = [];
      this.passageSubQuestionPanels = [];
      this.$nextTick(() => { this.$refs.form?.reset(); });
    },
    checkSubjects(id) {
      if (id == null) {
        this.subjectShowBool = false;
      } else {
        console.log(id);
        const skill = this.skills.find((skill) => skill == id);
        // console.log(skill);
        if (skill?.subject_skills.length == 0) {
          this.subjectShowBool = false;
          if (!this.subjectShowBool) {
            this.subject = null;
          }
        } else {
          this.subjectShowBool = true;
        }
      }
    },
    async searchData(search) {
      const response = await QuestionsController.searchQuestion(
        this.pageSize,
        this.page,
        search,
      );
      console.log(response.data);
      console.log(this.searchBool);
      this.count = response.data.data.count;
      this.tableData = response.data.data.rows;
    },

    addTag() {
      if (this.tag && !this.tagsList.includes(this.tag)) {
        this.tagsList.push(this.tag);
        this.tag = "";
      }
    },
    removeTag(index) {
      this.tagsList.splice(index, 1);
    },
    reload() {
      console.log("Reload");
      this.$router.go(0);
      //window.location.reload();
    },

    onResize() {
      this.windowHeight = window.innerHeight;
    },
    onChange(e) {
      this.tempOptions.set(
        this.editedOptionIndex,
        this.options[this.editedOptionIndex].optionValue,
      );
      this.selectedFile = e.target.files[0];
      if (
        this.selectedFile &&
        (this.selectedFile.type.startsWith('audio/') || this.selectedFile.type.startsWith('video/')) &&
        this.selectedFile.size > MAX_ASSET_SIZE_BYTES
      ) {
        e.target.value = '';
        this.selectedFile = null;
        this.errorDialog = true;
        this.errorMessage = "The file exceeds the maximum limit of 100 MB. Please upload a smaller file.";
        return;
      }
      this.uploadingMsg = "File Uploading...";
      console.log("selected file", this.selectedFile);
      this.uploadingDialog = true;
      this.uploadAsset();
    },
    uploadAsset() {
      console.log;
      this.loading = true;
      if (this.selectedFile != null) {
        const storageRef = ref(
          storage,
          "/question_bank/" + this.selectedFile.name + new Date().getTime(),
        );
        uploadBytes(storageRef, this.selectedFile).then((snapshot) => {
          console.log("Uploaded");
          getDownloadURL(snapshot.ref).then((url) => {
            if (this.uploadingForOption) {
              this.options[this.editedOptionIndex].optionValue = url;
              // this.options[this.editedOptionIndex].optionType = "IMAGE";
            } else {
              this.questionAssetUrl = url;
              // Reset the preview cache so resolveQuestionAssetUrl() re-resolves against
              // this newly uploaded file instead of reusing a previously resolved asset's URL.
              this.questionAssetUrlForPreview = IMAGE_ALT_SRC;
              this.mainImage = true;
              const fileType = this.selectedFile.type;

              switch (true) {
                case fileType.startsWith('audio/'):
                  this.questionAssetType = 'audio';
                  break;

                case fileType.startsWith('video/'):
                  this.questionAssetType = 'video';
                  break;

                default:
                  this.questionAssetType = 'image';
              }
              // console.log(this.selectedFile.type);
            }
            this.uploadingForOption = false;
            this.uploadingMsg = "File Uploaded";
            // console.log("Upload Response: ", uploadResponse);
            // this.saveInputs();
          });
        });
      }
    },

    formbtn() {
      return this.formbtnBool === false ? "Create" : "Update";
    },

    buildQuestionUpdatePayload(source = null) {
      const questionType = source?.questionType ?? this.questionType;
      if (questionType === 'PASSAGE_BASED') {
        return this.buildPassageQuestionUpdatePayload(source);
      }
      const questionStatement = source?.questionStatement ?? this.questionName;
      const questionOptions = source
        ? questionType === "MATCH_THE_FOLLOWING"
          ? source.correctAnswer ?? source.questionOptions
          : source.questionOptions
        : this.getOptions();
      const correctAnswer = source ? source.correctAnswer : this.getCorrectAnswer();
      const correctAnswerScore =
        source?.correctAnswerScore ??
        source?.marksAllotted ??
        this.correctAnswerScore;

      let mtfOptions;
      if(questionType === "MATCH_THE_FOLLOWING"){
        mtfOptions = this.prepareOptions(questionOptions);
      }

      return {
        questionStatement,
        sanitizedQuestionStatement: this.sanitizedQuestion(questionStatement),
        questionType,
        questionDescription: source?.questionDescription ?? this.questionDescription,
        questionAssetUrl: source?.questionAssetUrl ?? this.questionAssetUrl,
        questionAssetType: source?.questionAssetType ?? this.questionAssetType,
        selectedLOs: source?.selectedLOs ?? this.selectedLOs,
        skill: source?.skill ?? this.skill,
        subject: source?.subject ?? this.subject,
        correctAnswerScore,
        bloomsTaxonomy: source?.bloomsTaxonomy ?? this.bloomsTaxonomy,
        knowledgeLevel: source?.knowledgeLevel ?? this.knowledgeLevel,
        complexityLevel: source?.complexityLevel ?? this.complexityLevel,
        difficultyLevel: source?.difficultyLevel ?? this.difficultyLevel,
        proficiencyLevel: source?.proficiencyLevel ?? this.proficiencyLevel,
        correctAnswer,
        level: source?.level ?? this.level,
        hint: source?.hint ?? this.hint,
        answerExplanation: source?.answerExplanation ?? this.answerExplanation,
        questionOptions,
        ...(mtfOptions && {mtfOptions}),
        topic: source?.topic ?? this.topic,
        strand: source?.strand ?? this.strand,
        subStrand: source?.subStrand ?? this.subStrand,
        grade: source?.grade ?? this.grade,
        authoredBy: source?.authoredBy ?? this.authoredBy,
        hrisUniqueRole: source?.hrisUniqueRole ?? this.selectedHrisRoles,
        setNumber: source?.setNumber ?? this.setNumber,
        markingType: source?.markingType ?? this.markingType,
        groupName: source?.groupName ?? this.groupName
      };
    },
    buildPassageQuestionUpdatePayload(source = null) {
      const questionStatement = source?.questionStatement ?? this.questionStatement;
      const subQuestions = source
        ? source.subQuestions
        : this.passageSubQuestions.map((sub, index) => ({
            questionType: sub.questionType,
            questionStatement: sub.questionDescription,
            sanitizedQuestionStatement: this.sanitizedQuestion(sub.questionDescription),
            markingType: sub.markingType,
            correctAnswerScore: sub.correctAnswerScore,
            parentId: sub.parentId,
            questionOptions: sub.answerPayload?.questionOptions,
            correctAnswer: sub.answerPayload?.correctAnswer,
            mtfOptions: sub.answerPayload?.mtfOptions,
            hint: sub.answerPayload?.hint,
            answerExplanation: sub.answerPayload?.answerExplanation,
            strand: sub.answerPayload?.strand,
            subStrand: sub.answerPayload?.subStrand,
            topic: sub.answerPayload?.topic,
            selectedLOs: sub.answerPayload?.selectedLOs,
            isCaseSensitive: sub.answerPayload?.isCaseSensitive === "Yes",
            bloomsTaxonomy: sub.answerPayload?.bloomsTaxonomy,
            complexityLevel: sub.answerPayload?.complexityLevel,
            proficiencyLevel: sub.answerPayload?.proficiencyLevel,
            difficultyLevel: sub.answerPayload?.difficultyLevel,
            orderInPassage: index + 1,
          }));

      return {
        questionType: 'PASSAGE_BASED',
        questionStatement,
        sanitizedQuestionStatement: this.sanitizedQuestion(questionStatement),
        application: source?.application ?? this.product,
        skill: source?.skill ?? this.skill,
        setNumber: source?.setNumber ?? this.setNumber,
        level: source?.level ?? this.level,
        grade: source?.grade ?? this.grade,
        subject: source?.subject ?? this.subject,
        hrisUniqueRole: source?.hrisUniqueRole ?? this.selectedHrisRoles,
        languageOfQuestion: source?.languageOfQuestion ?? this.languageOfQuestion,
        difficultyLevel: source?.difficultyLevel ?? this.difficultyLevel,
        authoredBy: source?.authoredBy ?? this.authoredBy,
        groupName: source?.groupName ?? this.groupName,
        customer: source?.customer ?? this.passageCustomer,
        subQuestions,
      };
    },
    getChangedQuestionFields(currentPayload, originalPayload = {}) {
      const isMTF = currentPayload.questionType === 'MATCH_THE_FOLLOWING';
      return Object.entries(currentPayload).reduce((changedFields, [key, value]) => {
        // sanitizedQuestionStatement is derived from questionStatement — never track separately.
        if (key === 'sanitizedQuestionStatement') return changedFields;
        // For MTF questions, correctAnswer, questionOptions and mtfOptions all represent
        // the same pairs data. Exclude questionOptions and mtfOptions from tracking so
        // only correctAnswer is counted as the single change.
        if (key === 'mtfOptions') return changedFields;
        if (isMTF && key === 'questionOptions') return changedFields;

        // subQuestions (PASSAGE_BASED) is diffed as one atomic array. mtfOptions is
        // reshuffled (Math.random()) on every mount, so it must be excluded per-element
        // the same way the top-level MTF exclusion above works, or the form would look
        // dirty immediately on opening Edit for any passage with an MTF sub-question.
        if (key === 'subQuestions' && Array.isArray(value)) {
          const normalize = (arr) => (arr || []).map((sq) => {
            const { mtfOptions, questionOptions, ...rest } = sq;
            return sq.questionType === 'MATCH_THE_FOLLOWING' ? rest : { ...rest, questionOptions };
          });
          if (JSON.stringify(normalize(value)) !== JSON.stringify(normalize(originalPayload[key]))) {
            changedFields[key] = value;
          }
          return changedFields;
        }

        if (JSON.stringify(value) !== JSON.stringify(originalPayload[key])) {
          changedFields[key] = value;
        }

        return changedFields;
      }, {});
    },

    openUpdateCommentDialog() {
      if (this.$refs.form.validate() && this.isEditQuestionContentPresent) {
        this.updateComment = "";
        this.updateCommentDialog = true;
      }
    },
    async submitUpdate() {
      this.updateCommentDialog = false;
      await this.updateInput(this.editId, this.updateComment);
      this.updateComment = "";
    },
    async updateInput(id, comment = "") {
      console.log("update called");
      if (this.$refs.form.validate() && this.isEditQuestionContentPresent) {
        if (this.blockIfBlankPlaceholderMissing()) return;
        const currentPayload = this.buildQuestionUpdatePayload();
        const changedFields = this.getChangedQuestionFields(
          currentPayload,
          this.originalQuestionFormData || {},
        );
        // For MTF, questionOptions and mtfOptions are excluded from change tracking
        // but must still be sent to the server when the pairs (correctAnswer) changed.
        const mtfPayload = currentPayload.questionType === 'MATCH_THE_FOLLOWING' && changedFields.correctAnswer !== undefined
          ? {
              questionOptions: currentPayload.questionOptions,
              ...(currentPayload.mtfOptions ? { mtfOptions: currentPayload.mtfOptions } : {}),
            }
          : {};
        const response = await QuestionsController.updateQuestion(
          {
            ...changedFields,
            ...mtfPayload,
            updatedBy: {
              userId: this.$store.state.userInfo.id,
              name: this.$store.state.userInfo.name,
              role: this.$store.state.role.roleName,
            },
            ...(comment ? { comment } : {}),
          },
          id,
        );
        console.log("responce", response);
        console.log(response.data);
        if (response.status == 200) {
          this.isCreatingQuestion = false;
          this.successMessage = `Question Id ${this.questionid} has been updated Successfully`;
          this.successDialog = true;
          this.createQuestionDialog = false;
          //this.fetchQuestions();
        } else {
          this.isCreatingQuestion = false;
          this.errorDialog = true;
        }
      }
    },
    checkArrOptions(item = ``) {
      let result = `${item}`.replace(/[^A-Za-z]/g, "");
      return Array.from(new Set(result));
    },
    formatOptionAndAnswer(optionsWithAnswers) {
      console.log("optionsWithAnswers", optionsWithAnswers);
      this.options = [];
      this.answers = [];

      const formattedArray = optionsWithAnswers.split(", ").map((item) => {
        const [key, value] = item.split(":");
        return { key: key.trim(), value: value.trim() };
      });
      // Split the string into individual option-answer pairs
      const pairs = formattedArray;

      // Loop through the pairs to create the objects
      pairs.forEach((pair, index) => {
        const optionKey = String.fromCharCode(65 + index); // Generates 'A', 'B', 'C', etc.

        this.options.push({
          optionKey: optionKey,
          optionValue: pair.key,
        });

        this.answers.push({
          optionKey: optionKey,
          optionValue: pair.value,
        });
      });
    },
    updateData(item) {
      this.editId = item.id; // selected id for edit
      this.formbtnBool = true; // change update/create btn value
      this.createQuestionDialog = true;

      // Setting questionType below fires the Passage<->regular boundary-cross watcher,
      // which resets the shared metadata fields (product, skill, grade, etc.) — but that
      // watcher runs async (nextTick), i.e. AFTER this function's synchronous field
      // population finishes, so it would wipe out the values we're about to set here.
      // Suppress it for this edit-population pass; it re-enables right after (still
      // ahead of any user-driven dropdown change), so manual type switches in the form
      // still reset as designed.
      this.suppressSharedFieldReset = true;
      this.$nextTick(() => {
        this.suppressSharedFieldReset = false;
      });

      if (item.questionType === 'PASSAGE_BASED') {
        this.questionType = 'PASSAGE_BASED';
        this.product = item.application;
        this.skill = item.skill;
        this.setNumber = item?.setNumber ?? "";
        this.level = item.level;
        this.getGradesMappedToLevel(item.level);
        this.grade = item.grade;
        this.subject = item.subject;
        this.selectedHrisRoles = item.hrisUniqueRole;
        this.languageOfQuestion = item.languageOfQuestion;
        this.difficultyLevel = item.difficultyLevel;
        this.authoredBy = item.authoredBy;
        this.groupName = item.groupName;
        this.passageCustomer = item.customer;
        this.numberOfQuestions = item.subQuestions?.length || 1;
        this.passageSubQuestions = (item.subQuestions || []).map((sub) => ({
          questionType: sub.questionType,
          questionDescription: sub.questionStatement,
          markingType: sub.markingType,
          correctAnswerScore: sub.correctAnswerScore,
          parentId: sub.parentId,
          answerPayload: {
            questionOptions: sub.questionOptions,
            correctAnswer: sub.correctAnswer,
            mtfOptions: sub.mtfOptions,
            hint: sub.hint,
            answerExplanation: sub.answerExplanation,
            strand: sub.strand,
            subStrand: sub.subStrand,
            topic: sub.topic,
            selectedLOs: sub.selectedLOs,
            isCaseSensitive: sub.isCaseSensitive ? "Yes" : "No",
            bloomsTaxonomy: sub.bloomsTaxonomy,
            complexityLevel: sub.complexityLevel,
            proficiencyLevel: sub.proficiencyLevel,
            difficultyLevel: sub.difficultyLevel,
            isValid: true,
          },
        }));
        // Open the first sub-question panel by default when editing.
        this.passageSubQuestionPanels = this.passageSubQuestions.length ? [0] : [];
        this.originalQuestionFormData = this.buildQuestionUpdatePayload(item);
        // Delayed like `questionName` below (2s) — if the previous edit/cancel session
        // also left questionType at PASSAGE_BASED, this ckeditor instance may already be
        // mounted/stale rather than freshly created, and needs the same settle time.
        setTimeout(() => {
          this.questionStatement = item.questionStatement || "";
        }, 2000);
        return;
      }

      // Add these lines to set the missing fields
      this.product = item.application;
      this.correctAnswer = item.correctAnswer;
      this.questionid = item.questionId;
      this.languageOfQuestion = item.languageOfQuestion;
      this.groupName = item.groupName;
      this.skill = item.skill;
      this.questionType = item.questionType;
      this.bloomsTaxonomy = item.bloomsTaxonomy;
      this.knowledgeLevel = item.knowledgeLevel;
      this.complexityLevel = item.complexityLevel;
      this.difficultyLevel = item.difficultyLevel;
      this.hint = item.hint;
      this.subject = item.subject;
      this.proficiencyLevel = item.proficiencyLevel;
      this.level = item.level;
      this.getGradesMappedToLevel(item.level);
      if (this.questionType == "MATCH_THE_FOLLOWING") {
        this.formatOptionAndAnswer(item.correctAnswer);
      } else {
        this.options = JSON.parse(JSON.stringify(item.questionOptions || []));
      }
      this.singleSelectCorrectAnswer = item.correctAnswer;
      this.selectedAnswersForMultitpleTypeQuestions = this.checkArrOptions(
        item.correctAnswer,
      );
      this.trueFalseCorrectAnswer = item.correctAnswer;
      this.correctAnswerScore = item.marksAllotted ?? item.correctAnswerScore ?? 0;
      this.questionAssetUrl = item.questionAssetUrl;
      this.questionAssetType = item.questionAssetType ?? null;
      this.questionDescription = item.questionDescription ?? "NA";
      this.selectedLOs = item.selectedLOs ?? [];
      // this.selectedTags = item.tags;
      this.answerExplanation = item.answerExplanation;
      this.grade = item.grade;
      this.topic = item.topic;
      this.strand = item.strand;
      this.subStrand = item.subStrand;
      this.setNumber = item?.setNumber ?? "";
      this.markingType = item?.markingType ?? null;
      // this.typeOfAudience = item.typeOfAudience
      this.authoredBy = item.authoredBy;
      this.selectedHrisRoles = item.hrisUniqueRole;
      this.originalQuestionFormData = this.buildQuestionUpdatePayload(item);
      setTimeout(() => {
        // This code will execute after a 1 second delay
        this.questionName = item.questionStatement;
      }, 2000);
    },

    previewQuestion(question) {
      this.$router.push({
        name: "ViewQuestion",
        query: {
          id: question?.id || "",
          question: JSON.stringify(question || {}),
        },
      });
    },

    getDate(timeStamp) {
      return this.formatDate(timeStamp);
    },

    async deleteData(data) {
      this.dLoading = true;
      var ids = [];
      data.forEach((dataDelete) => {
        ids.push(dataDelete.id);
        const index = this.newFilteredQuestions.indexOf(dataDelete);
        this.newFilteredQuestions.splice(index, 1);
      });
      const response = await QuestionsController.deleteBulkQuestion(ids);
      if (response.data.flag) {
        setTimeout(this.fetchQuestions, 4000);

        this.dLoading = false;
        this.deleteDialog = false;
        this.selectedTableItems.length = "0";
        this.selectedTableItems = [];
        if (this.newFilteredQuestions.length === 0) {
          await this.getNewQuestionsData();
        }
        console.log("response", response);
      } else {
        this.dLoading = false;
        this.deleteDialog = false;
        this.selectedTableItems = [];
        this.selectedTableItems.length = "0";
        alert(response.data.error);
      }
      this.deleteDialog = false;
      this.dLoading = false;
      this.deleteSuccessDialog = true;
    },

    //console.log("deleted", response);
    async getLO() {
      const response = await LoBankController.getLO();
      //console.log(response);
      this.LOData = response.data.learningObjective.map((lo) => lo.lOCode);
    },
    async getAudienceRoles() {
      const response = await AudienceRoleController.getAudienceRoles();
      //console.log(response);
      this.hrisUniqueRole = response.data.audienceRoles.map(
        (role) => role.HRIS_unique_role,
      );
    },
    async getGrades() {
      const response = await GradeController.getAllGrades();
      this.grades = [{ name: "Any" }, ...response.data.grades];
      this.grades.forEach((obj) => {
        this.checkData.grades.push(obj.name);
      });
    },
    getGradesMappedToLevel(selectedLevel) {
      if (selectedLevel === "Any") {
        this.gradesMappedToLevel = this.grades.map(({ name }) => name);
      } else {
        const gradesMappedToLevel =
          this.levels.find(({ name }) => name === selectedLevel).grades ?? [];
        this.gradesMappedToLevel = [{ name: "Any" }, ...gradesMappedToLevel];
      }
    },
    async getLevels() {
      const response = await LevelController.getLevel();
      this.levelsGrades = response.data.levels;
      this.levels = [{ name: "Any" }, ...response.data.levels];
      this.levels.forEach((obj) => {
        this.checkData.levels.push(obj.name);
      });
    },
    async getSkills() {
      const response = await SkillsController.getSkills();
      //console.log(response);
      // this.skills = response.data.skills.filter(skill=>skill.name !== "Psychometry");
      this.skills = response.data.skills;
      this.skills.forEach((obj) => {
        this.checkData.skills.push(obj.name);
      });
    },
    async getSubjects() {
      const response = await SubjectController.getSubject();
      this.subjects = response.data.subjects;

      this.subjects.forEach((obj) => {
        this.checkData.subjects.push(obj.name);
      });
    },
    addOption() {
      if (this.options.length > 4) return;
      this.options.push({
        optionKey: this.getAlphabet(this.options.length),
        optionValue: "Option " + (this.options.length + 1),
        optionScore: 0,
      });
      console.log(this.options);
    },
    removeOption(index) {
      this.options.splice(index, 1);
    },
    getCorrectAnswer() {
      switch (this.questionType) {
        case "SINGLE_CHOICE":
          return this.singleSelectCorrectAnswer;
        case "MULTIPLE_CHOICE":
          return this.selectedAnswersForMultitpleTypeQuestions.join(",");

        case "FILL_IN_THE_BLANKS":
          return this.correctAnswer;

        case "TRUE_FALSE":
          return this.trueFalseCorrectAnswer;

        case "MATCH_THE_FOLLOWING":
          return this.getOptions();

        default:
          break;
      }
    },
    getOptions() {
      console.log("", this.options);
      switch (this.questionType) {
        case "SINGLE_CHOICE":
          return this.options;

        case "MULTIPLE_CHOICE":
          return this.options;

        case "FILL_IN_THE_BLANKS":
          return [];

        case "TRUE_FALSE":
          return [
            {
              optionKey: "A",
              optionValue: "TRUE",
            },
            {
              optionKey: "B",
              optionValue: "FALSE",
            },
          ];

        case "MATCH_THE_FOLLOWING":
          const result = this.options
            .map((option) => {
              const answer = this.answers.find(
                (a) => a.optionKey === option.optionKey,
              );
              const city = option.optionValue.replace(/<\/?p>/g, "").trim(); // Remove HTML tags
              const dish = answer.optionValue.replace(/<\/?p>/g, "").trim(); // Remove HTML tags
              return `${city}:${dish}`;
            })
            .join(", ");
          return result;

        default:
          break;
      }
    },
    // async createQuestionsFromBulk() {
    //   this.bulkQuestionJsonData.forEach(async (question) => {
    //     const response = await QuestionsController.createQuestion(question);
    //     if (response.status == 200) {
    //       console.log(question);
    //     }
    //   });
    // },

    async createPassageQuestion() {
      if (this.blockIfBlankPlaceholderMissing()) return;
      this.isCreatingQuestion = true;

      // One parent record with an embedded subQuestions array — mirrors the existing
      // MATCH_THE_FOLLOWING convention of embedding structured array data (questionOptions/
      // mtfOptions) directly on the question document. ms-questions is schema-less
      // (Firestore passthrough), so this requires no backend changes.
      const questionsData = {
        questionType: 'PASSAGE_BASED',
        questionStatement: this.questionStatement,
        sanitizedQuestionStatement: this.sanitizedQuestion(this.questionStatement),
        application: this.product,
        skill: this.skill,
        setNumber: this.setNumber,
        level: this.level,
        grade: this.grade,
        subject: this.subject,
        hrisUniqueRole: this.selectedHrisRoles,
        languageOfQuestion: this.languageOfQuestion,
        difficultyLevel: this.difficultyLevel,
        authoredBy: this.authoredBy,
        groupName: this.groupName,
        customer: this.passageCustomer,
        subQuestions: this.passageSubQuestions.map((sub, index) => ({
          questionType: sub.questionType,
          questionStatement: sub.questionDescription,
          sanitizedQuestionStatement: this.sanitizedQuestion(sub.questionDescription),
          markingType: sub.markingType,
          correctAnswerScore: sub.correctAnswerScore,
          questionOptions: sub.answerPayload?.questionOptions,
          correctAnswer: sub.answerPayload?.correctAnswer,
          mtfOptions: sub.answerPayload?.mtfOptions,
          hint: sub.answerPayload?.hint,
          answerExplanation: sub.answerPayload?.answerExplanation,
          strand: sub.answerPayload?.strand,
          subStrand: sub.answerPayload?.subStrand,
          topic: sub.answerPayload?.topic,
          selectedLOs: sub.answerPayload?.selectedLOs,
          isCaseSensitive: sub.answerPayload?.isCaseSensitive === "Yes",
          bloomsTaxonomy: sub.answerPayload?.bloomsTaxonomy,
          complexityLevel: sub.answerPayload?.complexityLevel,
          proficiencyLevel: sub.answerPayload?.proficiencyLevel,
          difficultyLevel: sub.answerPayload?.difficultyLevel,
          orderInPassage: index + 1,
        })),
      };

      try {
        const response = await QuestionsController.createQuestion([questionsData]);

        if (response.status === 200 && response.data.records) {
          const uploadedRecord = response.data.records[0];

          if (uploadedRecord.status === "Uploaded Successfully!") {
            this.isCreatingQuestion = false;
            this.successDialog = true;
            this.createQuestionDialog = false;
            this.questionid = this.createdQuestionIdOf(uploadedRecord);
            this.successMessage = this.questionid
              ? `Question Id ${this.questionid} has been created successfully`
              : "New Question Created";
          } else {
            this.isCreatingQuestion = false;
            this.errorDialog = true;
            this.errorMessage = uploadedRecord.error || "Failed to upload question.";
          }
        } else {
          this.isCreatingQuestion = false;
          this.errorDialog = true;
          this.errorMessage = "Bulk upload API did not return expected response.";
        }
      } catch (error) {
        console.error("Bulk Upload API Error:", error);
        this.isCreatingQuestion = false;
        this.errorDialog = true;
        this.errorMessage = "An error occurred while uploading the question.";
      }
    },

    async createQuestion() {
      if (this.questionType === 'PASSAGE_BASED') {
        if (!this.$refs.form.validate()) return;
        return this.createPassageQuestion();
      }
      if (this.$refs.form.validate() && this.questionName) {
        // let selectTags = this.selectedTags.join(",");
        if (this.blockIfBlankPlaceholderMissing()) return;

        this.isCreatingQuestion = true;

        const sanitizedQuestionStatement = this.sanitizedQuestion(
          this.questionName,
        );
        let correctAnswer = null;
        let mtfOptions = null;

        if (this.questionType == "MATCH_THE_FOLLOWING") {
          correctAnswer = this.getOptions();
          mtfOptions = this.prepareOptions(correctAnswer);
        } else {
          correctAnswer = this.getCorrectAnswer();
        }

        // Prepare question payload
        let questionsData = {
          questionStatement: this.questionName,
          questionType: this.questionType,
          questionDescription: this.questionDescription,
          questionAssetUrl: this.questionAssetUrl,
          questionAssetType: this.questionAssetType,
          selectedLOs: this.selectedLOs,
          skill: this.skill,
          setNumber: this.setNumber,
          markingType: this.markingType,
          subject: this.subject,
          correctAnswerScore: this.correctAnswerScore,
          bloomsTaxonomy: this.bloomsTaxonomy,
          knowledgeLevel: this.knowledgeLevel,
          complexityLevel: this.complexityLevel,
          difficultyLevel: this.difficultyLevel,
          proficiencyLevel: this.proficiencyLevel,
          correctAnswer: correctAnswer,
          sanitizedQuestionStatement,
          level: this.level,
          hint: this.hint,
          // tags: selectTags,
          answerExplanation: this.answerExplanation,
          questionOptions: this.getOptions(),
          mtfOptions: mtfOptions,
          topic: this.topic,
          strand: this.strand,
          subStrand: this.subStrand,
          grade: this.grade,
          authoredBy: this.authoredBy,
          application: this.product,
          hrisUniqueRole: this.selectedHrisRoles,
          isCaseSensitive: this.isCaseSensitive === "Yes",
          languageOfQuestion: this.languageOfQuestion,
          groupName: this.groupName,
        };

        try {
          // Call the Bulk Upload API with a single-question array
          const response = await QuestionsController.createQuestion([
            questionsData,
          ]);

          if (response.status === 200 && response.data.records) {
            const uploadedRecord = response.data.records[0]; // Since we are sending only one question

            if (uploadedRecord.status === "Uploaded Successfully!") {
              this.isCreatingQuestion = false;
              this.successDialog = true;
              this.createQuestionDialog = false;
              this.questionid = this.createdQuestionIdOf(uploadedRecord);
              this.successMessage = this.questionid
                ? `Question Id ${this.questionid} has been created successfully`
                : "New Question Created";
              // this.fetchQuestions();
            } else {
              this.isCreatingQuestion = false;
              this.errorDialog = true;
              this.errorMessage =
                uploadedRecord.error || "Failed to upload question.";
            }
          } else {
            this.isCreatingQuestion = false;
            this.errorDialog = true;
            this.errorMessage =
              "Bulk upload API did not return expected response.";
          }
        } catch (error) {
          console.error("Bulk Upload API Error:", error);
          this.isCreatingQuestion = false;
          this.errorDialog = true;
          this.errorMessage = "An error occurred while uploading the question.";
        }
      }
    },

    getTextWithoutHTMLTags(text) {
      // Strip HTML tags from the text
      return text.replace(/<[^>]*>?/gm, "");
    },
    editOption(index) {
      console.log("Edit Option Called");
      console.log("Checkpoint 1:", this.options);
      this.editedOptionIndex = index;
      this.optionTextFieldDialog = true;
      this.editedCkeditorValue = "";
      setTimeout(() => {
        this.editedCkeditorValue =
          this.options[this.editedOptionIndex].optionValue;

        // This code will execute after a 1 second delay
        //this.options[this.editedOptionIndex] = this.options[index];
      }, 1000);
      console.log("Checkpoint 2:", this.options);
    },
    editAnswer(index) {
      console.log("Edit Option Called");
      console.log("Checkpoint 1:", this.options);
      this.editedAnswerIndex = index;
      this.answerTextFieldDialog = true;
      setTimeout(() => {
        this.editedCkeditorValue =
          this.answers[this.editedAnswerIndex].optionValue;

        // This code will execute after a 1 second delay
        //this.options[this.editedOptionIndex] = this.options[index];
      }, 1000);
      console.log("Checkpoint 2:", this.options);
    },

    async deleteQuestion(items) {
      await QuestionsController.deleteQuestion();
      //console.log(response.data);
    },
    clearFilter() {
      // this.appliedFilter = false;
      this.selectedQuestionTypeFilter = [];
      this.selectedLevelFilter = [];
      this.selectedGradeFilter = [];
      this.selecteddifficultyLevelFilter = [];
      this.selectedcomplexityLevelFilter = [];
      this.selectedknowlewdgeLevelFilter = [];
      this.selectedbloomsTaxonomyLevelFilter = [];
      this.selectedskillsFilter = [];
      this.selectedsubjectsFilter = [];
      this.selectedReportedQuestionsFilter = null;
      this.sendSelectedReportedQuestionsFilter = [];
      this.hasEquationFilter = [];
      this.selectedQuestionAssetUrlFilter = [];
      this.filterVal = "";
      this.customStartDate = null;
      this.customEndDate = null;
      // this.filterDialog = false;
      this.filterData = false;
      this.filterCount = 0;
      this.selectedSort = "questionAsc";
      this.sortCol = "sanitizedQuestionStatement";
      this.sortOrder = "asc";
      this.filterDialog = false;
      this.getNewQuestionsData();
      // this.filterQuestions(
      //   this.selectedQuestionTypeFilter,
      //   this.selectedLevelFilter,
      //   this.selectedGradeFilter,
      //   this.selecteddifficultyLevelFilter,
      //   this.selectedcomplexityLevelFilter,
      //   this.selectedknowlewdgeLevelFilter,
      //   this.selectedbloomsTaxonomyLevelFilter,
      //   this.selectedskillsFilter,
      //   this.selectedsubjectsFilter,
      //   this.selectedReportedQuestionsFilter
      // );
      // Add method to reset the combinations map when starting new validation
      this.resetQuestionIdValidation();
    },
    async filterQuestions(
      questionTypeIds,
      levelIds,
      gradeIds,
      diffLevelIds,
      complexityLevelIds,
      knowledgeLevelIds,
      bloomsTaxonomy,
      skillIds,
      subjectIds,
      reportQuestions,
    ) {
      console.log("filter function call", reportQuestions, subjectIds);
      let questionIds = "";
      let levelId = "";
      let gradeId = "";
      let diffLevelId = "";
      let compLevelIds = "";
      let knowLevelIds = "";
      let bloomsLevelIds = "";
      let skillsId = "";
      let subIds = "";
      let reportedQIds = "";

      questionIds = questionTypeIds.join(" ");
      levelId = levelIds.join(" ");
      gradeId = gradeIds.join(" ");
      diffLevelId = diffLevelIds.join(" ");
      compLevelIds = complexityLevelIds.join(" ");
      knowLevelIds = knowledgeLevelIds.join(" ");
      bloomsLevelIds = bloomsTaxonomy.join(" ");
      skillsId = skillIds.join(" ");
      subIds = subjectIds.join(" ");
      reportedQIds = reportQuestions;

      this.selectedSort = "questionAsc";
      this.sortCol = "sanitizedQuestionStatement";
      this.sortOrder = "asc";
      this.filterVal =
        questionIds +
        levelId +
        gradeId +
        diffLevelId +
        compLevelIds +
        knowLevelIds +
        bloomsLevelIds +
        skillsId +
        subIds +
        reportedQIds;

      await this.algoliaIndex
        .search(this.filterVal, {
          hitsPerPage: this.pageSize,
          page: this.page - 1,
        })
        .then(({ hits }) => {
          console.log(hits);
          this.tableData = hits;
        });
      const { nbHits } = await this.algoliaIndex.search(this.filterVal, {
        hitsPerPage: 0,
      });
      this.count = nbHits;
      console.log("filter responce", this.filterVal);
      // this.filterDialog = false;
      this.filterData = true;
    },

    async getQuestionsFromAlgolia() {
      console.log("PageSize:", this.pageSize, " Page:", this.page);
      if (this.filterVal == "") {
        if (this.search == null) {
          // Check if `search` is null
          await this.algoliaIndex
            .search("", {
              hitsPerPage: this.pageSize,
              page: this.page - 1,
            })
            .then(({ hits }) => {
              console.log(hits);
              this.tableData = hits;
            });
        } else {
          await this.algoliaIndex
            .search(this.search, {
              hitsPerPage: this.pageSize,
              page: this.page - 1,
            })
            .then(({ hits }) => {
              console.log(hits);
              this.tableData = hits;
            });
        }
      } else {
        if (this.search == null) {
          // Check if `search` is null
          let values = this.filterVal;
          await this.algoliaIndex
            .search(values, {
              hitsPerPage: this.pageSize,
              page: this.page - 1,
            })
            .then(({ hits }) => {
              console.log(hits);
              this.tableData = hits;
            });
        } else {
          let values = this.filterVal + this.search;
          await this.algoliaIndex
            .search(values, {
              hitsPerPage: this.pageSize,
              page: this.page - 1,
            })
            .then(({ hits }) => {
              console.log(hits);
              this.tableData = hits;
            });
        }
      }
    },

    getFilterCount() {
      if (!this.isCustomDate) {
        this.getDateRange();
      }
      this.filterCount = 0;

      let combinedFilters = [
        this.selectedQuestionTypeFilter,
        this.selectedLevelFilter,
        this.selectedGradeFilter,
        this.selecteddifficultyLevelFilter,
        this.selectedcomplexityLevelFilter,
        this.selectedknowlewdgeLevelFilter,
        this.selectedbloomsTaxonomyLevelFilter,
        this.selectedskillsFilter,
        this.selectedsubjectsFilter,
        this.sendSelectedReportedQuestionsFilter,
        this.hasEquationFilter,
        this.selectedQuestionAssetUrlFilter,
      ];
      this.filterCount = combinedFilters.reduce((accumulator, current) => {
        if (typeof current === "string" && current !== "") {
          return accumulator + 1;
        }
        return current?.length > 0 ? accumulator + 1 : accumulator;
      }, 0);

      if (!this.isObjectEmpty(this.sendSelectedReportedQuestionsFilter)) {
        this.filterCount++;
      }

      this.getNewQuestionsData();
    },
    isObjectEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    csvFileToJSON(file) {
      var contents = [];
      this.bulkQuestionJsonData = [];
      this.bulkQuestionUploadResponse = [];
      this.removedQuestion = [];

      const requiredHeaders = [
        "application",
        "questionId",
        "skill",
        "setNumber",
        "level",
        "grade",
        "subject",
        "strand",
        "subStrand",
        "topic",
        "loCode1",
        "loCode2",
        "loCode3",
        "loCode4",
        "hrisUniqueRole",
        "markingType",
        "questionType",
        "parentId",
        "marksAllotted",
        "languageOfQuestion",
        "questionStatement",
        "questionAssetUrl",
        "questionAssetType",
        "optionKey1",
        "optionValue1",
        "optionScore1",
        "optionKey2",
        "optionValue2",
        "optionScore2",
        "optionKey3",
        "optionValue3",
        "optionScore3",
        "optionKey4",
        "optionValue4",
        "optionScore4",
        "optionKey5",
        "optionValue5",
        "optionScore5",
        "correctAnswer",
        "isCaseSensitive",
        "answerExplanation",
        "bloomsTaxonomy",
        "difficultyLevel",
        "complexityLevel",
        "hint",
        "proficiencyLevel",
        "authoredBy",
        "groupName",
        "customer",
      ];

      try {
        Papa.parse(file, {
          header: false,
          skipEmptyLines: true,
          complete: async (results) => {
            try {
              this.content = results;
              this.parsed = true;
              contents = this.content.data.filter((row) =>
                row.some((cell) => cell.trim() !== ""),
              );
              if (contents.length < 2) {
                const errorMessage =
                  "Please upload a file that contains at least one question. Empty files are not allowed.";
                this.downloadTextFile(errorMessage, "uploadReport.txt");
                return;
              }
              const headers = contents[0].map((header) =>
                header.replace("*", "").trim(),
              );
              const missingHeaders = requiredHeaders.filter(
                (reqHeader) => !headers.includes(reqHeader),
              );

              console.log("missingHeaders===>", missingHeaders);
              console.log("required Hr=eaders===>", requiredHeaders);
              if (missingHeaders.length > 0) {
                const missingHead =
                  "Following headers are missing:\n" +
                  missingHeaders.join("\n") +
                  "\n";
                this.downloadTextFile(missingHead, "uploadReport.txt");
                return;
              }

              const invalidHeaders = headers.filter(
                (header) => !requiredHeaders.includes(header),
              );
              console.log("required Hr=eaders===>", requiredHeaders);
              console.log("required Hr=eaders===>", headers);
              if (invalidHeaders.length > 0) {
                const invalidHead =
                  "Following headers are invalid:\n" +
                  invalidHeaders.join("\n") +
                  "\n";
                this.downloadTextFile(invalidHead, "uploadReport.txt");
                return;
              }

              var jsonData = [];
              var removedQuestion = [];
              var blankcell = false;

              for (var i = 1; i < contents.length; i++) {
                var rowData = {};
                var options = [];
                var cells = contents[i];
                let questionType = null;

                for (var j = 0; j < cells.length; j++) {
                  var skillIndex = headers.indexOf("skill");

                  const check = this.checkMatters(
                    headers[j],
                    cells[j],
                    cells[skillIndex],
                    headers,
                    cells,
                  );

                  if (!check || typeof check === "string") {
                    removedQuestion.includes(i) ? "" : removedQuestion.push(i);
                    this.skippedQuestion( i, headers[j], cells[j], check);
                    continue;
                  }

                  if (cells[j].trim().length === 0) {
                    if (!removedQuestion.includes(i)) removedQuestion.push(i);
                    this.skippedQuestion(i, headers[j], cells[j]);
                    continue;
                  }

                  if (
                    headers[j].includes("difficultyLevel") ||
                    headers[j].includes("complexityLevel") ||
                    headers[j].includes("bloomsTaxonomy")
                  ) {
                    rowData[headers[j]] = cells[j].toUpperCase();
                    continue;
                  }

                  if (headers[j].includes("grade")) {
                    rowData[headers[j]] =
                      cells[j].indexOf("Grade ") === -1 && cells[j] !== "NA"
                        ? `Grade ${cells[j]}`
                        : cells[j];
                    continue;
                  }

                  var key = headers[j];
                  var value = cells[j].trim();

                  if (key.startsWith("optionKey")) {
                    options.push({ optionKey: value });
                  } else if (key.startsWith("optionValue")) {
                    if (value.includes("https://drive.google.com/file/")) {
                      var found = value.match(/\/d\/([A-Za-z0-9_-]+)/);
                      if (found && found[1].length) {
                        value = `https://drive.google.com/uc?export=view&id=${found[1]}`;
                      }
                    }
                    if (options.length > 0) {
                      options[options.length - 1].optionValue = value;
                    }
                  } else if (key.startsWith("optionScore")) {
                    if (options.length > 0) {
                      options[options.length - 1].optionScore = value;
                    }
                  } else if (key === "customer") {
                    rowData.customer = value.toLowerCase();
                  } else if (key === "questionAssetType") {
                    rowData.questionAssetType = value.toLowerCase();
                  } else {
                    rowData[key] =
                      key === "subject"
                        ? cells[j].split(",").map((item) => item.trim())
                        : value;
                  }

                  if (headers[j]?.includes("questionType")) {
                    questionType = cells[j];
                  }

                  if (questionType === "TRUE_FALSE") {
                    options = [
                      { optionKey: "A", optionValue: "TRUE" },
                      { optionKey: "B", optionValue: "FALSE" },
                    ];
                  }

                  rowData["questionOptions"] = options;
                }
                if (rowData.markingType?.toLowerCase() === "likert marking") {
                  if (
                    rowData.marksAllotted != "NA" ||
                    rowData.correctAnswer != "NA"
                  ) {
                    if (!removedQuestion.includes(i)) {
                      removedQuestion.push(i);
                      this.skippedQuestion(
                        i,
                        "markingType",
                        "Marks allotted or Correct Answer should be NA",
                      );
                    }
                  }
                  rowData.marksAllotted = "0";
                  rowData.correctAnswer = "NA";

                  // if (rowData.questionType !== "SINGLE_CHOICE") {
                  //   if (!removedQuestion.includes(i)) removedQuestion.push(i);
                  //     this.skippedQuestion(i, "questionType", 'Likert-type questions must be configured as SINGLE_CHOICE');
                  //     continue;
                  // }

                  const isValidLikertOptions = options.every(
                    (opt) =>
                      opt.optionKey &&
                      opt.optionValue &&
                      !isNaN(Number(opt.optionScore)),
                  );

                  if (!isValidLikertOptions) {
                    if (!removedQuestion.includes(i)) removedQuestion.push(i);
                    this.skippedQuestion(
                      i,
                      "questionOptions",
                      "For Likert marking type, each option must have a valid numeric optionScore — questionOptions has an invalid or missing score (must not be empty, 'NA', or non-numeric).",
                    );
                    continue;
                  }

                  // Valid likert marking options – attach full structure
                  rowData["questionOptions"] = options.map((opt) => ({
                    optionKey: opt.optionKey,
                    optionValue: opt.optionValue,
                    optionScore: opt.optionScore,
                  }));
                }
                if (
                  rowData.markingType?.toLowerCase() === "regular marking" &&
                  !PARENT_QUESTION_TYPES.has(rowData.questionType)
                ) {
                  if (
                    rowData["marksAllotted"] === "NA" ||
                    rowData["marksAllotted"] === "" ||
                    rowData["correctAnswer"] === "NA" ||
                    rowData["correctAnswer"] === ""
                  ) {
                    if (!removedQuestion.includes(i)) {
                      removedQuestion.push(i);

                      this.skippedQuestion(
                        i,
                        "markingType",
                        " Since this question is marked for Regular marking type, both Marks Allotted and Correct Answer fields must have valid values provided.",
                      );
                    }
                  }
                  const isValidRegularOptions = options.every(
                    (opt) =>
                      opt.optionKey &&
                      opt.optionValue &&
                      opt.optionScore === "NA",
                  );

                  if (!isValidRegularOptions) {
                    if (!removedQuestion.includes(i)) removedQuestion.push(i);
                    this.skippedQuestion(
                      i,
                      "questionOptions",
                      "For Regular marking type, the optionScore for options should be set to 'NA'.",
                    );
                    continue;
                  }
                  rowData["questionOptions"] = options.map((opt) => ({
                    optionKey: opt.optionKey,
                    optionValue: opt.optionValue,
                    optionScore: "NA",
                  }));
                }
                if (rowData.questionType === "FILL_IN_THE_BLANKS") {
                  rowData.isCaseSensitive =
                    (rowData.isCaseSensitive ?? "")
                      .toString()
                      .trim()
                      .toLowerCase() === "yes";

                  if (
                    rowData.markingType?.toLowerCase() !== "regular marking"
                  ) {
                    if (!removedQuestion.includes(i)) removedQuestion.push(i);
                    this.skippedQuestion(
                      i,
                      "markingType",
                      "For FILL_IN_THE_BLANKS, markingType must be 'Regular Marking'.",
                    );
                  }

                  if (
                    this.isBlankMissing(
                      rowData.questionType,
                      rowData.questionStatement,
                    )
                  ) {
                    if (!removedQuestion.includes(i)) removedQuestion.push(i);
                    this.skippedQuestion(
                      i,
                      "questionStatement",
                      BLANK_PLACEHOLDER_ERROR,
                    );
                  }

                  const fillInTheBlanksOptionFields = [
                    "optionKey1",
                    "optionValue1",
                    "optionScore1",
                    "optionKey2",
                    "optionValue2",
                    "optionScore2",
                    "optionKey3",
                    "optionValue3",
                    "optionScore3",
                    "optionKey4",
                    "optionValue4",
                    "optionScore4",
                    "optionKey5",
                    "optionValue5",
                    "optionScore5",
                  ];

                  const invalidFillInTheBlanksOptionFields =
                    fillInTheBlanksOptionFields.filter((field) => {
                      const fieldIndex = headers.indexOf(field);
                      const fieldValue =
                        fieldIndex > -1 ? (cells[fieldIndex] ?? "").trim() : "";
                      return fieldValue.toUpperCase() !== "NA";
                    });

                  if (invalidFillInTheBlanksOptionFields.length > 0) {
                    if (!removedQuestion.includes(i)) removedQuestion.push(i);
                    this.skippedQuestion(
                      i,
                      "questionOptions",
                      `For FILL_IN_THE_BLANKS, these fields must be 'NA': ${invalidFillInTheBlanksOptionFields.join(
                        ", ",
                      )}`,
                    );
                  }
                }

                if (rowData.skill?.toLowerCase() === "psychometry") {
                  if (
                    !rowData.setNumber ||
                    rowData.setNumber.trim().toUpperCase() === "NA"
                  ) {
                    if (!removedQuestion.includes(i)) removedQuestion.push(i);
                    this.skippedQuestion(
                      i,
                      "setNumber",
                      "Missing or NA setNumber for psychometry skill",
                    );
                    continue;
                  }
                }
                if (i !== 0 && !removedQuestion.includes(i)) {
                  rowData["sanitizedQuestionStatement"] =
                    this.sanitizedQuestion(rowData["questionStatement"]);
                  rowData["_csvRowIndex"] = i;
                  jsonData.push(rowData);
                }
              }

              // Validate size-limited asset files (audio/video, 100 MB limit)
              const assetSizeResults = await Promise.all(
                jsonData.map(async (question) => {
                  const assetType = question.questionAssetType;
                  if ( !SIZE_LIMITED_ASSET_TYPES.has(assetType) || !question.questionAssetUrl || question.questionAssetUrl === "NA" ) {
                    return null;
                  }
                  try {
                    const assetUrl = question.questionAssetUrl;
                    let size = 0;
                    if (assetUrl.startsWith("https://drive.google.com/")) {
                      let fileId = null;
                      if (assetUrl.indexOf("&id=") > -1) {
                        fileId = assetUrl.split("&id=").pop();
                      } else {
                        const match = assetUrl.match(/\/file\/d\/([^/?]+)/);
                        if (match) fileId = match[1];
                      }
                      if (fileId) {
                        const sizeRes = await QuestionsController.getDriveFileSize(fileId);
                        size = parseInt(sizeRes?.data?.size || "0", 10);
                      }
                    } else {
                      const metaUrl = new URL(assetUrl);
                      metaUrl.searchParams.delete("alt");
                      const metaRes = await fetch(metaUrl.toString());
                      const meta = await metaRes.json();
                      size = parseInt(meta.size || "0", 10);
                    }
                    if (size > MAX_ASSET_SIZE_BYTES) {
                      return { rowIndex: question._csvRowIndex, assetType };
                    }
                  } catch (err) {
                    console.error(`${assetType} size check error:`, err);
                  }
                  return null;
                }),
              );
              const oversizedAssets = assetSizeResults.filter((r) => r !== null);
              if (oversizedAssets.length > 0) {
                const oversizedRows = new Set( oversizedAssets.map((asset) => asset.rowIndex));
                oversizedAssets.forEach(({ rowIndex, assetType }) => {
                  removedQuestion.push(rowIndex);
                  this.skippedQuestion(
                    rowIndex,
                    "questionAssetUrl",
                    `${ASSET_TYPE_LABELS[assetType] ?? "Asset"} file exceeds the 100 MB size limit`,
                  );
                });
                jsonData = jsonData.filter((q) => !oversizedRows.has(q._csvRowIndex));
              }
              jsonData.forEach((q) => delete q._csvRowIndex);

              const skippedParentIds = this.parentIdsOfSkippedRows(headers, contents, removedQuestion);

              jsonData = this.consolidateSubQuestions(jsonData, skippedParentIds);

              var msg = `Question No. ${removedQuestion.join(
                ",",
              )} Will not upload due to blank cell or Wrong Entry`;
              if (this.removedQuestion.length !== 0) {
                this.downloadTextFile(
                  this.removedQuestion.join("\n"),
                  "uploadReport.txt",
                );
              }
              this.bulkQuestionJsonData = jsonData;
              var index = 2;

              if (!blankcell) {
                try {
                  this.bulkQuestionJsonData.forEach(async (question) => {
                    if (question.questionType == "MATCH_THE_FOLLOWING") {
                      question.mtfOptions = this.prepareOptions(
                        question.correctAnswer,
                      );
                    }
                  });
                  const response = await QuestionsController.createQuestion(
                    this.bulkQuestionJsonData,
                  );

                  if (response.status === 200 && response.data) {
                    const { records } = response.data;

                    this.bulkQuestionUploadResponse = new Array(
                      jsonData.length,
                    ).fill(null);

                    // Separate success and failed records while maintaining the original index
                    const successRecords = [];
                    const failedRecords = [];

                    records.forEach((record) => {
                      this.bulkQuestionUploadResponse[record.index - 1] = {
                        questionIndex: record.index,
                        status: record.status,
                        error: record.error || "",
                      };

                      if (record.status === "Uploaded Successfully!") {
                        successRecords.push(record);
                      } else {
                        failedRecords.push(record);
                      }
                    });

                    // If there are failed records, generate a report file
                    if (failedRecords.length > 0) {
                      const failedReport = failedRecords
                        .map(
                          (record) =>
                            `Question No. ${record.index} - ${record.error}`,
                        )
                        .join("\n");

                      this.downloadTextFile(
                        failedReport,
                        "failedUploadReport.txt",
                      );
                    }
                  } else {
                    // In case of complete failure
                    this.bulkQuestionUploadResponse = jsonData.map(
                      (_, index) => ({
                        questionIndex: index + 1, // Start from 1
                        status: "Upload Failed!",
                      }),
                    );
                  }
                } catch (error) {
                  console.error("Bulk Upload Error:", error);
                  this.bulkQuestionUploadResponse = jsonData.map(
                    (_, index) => ({
                      questionIndex: index + 1, // Start from 1
                      status: "Upload Failed!",
                    }),
                  );
                }
              }
            } catch (e) {
              console.error(e);
            }
          },
        });
      } catch (e) {
        console.error(e);
      }
    },

    prepareOptions(correctAnswer) {
      const mtfOptions = [];
      const entries = correctAnswer.split(", ");

      // Extract all countries and cities into arrays
      const countries = entries.map((entry) => entry.split(":")[0]);
      const cities = entries.map((entry) => entry.split(":")[1]);

      // Shuffle the cities array
      const shuffledCities = cities.sort(() => Math.random() - 0.5);

      // Create the options with key-value pairs and index
      countries.forEach((country, index) => {
        mtfOptions.push({
          key: country,
          value: shuffledCities[index],
        });
      });

      return mtfOptions;
    },

    closeUploadingQuestionsDialog() {
      this.uploadingQuestionsDialog = false;
      window.location.reload();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      console.log(file);
      if (file) {
        this.csvFileToJSON(file);
        this.uploadingQuestionsDialog = true;
      }
    },
    async resolveDriveUrl(url) {
      if (!url || !url.startsWith('https://drive.google.com/')) return url;
      let fileId = null;
      if (url.indexOf('&id=') > -1) {
        fileId = url.split('&id=').pop();
      } else {
        const match = url.match(/\/file\/d\/([^/?]+)/);
        if (match) fileId = match[1];
      }
      if (!fileId) return url;
      try {
        const response = await QuestionsController.doFetchFileContentFromDriveUrl(fileId);
        if (response.status === 200) {
          return window.URL.createObjectURL(new Blob([response.data]));
        }
      } catch (e) {
        console.error('Error resolving Drive URL:', e);
      }
      return url;
    },
    resolveQuestionAssetUrl: async function () {
      const url = this.questionAssetUrl;
      if (this.questionAssetUrlForPreview == IMAGE_ALT_SRC) {
        const resolved = await this.resolveDriveUrl(url);
        if (resolved !== url) {
          this.questionAssetUrlForPreview = resolved;
        } else if (url !== this.questionAssetUrlForPreview) {
          this.questionAssetUrlForPreview = url;
        }
      }
    },
    resolveQuestionOptionUrl: async function (url) {
      const optionIndex = this.options.findIndex(
        ({ optionValue }) => optionValue === url,
      );
      if (optionIndex === -1) return;
      const resolved = await this.resolveDriveUrl(url);
      if (resolved !== url) {
        this.options[optionIndex].optionValue = resolved;
      }
    },
    selectSortOption(sortOption) {
      this.selectedSort = sortOption;
      switch (sortOption) {
        case "questionAsc":
          this.sortCol = "sanitizedQuestionStatement";
          this.sortOrder = "asc";
          break;
        case "questionDesc":
          this.sortCol = "sanitizedQuestionStatement";
          this.sortOrder = "desc";
          break;
        case "dateNewest":
          this.sortCol = "createdOn";
          this.sortOrder = "desc";
          break;
        case "dateOldest":
          this.sortCol = "createdOn";
          this.sortOrder = "asc";
          break;
        default:
          this.selectedSort = "questionAsc";
          this.sortCol = "sanitizedQuestionStatement";
          this.sortOrder = "asc";
      }
      this.dataTableOptions.page = 1;
      this.getNewQuestionsData();
    },
    updateUrlParams() {
      const query = {};

      if (this.search) {
        query.search = this.search;
      }
      this.$router
        .replace({
          query: query,
        })
        .catch(() => {});
    },
    // Add method to reset the combinations map when starting new validation
    resetQuestionIdValidation() {
      this.questionIdLanguageCombos.clear();
    },
    validateQuestionId(value) {
      if (!this.product || !value) {
        this.questionIdError = "";
        return true;
      }

      const prefix = this.product; // Keep product name as-is
      const pattern = new RegExp(`^${prefix}_(\\d+|[a-zA-Z]\\d+)$`);

      if (!pattern.test(value)) {
        this.questionIdError = `Question ID must start with ${prefix}_`;
        return false;
      }

      this.questionIdError = "";
      return true;
    },

    sanitizedQuestion(statement) {
      const htmlEntityMap = {
        "&nbsp;": "",
        "&lt;": "<",
        "&gt;": ">",
        "&amp;": "&",
        "&quot;": '"',
        "&apos;": "'",
        "&cent;": "¢",
        "&pound;": "£",
        "&yen;": "¥",
        "&euro;": "€",
        "&copy;": "©",
        "&reg;": "®",
        "&times;": "×",
        "&divide;": "÷",
        "&plus;": "+",
        "&minus;": "−",
        "&equals;": "=",
        "&ne;": "≠",
        "&le;": "≤",
        "&ge;": "≥",
        "&harr;": "<->",
        "&#39;": "'",
        "&sup": "^",
      };
      const decodeHtmlEntities = (str) => {
        return str.replace(
          /&[a-zA-Z0-9#]+;/g,
          (entity) => htmlEntityMap[entity] || entity,
        );
      };
      if (!statement) {
        console.log("statement", statement);
        return "";
      }

      // Replace MathML fractions with numerator/denominator notation
      statement = statement.replace(
        /<mfrac>\s*<mrow>\s*<mo>(.*?)<\/mo>\s*<mn>(.*?)<\/mn>\s*<\/mrow>\s*<mn>(.*?)<\/mn>\s*<\/mfrac>/g,
        "($1$2)/$3",
      );
      statement = statement.replace(
        /<mfrac>\s*<mn>(.*?)<\/mn>\s*<mn>(.*?)<\/mn>\s*<\/mfrac>/g,
        "$1/$2",
      );

      // Replace mathematical operators and clean up tags
      statement = statement
        .replace(/<mo>&#215;<\/mo>/g, "×") // Multiplication
        .replace(/<mo>&#160;<\/mo>/g, " ") // Non-breaking space
        .replace(/<mo>(.*?)<\/mo>/g, "$1") // General operators
        .replace(/<mfenced>.*?<mrow>(.*?)<\/mrow>.*?<\/mfenced>/g, "($1)") // Fenced structures
        .replace(/<[^>]*>/g, "") // Remove all HTML tags
        .replace(/\n/g, " ") // Remove newlines
        .replace(/&nbsp;/g, " ") // Non-breaking spaces
        .trim(); // Trim whitespace

      // Decode HTML entities
      statement = decodeHtmlEntities(statement);

      return statement;
    },
    incrementOptionScore(index) {
      const score = this.options[index].optionScore || 0;
      if (score < 10) this.$set(this.options[index], 'optionScore', score + 1);
    },
    decrementOptionScore(index) {
      const score = this.options[index].optionScore || 0;
      if (score > 0) this.$set(this.options[index], 'optionScore', score - 1);
    },
    openOptionScoreDialog(index) {
      this.optionScoreDialog = true;
      this.selectedOptionIndex = index;
      this.optionScoreInput = this.options[index].optionScore;
    },
    saveOptionScore() {
      const score = Number(this.optionScoreInput);
      this.options[this.selectedOptionIndex].optionScore =
        this.markingType === 'Likert Marking' ? Math.min(score, 10) : score;
      this.closeOptionScoreDialog();
    },
    closeOptionScoreDialog() {
      this.optionScoreDialog = false;
    },
    handleMarkingTypeChange() {
      this.options = this.options.map(({ optionScore, ...rest }) => ({
        ...rest,
        optionScore: 0,
      }));
      this.correctAnswerScore = 0;
    },
    preventNonNumericInput(event) {
      const charCode = event.keyCode || event.which;
      const charStr = String.fromCharCode(charCode);

      // Prevent entering "." or any non-numeric characters
      if (!/^[1-9]+$/.test(charStr)) {
        event.preventDefault();
      }
    },
    countWords(html) {
      const text = String(html || '')
          .replace(/<[^>]*>/g, ' ')
          .replace(/&nbsp;/g, ' ')
          .trim();
      return text ? text.split(/\s+/).length : 0;
    },
  },
  created() {
    // this.getNewQuestionsData();
    this.getLO();
    this.getSubjects();
    this.getSkills();
    this.getLevels();
    this.getGrades();
    this.getAudienceRoles();
    this.getAudienceRoleGroups();
    this.debouncedSearch = debounce(this.getNewQuestionsData, 500);
  },
  unmounted() {
    this.debouncedSearch.cancel();
  },
  beforeRouteUpdate(to, from, next) {
    this.search = to.query.search || "";
    next();
  },
};
</script>
<style scoped>
.v-list-item__content {
  min-height: 64px;
}
.asset-preview-video {
  display: block;
  max-width: 100%;
  max-height: 60vh;
  border-radius: 4px;
}

.qpad {
  padding-top: 80px !important;
}
.expansion-panel-card {
  /* border: 1px solid #d9dee8; */
  border-radius: 10px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08) !important;
}

.expansion-panel-card-header {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.qb-container ::v-deep .mdi-format-textbox {
  font-size: 24px !important;
}
.upload-image {
  width: 24px !important;
}
.options-score-dialog >>> .v-overlay__scrim {
  z-index: 2100 !important; /* higher than typical dialog scrim */
}
.options-score-dialog >>> .v-dialog {
  z-index: 2200 !important; /* higher than typical dialog */
}
.likert-score-wrapper {
  gap: 4px;
}

.likert-score-label {
  font-size: 12px;
  font-weight: 500;
  color: #4a4a4a;
  white-space: nowrap;
}

.likert-score-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d9dee8;
  border-radius: 8px;
  padding: 2px 6px;
  min-width: 80px;
}

.likert-score-value {
  font-size: 14px;
  font-weight: 600;
  color: #4a4a4a;
  flex: 1;
}

.likert-score-arrows .v-btn {
  width: 16px !important;
  height: 16px !important;
}

.likert-score-arrows .v-icon {
  font-size: 14px !important;
}

.options-icon {
  font-size: 24px !important;
}
.options-btn {
  height: 24px !important;
  width: 24px !important;
}
.options-attach-img {
  width: 64px;
}
.question-history-layout {
  display: flex;
  gap: 24px;
  height: calc(100vh - 100px);
  padding-bottom: 16px;
  overflow: hidden;
  box-sizing: border-box;
}

.question-history-section {
  min-height: 0;
  height: 100%;
  border-radius: 16px;
}

.question-history-section-primary {
  display: flex;
  flex: 2.15;
  min-width: 0;
  border: 1px solid #d9dee8;
  background: #fff;
  overflow: hidden;
}

.question-history-section-secondary {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.question-history-side-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.question-history-side-content::-webkit-scrollbar {
  display: none;
}

.question-history-card {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  color: #2f2f2f;
}

.question-history-card-header {
  flex-shrink: 0;
}

.question-history-card-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 16px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.question-history-card-body::-webkit-scrollbar {
  display: none;
}

.question-history-field-block {
  padding: 14px 16px;
  border-radius: 10px;
  background: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.question-history-field-block--changed {
  background: #fde8de;
}

.question-history-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
}

.question-history-match-header,
.question-history-match-row {
  display: flex;
  gap: 24px;
}

.question-history-match-header > p,
.question-history-match-row > p {
  flex: 1;
}

.question-history-match-row {
  padding-bottom: 8px;
}

.question-history-section-title,
.question-history-side-title {
  font-size: 16px;
  font-weight: 700;
  color: #2f2f2f;
}

.question-history-field-label,
.question-history-highlight-label,
.question-history-side-subtitle {
  font-size: 12px;
  font-weight: 400;
  color: #7d7d7d;
}

.question-history-side-header {
  padding-right: 8px;
}

.question-history-expansion-panel {
  border-radius: 10px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08) !important;
}

.question-history-expansion-header {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.question-history-expansion-panel:not(:first-child) {
  margin-top: 16px;
}

.question-history-loading-state {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #4a4a4a;
}

.question-history-timeline {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.question-history-timeline-group {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.question-history-timeline-date-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.question-history-timeline-date-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.question-history-timeline-dot {
  width: 18px;
  height: 18px;
  border: 3px solid #5b1fe8;
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
}

.question-history-timeline-date {
  font-size: 14px;
  font-weight: 500;
  color: #2f2f2f;
}

.question-history-timeline-toggle {
  flex-shrink: 0;
  color: #7d7d7d;
}

.question-history-timeline-items {
  margin-left: 8px;
  padding-left: 20px;
  border-left: 2px solid #5b1fe8;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.question-history-timeline-group:last-child .question-history-timeline-items {
  border-left: none;
}

.question-history-timeline-card {
  position: relative;
  border: 1px solid #d9dee8;
  border-radius: 14px;
  background: #fff;
  padding: 14px 16px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
}

.question-history-timeline-card-active {
  border-color: #5b1fe8;
  box-shadow: 0 0 0 1px rgba(91, 31, 232, 0.16);
}

.question-history-timeline-card-current .question-history-timeline-card-top {
  padding-right: 88px;
}

.question-history-timeline-card-top,
.question-history-timeline-card-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.question-history-timeline-version {
  font-size: 16px;
  font-weight: 700;
  color: #2f2f2f;
}

.question-history-timeline-inline-meta {
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #4a4a4a;
}

.question-history-comment-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  cursor: default;
}

.question-history-timeline-icon {
  color: #707070;
}

.question-history-current-badge {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 78px;
  padding: 7px 14px;
  border-radius: 0 14px 0 14px;
  background: #e6e0ff;
  font-size: 12px;
  font-weight: 600;
  color: #5b1fe8;
  white-space: nowrap;
  text-align: center;
  line-height: 18px;
}

.question-history-timeline-comment,
.question-history-empty-state {
  font-size: 13px;
  line-height: 20px;
  color: #6a6a6a;
}

.question-history-empty-state {
  border: 1px dashed #d9dee8;
  border-radius: 14px;
  padding: 16px;
}

.question-history-field-value,
.question-history-highlight-value,
.question-history-option-value {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: #4a4a4a;
}

.question-history-option-value--correct {
  color: #2e7d32;
}

.question-history-highlight {
  padding: 14px 16px;
  border-radius: 10px;
  background: #fde8de;
}

.question-history-summary-grid,
.question-history-meta-grid,
.question-history-options-grid {
  display: grid;
  gap: 24px;
}

.question-history-summary-grid,
.question-history-meta-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.question-history-options-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.question-history-option-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.question-history-option-index {
  min-width: 18px;
  font-size: 14px;
  font-weight: 500;
  color: #4a4a4a;
}

@media (max-width: 960px) {
  .question-history-layout,
  .question-history-summary-grid,
  .question-history-meta-grid,
  .question-history-options-grid {
    grid-template-columns: 1fr;
    flex-direction: column;
  }

  .question-history-layout {
    height: auto;
    overflow: visible;
  }

  .question-history-section {
    height: auto;
  }

  .question-history-section-primary,
  .question-history-section-secondary {
    overflow: visible;
  }
}

/* ── Exam Mode ── */
.exam-mode-wrapper {
  display: flex;
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
}

.exam-mode-sidebar {
  width: 240px;
  min-width: 240px;
  background: #fff;
  border-right: 1px solid #e0e0e0;
  padding: 24px 16px;
  margin: 16px;
  border-radius: 8px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.graphik-regular {
  font-family: "GraphikRegular", sans-serif;
  font-weight: 400;
}

.exam-mode-sidebar-header {
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: #212121;
  margin-bottom: 16px;
}

.exam-mode-stats-card {
  padding: 16px;
  border-radius: 8px !important;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exam-mode-placeholder-text {
  font-size: 16px;
  color: #212121;
  text-align: center;
  margin: 0;
  /* background: #212121; */

}

.exam-mode-list-card {
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}

.exam-mode-questions-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.exam-mode-question-num {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #616161;
}

.exam-mode-question-num--active {
  background-color: #3F41D1;
  color: #fff;
  border-color: #3F41D1;
}

.exam-mode-content {
  flex: 1;
  padding: 28px 36px;
  margin: 16px 16px 16px 0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.exam-mode-close-btn {
  position: absolute !important;
  top: 12px;
  right: 12px;
}

.exam-mode-topbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 14px;
}

.exam-mode-timer-unit {
  position: relative;
  display: inline-flex;
}

.exam-mode-timer-label {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 0 4px;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: capitalize;
  color: #3F41D1;
  z-index: 1;
  white-space: nowrap;
}

.exam-mode-timer-box {
  min-width: 48px;
  height: 48px;
  padding: 6px 14px;
  border: 1.5px solid #3F41D1;
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.38) 0%, rgba(207, 213, 241, 0.6) 100%);
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  color: #212121;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exam-mode-timer-colon {
  font-size: 34px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  color: #A3A3A3;
  margin: 0 4px;
}

.exam-mode-time-left-text {
  font-size: 14px;
  color: #616161;
}

.exam-mode-submit-btn {
  font-size: 14px;
  background-color: #E697AB !important;
  letter-spacing: 1px;
}

.exam-mode-progress {
  border-radius: 6px !important;
  margin-bottom: 16px;
  color: #E0E0E0;
}

.exam-mode-question-meta {
  margin-bottom: 12px;
}

.exam-mode-question-counter {
  font-size: 14px;
  font-weight: 400;
  color: #212121;
  font-weight: 500;
}

.exam-mode-lang-chip {
  height: 36px;
  opacity: 1;
  padding: 0 24px !important;
  gap: 10px;
  border-radius: 24px !important;
  border: 0.5px solid #3F41D1 !important;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 2%;
  text-align: center;
  justify-content: center;
  color: #3F41D1 !important;
  background: #E1E8F5 !important;
}

.exam-mode-lang-chip ::v-deep .v-chip__content {
  justify-content: center;
}

.exam-mode-question-card {
  padding: 20px;
  border-radius: 8px !important;
  margin-bottom: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #F7F7F7;

}

.exam-mode-subquestion-box {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.exam-mode-subquestion-box .exam-mode-question-card-footer {
  margin-top: auto;
  padding-top: 12px;
}

.exam-mode-question-content {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 12px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
  flex-direction: column;
}

.exam-mode-question-content::-webkit-scrollbar {
  display: none;
}

.exam-mode-question-text ::v-deep strong,
.exam-mode-question-text ::v-deep p {
  /* font-family: "GraphikMedium", sans-serif !important;
  font-weight: 500 !important; */
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  color: #212121;
}

.exam-mode-image-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80px;
}

.exam-mode-image {
  display: block;
  max-width: 100%;
  border-radius: 8px;
}

.exam-mode-media {
  display: block;
  width: 100%;
  max-width: 360px;
  border-radius: 8px;
}

.exam-mode-question-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exam-mode-expand-link {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  color: #3F41D1;
  cursor: pointer;
  letter-spacing: 0.5px;
}

.exam-mode-options-wrapper {
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.exam-mode-options-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
}

.exam-mode-options-grid > *:last-child:nth-child(odd) {
  grid-column: 1 / -1;
  justify-self: center;
  width: 50%;
}

.exam-mode-options-grid--image {
  grid-template-columns: repeat(4, 1fr);
}

.exam-mode-option-card {
  padding: 14px 16px;
  border-radius: 0 !important;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
  min-width: 0;
  overflow: hidden;
}

.exam-mode-option-card ::v-deep .v-radio,
.exam-mode-option-card ::v-deep .v-input--checkbox {
  margin: 0;
  pointer-events: none;
  min-width: 0;
}

.exam-mode-option-card ::v-deep .v-label {
  min-width: 0;
  overflow: hidden;
  pointer-events: auto;
}

.exam-mode-option-card ::v-deep .v-input--selection-controls__input {
  margin-right: 10px;
  flex-shrink: 0;
}

.exam-mode-option-label {
  font-size: 16px;
  color: #212121;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  min-width: 0;
  max-width: 100%;
}

.exam-mode-question-text ::v-deep img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 8px 0;
}

.exam-mode-option-label ::v-deep img {
  max-width: 100%;
  max-height: 100px;
  object-fit: contain;
  display: block;
  margin: 4px 0;
}

.exam-mode-options-grid--image .exam-mode-option-label {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}

.exam-mode-fib-card {
  padding: 16px;
  border-radius: 8px !important;
  margin-bottom: 28px;
}

.exam-mode-expand-dialog {
  display: flex;
  flex-direction: column;
  background: #f5f6fa;
  overflow: hidden;
  height: 100vh;
}

.exam-mode-expand-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.exam-mode-expand-title {
  font-size: 16px;
  font-weight: 600;
  color: #212121;
}

.exam-mode-expand-body {
  flex: 1;
  overflow: hidden;
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.exam-mode-expand-body--passage {
  flex-direction: row;
  gap: 24px;
  overflow: hidden;
}

.exam-mode-expand-passage-pane {
  flex: 3 1 0%;
  min-width: 0;
  overflow-y: auto;
}

.exam-mode-expand-question-pane {
  flex: 7 1 0%;
  min-width: 0;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.exam-mode-expand-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 16px;
  flex-shrink: 0;
}

.exam-mode-mtf-card {
  padding: 16px;
  border-radius: 8px !important;
  margin-bottom: 28px;
}

.exam-mode-mtf-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 28px;
}

.exam-mode-mtf-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.exam-mode-mtf-item {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 14px 16px;
  font-size: 14px;
  color: #212121;
  background: #ffffff;
  text-align: center;
}

.exam-mode-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exam-mode-nav-btn {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.exam-mode-action-btn {
  /* font-family: "GraphikMedium", sans-serif !important; */
  font-size: 14px;
  /* font-weight: 500; */
  color: #3F41D1 !important;
  letter-spacing: 0%;
}
</style>
